/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  date: { input: any; output: any; }
  float8: { input: any; output: any; }
  time: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "language" */
export type Language = {
  __typename?: 'language';
  code: Scalars['String']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  participant_languages: Array<Participant_Language>;
  /** An aggregate relationship */
  participant_languages_aggregate: Participant_Language_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  user_languages: Array<User_Language>;
  /** An aggregate relationship */
  user_languages_aggregate: User_Language_Aggregate;
};


/** columns and relationships of "language" */
export type LanguageParticipant_LanguagesArgs = {
  distinct_on?: InputMaybe<Array<Participant_Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Language_Order_By>>;
  where?: InputMaybe<Participant_Language_Bool_Exp>;
};


/** columns and relationships of "language" */
export type LanguageParticipant_Languages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Language_Order_By>>;
  where?: InputMaybe<Participant_Language_Bool_Exp>;
};


/** columns and relationships of "language" */
export type LanguageUser_LanguagesArgs = {
  distinct_on?: InputMaybe<Array<User_Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Language_Order_By>>;
  where?: InputMaybe<User_Language_Bool_Exp>;
};


/** columns and relationships of "language" */
export type LanguageUser_Languages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Language_Order_By>>;
  where?: InputMaybe<User_Language_Bool_Exp>;
};

/** aggregated selection of "language" */
export type Language_Aggregate = {
  __typename?: 'language_aggregate';
  aggregate?: Maybe<Language_Aggregate_Fields>;
  nodes: Array<Language>;
};

/** aggregate fields of "language" */
export type Language_Aggregate_Fields = {
  __typename?: 'language_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Language_Max_Fields>;
  min?: Maybe<Language_Min_Fields>;
};


/** aggregate fields of "language" */
export type Language_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Language_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "language". All fields are combined with a logical 'AND'. */
export type Language_Bool_Exp = {
  _and?: InputMaybe<Array<Language_Bool_Exp>>;
  _not?: InputMaybe<Language_Bool_Exp>;
  _or?: InputMaybe<Array<Language_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  participant_languages?: InputMaybe<Participant_Language_Bool_Exp>;
  participant_languages_aggregate?: InputMaybe<Participant_Language_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_languages?: InputMaybe<User_Language_Bool_Exp>;
  user_languages_aggregate?: InputMaybe<User_Language_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "language" */
export enum Language_Constraint {
  /** unique or primary key constraint on columns "code" */
  LanguageIdKey = 'language_id_key',
  /** unique or primary key constraint on columns "code" */
  LanguagesPkey = 'languages_pkey'
}

/** input type for inserting data into table "language" */
export type Language_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  participant_languages?: InputMaybe<Participant_Language_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_languages?: InputMaybe<User_Language_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Language_Max_Fields = {
  __typename?: 'language_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Language_Min_Fields = {
  __typename?: 'language_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "language" */
export type Language_Mutation_Response = {
  __typename?: 'language_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Language>;
};

/** input type for inserting object relation for remote table "language" */
export type Language_Obj_Rel_Insert_Input = {
  data: Language_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Language_On_Conflict>;
};

/** on_conflict condition type for table "language" */
export type Language_On_Conflict = {
  constraint: Language_Constraint;
  update_columns?: Array<Language_Update_Column>;
  where?: InputMaybe<Language_Bool_Exp>;
};

/** Ordering options when selecting data from "language". */
export type Language_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  participant_languages_aggregate?: InputMaybe<Participant_Language_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_languages_aggregate?: InputMaybe<User_Language_Aggregate_Order_By>;
};

/** primary key columns input for table: language */
export type Language_Pk_Columns_Input = {
  code: Scalars['String']['input'];
};

/** select columns of table "language" */
export enum Language_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "language" */
export type Language_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "language" */
export type Language_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Language_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Language_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "language" */
export enum Language_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Language_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Language_Set_Input>;
  /** filter the rows which have to be updated */
  where: Language_Bool_Exp;
};

/** columns and relationships of "location" */
export type Location = {
  __typename?: 'location';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['uuid']['output'];
  /** An array relationship */
  programme_locations: Array<Programme_Location>;
  /** An aggregate relationship */
  programme_locations_aggregate: Programme_Location_Aggregate;
  /** An array relationship */
  registers: Array<Register>;
  /** An aggregate relationship */
  registers_aggregate: Register_Aggregate;
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "location" */
export type LocationProgramme_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Programme_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Location_Order_By>>;
  where?: InputMaybe<Programme_Location_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationProgramme_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Programme_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Location_Order_By>>;
  where?: InputMaybe<Programme_Location_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationRegistersArgs = {
  distinct_on?: InputMaybe<Array<Register_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Order_By>>;
  where?: InputMaybe<Register_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationRegisters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Order_By>>;
  where?: InputMaybe<Register_Bool_Exp>;
};

/** aggregated selection of "location" */
export type Location_Aggregate = {
  __typename?: 'location_aggregate';
  aggregate?: Maybe<Location_Aggregate_Fields>;
  nodes: Array<Location>;
};

export type Location_Aggregate_Bool_Exp = {
  count?: InputMaybe<Location_Aggregate_Bool_Exp_Count>;
};

export type Location_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Location_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "location" */
export type Location_Aggregate_Fields = {
  __typename?: 'location_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Location_Max_Fields>;
  min?: Maybe<Location_Min_Fields>;
};


/** aggregate fields of "location" */
export type Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "location" */
export type Location_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Location_Max_Order_By>;
  min?: InputMaybe<Location_Min_Order_By>;
};

/** input type for inserting array relation for remote table "location" */
export type Location_Arr_Rel_Insert_Input = {
  data: Array<Location_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Location_On_Conflict>;
};

/** Boolean expression to filter rows from the table "location". All fields are combined with a logical 'AND'. */
export type Location_Bool_Exp = {
  _and?: InputMaybe<Array<Location_Bool_Exp>>;
  _not?: InputMaybe<Location_Bool_Exp>;
  _or?: InputMaybe<Array<Location_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  programme_locations?: InputMaybe<Programme_Location_Bool_Exp>;
  programme_locations_aggregate?: InputMaybe<Programme_Location_Aggregate_Bool_Exp>;
  registers?: InputMaybe<Register_Bool_Exp>;
  registers_aggregate?: InputMaybe<Register_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "location" */
export enum Location_Constraint {
  /** unique or primary key constraint on columns "id" */
  CentrePkey = 'centre_pkey',
  /** unique or primary key constraint on columns "slug" */
  CentreSlugKey = 'centre_slug_key'
}

/** input type for inserting data into table "location" */
export type Location_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  programme_locations?: InputMaybe<Programme_Location_Arr_Rel_Insert_Input>;
  registers?: InputMaybe<Register_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Location_Max_Fields = {
  __typename?: 'location_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "location" */
export type Location_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Location_Min_Fields = {
  __typename?: 'location_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "location" */
export type Location_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "location" */
export type Location_Mutation_Response = {
  __typename?: 'location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Location>;
};

/** input type for inserting object relation for remote table "location" */
export type Location_Obj_Rel_Insert_Input = {
  data: Location_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Location_On_Conflict>;
};

/** on_conflict condition type for table "location" */
export type Location_On_Conflict = {
  constraint: Location_Constraint;
  update_columns?: Array<Location_Update_Column>;
  where?: InputMaybe<Location_Bool_Exp>;
};

/** Ordering options when selecting data from "location". */
export type Location_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  programme_locations_aggregate?: InputMaybe<Programme_Location_Aggregate_Order_By>;
  registers_aggregate?: InputMaybe<Register_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: location */
export type Location_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "location" */
export enum Location_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "location" */
export type Location_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "location" */
export type Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Location_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "location" */
export enum Location_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Location_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: Location_Bool_Exp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "language" */
  delete_language?: Maybe<Language_Mutation_Response>;
  /** delete single row from the table: "language" */
  delete_language_by_pk?: Maybe<Language>;
  /** delete data from the table: "location" */
  delete_location?: Maybe<Location_Mutation_Response>;
  /** delete single row from the table: "location" */
  delete_location_by_pk?: Maybe<Location>;
  /** delete data from the table: "organisation" */
  delete_organisation?: Maybe<Organisation_Mutation_Response>;
  /** delete single row from the table: "organisation" */
  delete_organisation_by_pk?: Maybe<Organisation>;
  /** delete data from the table: "organisation_manager" */
  delete_organisation_manager?: Maybe<Organisation_Manager_Mutation_Response>;
  /** delete single row from the table: "organisation_manager" */
  delete_organisation_manager_by_pk?: Maybe<Organisation_Manager>;
  /** delete data from the table: "organisation_participant" */
  delete_organisation_participant?: Maybe<Organisation_Participant_Mutation_Response>;
  /** delete single row from the table: "organisation_participant" */
  delete_organisation_participant_by_pk?: Maybe<Organisation_Participant>;
  /** delete data from the table: "organisation_programme" */
  delete_organisation_programme?: Maybe<Organisation_Programme_Mutation_Response>;
  /** delete single row from the table: "organisation_programme" */
  delete_organisation_programme_by_pk?: Maybe<Organisation_Programme>;
  /** delete data from the table: "organisation_restricted_access_users" */
  delete_organisation_restricted_access_users?: Maybe<Organisation_Restricted_Access_Users_Mutation_Response>;
  /** delete single row from the table: "organisation_restricted_access_users" */
  delete_organisation_restricted_access_users_by_pk?: Maybe<Organisation_Restricted_Access_Users>;
  /** delete data from the table: "organisation_siloed_user" */
  delete_organisation_siloed_user?: Maybe<Organisation_Siloed_User_Mutation_Response>;
  /** delete single row from the table: "organisation_siloed_user" */
  delete_organisation_siloed_user_by_pk?: Maybe<Organisation_Siloed_User>;
  /** delete data from the table: "organisation_user" */
  delete_organisation_user?: Maybe<Organisation_User_Mutation_Response>;
  /** delete single row from the table: "organisation_user" */
  delete_organisation_user_by_pk?: Maybe<Organisation_User>;
  /** delete data from the table: "parent_child" */
  delete_parent_child?: Maybe<Parent_Child_Mutation_Response>;
  /** delete single row from the table: "parent_child" */
  delete_parent_child_by_pk?: Maybe<Parent_Child>;
  /** delete data from the table: "participant" */
  delete_participant?: Maybe<Participant_Mutation_Response>;
  /** delete single row from the table: "participant" */
  delete_participant_by_pk?: Maybe<Participant>;
  /** delete data from the table: "participant_files" */
  delete_participant_files?: Maybe<Participant_Files_Mutation_Response>;
  /** delete single row from the table: "participant_files" */
  delete_participant_files_by_pk?: Maybe<Participant_Files>;
  /** delete data from the table: "participant_language" */
  delete_participant_language?: Maybe<Participant_Language_Mutation_Response>;
  /** delete single row from the table: "participant_language" */
  delete_participant_language_by_pk?: Maybe<Participant_Language>;
  /** delete data from the table: "participant_sensitive_fields" */
  delete_participant_sensitive_fields?: Maybe<Participant_Sensitive_Fields_Mutation_Response>;
  /** delete single row from the table: "participant_sensitive_fields" */
  delete_participant_sensitive_fields_by_pk?: Maybe<Participant_Sensitive_Fields>;
  /** delete data from the table: "participant_sibling" */
  delete_participant_sibling?: Maybe<Participant_Sibling_Mutation_Response>;
  /** delete single row from the table: "participant_sibling" */
  delete_participant_sibling_by_pk?: Maybe<Participant_Sibling>;
  /** delete data from the table: "programme" */
  delete_programme?: Maybe<Programme_Mutation_Response>;
  /** delete single row from the table: "programme" */
  delete_programme_by_pk?: Maybe<Programme>;
  /** delete data from the table: "programme_group" */
  delete_programme_group?: Maybe<Programme_Group_Mutation_Response>;
  /** delete single row from the table: "programme_group" */
  delete_programme_group_by_pk?: Maybe<Programme_Group>;
  /** delete data from the table: "programme_location" */
  delete_programme_location?: Maybe<Programme_Location_Mutation_Response>;
  /** delete single row from the table: "programme_location" */
  delete_programme_location_by_pk?: Maybe<Programme_Location>;
  /** delete data from the table: "programme_participant" */
  delete_programme_participant?: Maybe<Programme_Participant_Mutation_Response>;
  /** delete single row from the table: "programme_participant" */
  delete_programme_participant_by_pk?: Maybe<Programme_Participant>;
  /** delete data from the table: "project" */
  delete_project?: Maybe<Project_Mutation_Response>;
  /** delete single row from the table: "project" */
  delete_project_by_pk?: Maybe<Project>;
  /** delete data from the table: "project_category" */
  delete_project_category?: Maybe<Project_Category_Mutation_Response>;
  /** delete single row from the table: "project_category" */
  delete_project_category_by_pk?: Maybe<Project_Category>;
  /** delete data from the table: "register" */
  delete_register?: Maybe<Register_Mutation_Response>;
  /** delete single row from the table: "register" */
  delete_register_by_pk?: Maybe<Register>;
  /** delete data from the table: "register_facilitator" */
  delete_register_facilitator?: Maybe<Register_Facilitator_Mutation_Response>;
  /** delete single row from the table: "register_facilitator" */
  delete_register_facilitator_by_pk?: Maybe<Register_Facilitator>;
  /** delete data from the table: "register_participant" */
  delete_register_participant?: Maybe<Register_Participant_Mutation_Response>;
  /** delete single row from the table: "register_participant" */
  delete_register_participant_by_pk?: Maybe<Register_Participant>;
  /** delete data from the table: "register_participant_computed" */
  delete_register_participant_computed?: Maybe<Register_Participant_Computed_Mutation_Response>;
  /** delete data from the table: "register_participant_sensitive_fields" */
  delete_register_participant_sensitive_fields?: Maybe<Register_Participant_Sensitive_Fields_Mutation_Response>;
  /** delete single row from the table: "register_participant_sensitive_fields" */
  delete_register_participant_sensitive_fields_by_pk?: Maybe<Register_Participant_Sensitive_Fields>;
  /** delete data from the table: "register_project_category" */
  delete_register_project_category?: Maybe<Register_Project_Category_Mutation_Response>;
  /** delete single row from the table: "register_project_category" */
  delete_register_project_category_by_pk?: Maybe<Register_Project_Category>;
  /** delete data from the table: "register_sensitive_fields" */
  delete_register_sensitive_fields?: Maybe<Register_Sensitive_Fields_Mutation_Response>;
  /** delete single row from the table: "register_sensitive_fields" */
  delete_register_sensitive_fields_by_pk?: Maybe<Register_Sensitive_Fields>;
  /** delete data from the table: "user" */
  delete_user?: Maybe<User_Mutation_Response>;
  /** delete single row from the table: "user" */
  delete_user_by_pk?: Maybe<User>;
  /** delete data from the table: "user_language" */
  delete_user_language?: Maybe<User_Language_Mutation_Response>;
  /** delete single row from the table: "user_language" */
  delete_user_language_by_pk?: Maybe<User_Language>;
  /** delete data from the table: "user_login_code" */
  delete_user_login_code?: Maybe<User_Login_Code_Mutation_Response>;
  /** delete single row from the table: "user_login_code" */
  delete_user_login_code_by_pk?: Maybe<User_Login_Code>;
  /** delete data from the table: "user_warning" */
  delete_user_warning?: Maybe<User_Warning_Mutation_Response>;
  /** delete single row from the table: "user_warning" */
  delete_user_warning_by_pk?: Maybe<User_Warning>;
  /** delete data from the table: "warning" */
  delete_warning?: Maybe<Warning_Mutation_Response>;
  /** delete single row from the table: "warning" */
  delete_warning_by_pk?: Maybe<Warning>;
  /** insert data into the table: "language" */
  insert_language?: Maybe<Language_Mutation_Response>;
  /** insert a single row into the table: "language" */
  insert_language_one?: Maybe<Language>;
  /** insert data into the table: "location" */
  insert_location?: Maybe<Location_Mutation_Response>;
  /** insert a single row into the table: "location" */
  insert_location_one?: Maybe<Location>;
  /** insert data into the table: "organisation" */
  insert_organisation?: Maybe<Organisation_Mutation_Response>;
  /** insert data into the table: "organisation_manager" */
  insert_organisation_manager?: Maybe<Organisation_Manager_Mutation_Response>;
  /** insert a single row into the table: "organisation_manager" */
  insert_organisation_manager_one?: Maybe<Organisation_Manager>;
  /** insert a single row into the table: "organisation" */
  insert_organisation_one?: Maybe<Organisation>;
  /** insert data into the table: "organisation_participant" */
  insert_organisation_participant?: Maybe<Organisation_Participant_Mutation_Response>;
  /** insert a single row into the table: "organisation_participant" */
  insert_organisation_participant_one?: Maybe<Organisation_Participant>;
  /** insert data into the table: "organisation_programme" */
  insert_organisation_programme?: Maybe<Organisation_Programme_Mutation_Response>;
  /** insert a single row into the table: "organisation_programme" */
  insert_organisation_programme_one?: Maybe<Organisation_Programme>;
  /** insert data into the table: "organisation_restricted_access_users" */
  insert_organisation_restricted_access_users?: Maybe<Organisation_Restricted_Access_Users_Mutation_Response>;
  /** insert a single row into the table: "organisation_restricted_access_users" */
  insert_organisation_restricted_access_users_one?: Maybe<Organisation_Restricted_Access_Users>;
  /** insert data into the table: "organisation_siloed_user" */
  insert_organisation_siloed_user?: Maybe<Organisation_Siloed_User_Mutation_Response>;
  /** insert a single row into the table: "organisation_siloed_user" */
  insert_organisation_siloed_user_one?: Maybe<Organisation_Siloed_User>;
  /** insert data into the table: "organisation_user" */
  insert_organisation_user?: Maybe<Organisation_User_Mutation_Response>;
  /** insert a single row into the table: "organisation_user" */
  insert_organisation_user_one?: Maybe<Organisation_User>;
  /** insert data into the table: "parent_child" */
  insert_parent_child?: Maybe<Parent_Child_Mutation_Response>;
  /** insert a single row into the table: "parent_child" */
  insert_parent_child_one?: Maybe<Parent_Child>;
  /** insert data into the table: "participant" */
  insert_participant?: Maybe<Participant_Mutation_Response>;
  /** insert data into the table: "participant_files" */
  insert_participant_files?: Maybe<Participant_Files_Mutation_Response>;
  /** insert a single row into the table: "participant_files" */
  insert_participant_files_one?: Maybe<Participant_Files>;
  /** insert data into the table: "participant_language" */
  insert_participant_language?: Maybe<Participant_Language_Mutation_Response>;
  /** insert a single row into the table: "participant_language" */
  insert_participant_language_one?: Maybe<Participant_Language>;
  /** insert a single row into the table: "participant" */
  insert_participant_one?: Maybe<Participant>;
  /** insert data into the table: "participant_sensitive_fields" */
  insert_participant_sensitive_fields?: Maybe<Participant_Sensitive_Fields_Mutation_Response>;
  /** insert a single row into the table: "participant_sensitive_fields" */
  insert_participant_sensitive_fields_one?: Maybe<Participant_Sensitive_Fields>;
  /** insert data into the table: "participant_sibling" */
  insert_participant_sibling?: Maybe<Participant_Sibling_Mutation_Response>;
  /** insert a single row into the table: "participant_sibling" */
  insert_participant_sibling_one?: Maybe<Participant_Sibling>;
  /** insert data into the table: "programme" */
  insert_programme?: Maybe<Programme_Mutation_Response>;
  /** insert data into the table: "programme_group" */
  insert_programme_group?: Maybe<Programme_Group_Mutation_Response>;
  /** insert a single row into the table: "programme_group" */
  insert_programme_group_one?: Maybe<Programme_Group>;
  /** insert data into the table: "programme_location" */
  insert_programme_location?: Maybe<Programme_Location_Mutation_Response>;
  /** insert a single row into the table: "programme_location" */
  insert_programme_location_one?: Maybe<Programme_Location>;
  /** insert a single row into the table: "programme" */
  insert_programme_one?: Maybe<Programme>;
  /** insert data into the table: "programme_participant" */
  insert_programme_participant?: Maybe<Programme_Participant_Mutation_Response>;
  /** insert a single row into the table: "programme_participant" */
  insert_programme_participant_one?: Maybe<Programme_Participant>;
  /** insert data into the table: "project" */
  insert_project?: Maybe<Project_Mutation_Response>;
  /** insert data into the table: "project_category" */
  insert_project_category?: Maybe<Project_Category_Mutation_Response>;
  /** insert a single row into the table: "project_category" */
  insert_project_category_one?: Maybe<Project_Category>;
  /** insert a single row into the table: "project" */
  insert_project_one?: Maybe<Project>;
  /** insert data into the table: "register" */
  insert_register?: Maybe<Register_Mutation_Response>;
  /** insert data into the table: "register_facilitator" */
  insert_register_facilitator?: Maybe<Register_Facilitator_Mutation_Response>;
  /** insert a single row into the table: "register_facilitator" */
  insert_register_facilitator_one?: Maybe<Register_Facilitator>;
  /** insert a single row into the table: "register" */
  insert_register_one?: Maybe<Register>;
  /** insert data into the table: "register_participant" */
  insert_register_participant?: Maybe<Register_Participant_Mutation_Response>;
  /** insert data into the table: "register_participant_computed" */
  insert_register_participant_computed?: Maybe<Register_Participant_Computed_Mutation_Response>;
  /** insert a single row into the table: "register_participant_computed" */
  insert_register_participant_computed_one?: Maybe<Register_Participant_Computed>;
  /** insert a single row into the table: "register_participant" */
  insert_register_participant_one?: Maybe<Register_Participant>;
  /** insert data into the table: "register_participant_sensitive_fields" */
  insert_register_participant_sensitive_fields?: Maybe<Register_Participant_Sensitive_Fields_Mutation_Response>;
  /** insert a single row into the table: "register_participant_sensitive_fields" */
  insert_register_participant_sensitive_fields_one?: Maybe<Register_Participant_Sensitive_Fields>;
  /** insert data into the table: "register_project_category" */
  insert_register_project_category?: Maybe<Register_Project_Category_Mutation_Response>;
  /** insert a single row into the table: "register_project_category" */
  insert_register_project_category_one?: Maybe<Register_Project_Category>;
  /** insert data into the table: "register_sensitive_fields" */
  insert_register_sensitive_fields?: Maybe<Register_Sensitive_Fields_Mutation_Response>;
  /** insert a single row into the table: "register_sensitive_fields" */
  insert_register_sensitive_fields_one?: Maybe<Register_Sensitive_Fields>;
  /** insert data into the table: "user" */
  insert_user?: Maybe<User_Mutation_Response>;
  /** insert data into the table: "user_language" */
  insert_user_language?: Maybe<User_Language_Mutation_Response>;
  /** insert a single row into the table: "user_language" */
  insert_user_language_one?: Maybe<User_Language>;
  /** insert data into the table: "user_login_code" */
  insert_user_login_code?: Maybe<User_Login_Code_Mutation_Response>;
  /** insert a single row into the table: "user_login_code" */
  insert_user_login_code_one?: Maybe<User_Login_Code>;
  /** insert a single row into the table: "user" */
  insert_user_one?: Maybe<User>;
  /** insert data into the table: "user_warning" */
  insert_user_warning?: Maybe<User_Warning_Mutation_Response>;
  /** insert a single row into the table: "user_warning" */
  insert_user_warning_one?: Maybe<User_Warning>;
  /** insert data into the table: "warning" */
  insert_warning?: Maybe<Warning_Mutation_Response>;
  /** insert a single row into the table: "warning" */
  insert_warning_one?: Maybe<Warning>;
  /** update data of the table: "language" */
  update_language?: Maybe<Language_Mutation_Response>;
  /** update single row of the table: "language" */
  update_language_by_pk?: Maybe<Language>;
  /** update multiples rows of table: "language" */
  update_language_many?: Maybe<Array<Maybe<Language_Mutation_Response>>>;
  /** update data of the table: "location" */
  update_location?: Maybe<Location_Mutation_Response>;
  /** update single row of the table: "location" */
  update_location_by_pk?: Maybe<Location>;
  /** update multiples rows of table: "location" */
  update_location_many?: Maybe<Array<Maybe<Location_Mutation_Response>>>;
  /** update data of the table: "organisation" */
  update_organisation?: Maybe<Organisation_Mutation_Response>;
  /** update single row of the table: "organisation" */
  update_organisation_by_pk?: Maybe<Organisation>;
  /** update data of the table: "organisation_manager" */
  update_organisation_manager?: Maybe<Organisation_Manager_Mutation_Response>;
  /** update single row of the table: "organisation_manager" */
  update_organisation_manager_by_pk?: Maybe<Organisation_Manager>;
  /** update multiples rows of table: "organisation_manager" */
  update_organisation_manager_many?: Maybe<Array<Maybe<Organisation_Manager_Mutation_Response>>>;
  /** update multiples rows of table: "organisation" */
  update_organisation_many?: Maybe<Array<Maybe<Organisation_Mutation_Response>>>;
  /** update data of the table: "organisation_participant" */
  update_organisation_participant?: Maybe<Organisation_Participant_Mutation_Response>;
  /** update single row of the table: "organisation_participant" */
  update_organisation_participant_by_pk?: Maybe<Organisation_Participant>;
  /** update multiples rows of table: "organisation_participant" */
  update_organisation_participant_many?: Maybe<Array<Maybe<Organisation_Participant_Mutation_Response>>>;
  /** update data of the table: "organisation_programme" */
  update_organisation_programme?: Maybe<Organisation_Programme_Mutation_Response>;
  /** update single row of the table: "organisation_programme" */
  update_organisation_programme_by_pk?: Maybe<Organisation_Programme>;
  /** update multiples rows of table: "organisation_programme" */
  update_organisation_programme_many?: Maybe<Array<Maybe<Organisation_Programme_Mutation_Response>>>;
  /** update data of the table: "organisation_restricted_access_users" */
  update_organisation_restricted_access_users?: Maybe<Organisation_Restricted_Access_Users_Mutation_Response>;
  /** update single row of the table: "organisation_restricted_access_users" */
  update_organisation_restricted_access_users_by_pk?: Maybe<Organisation_Restricted_Access_Users>;
  /** update multiples rows of table: "organisation_restricted_access_users" */
  update_organisation_restricted_access_users_many?: Maybe<Array<Maybe<Organisation_Restricted_Access_Users_Mutation_Response>>>;
  /** update data of the table: "organisation_siloed_user" */
  update_organisation_siloed_user?: Maybe<Organisation_Siloed_User_Mutation_Response>;
  /** update single row of the table: "organisation_siloed_user" */
  update_organisation_siloed_user_by_pk?: Maybe<Organisation_Siloed_User>;
  /** update multiples rows of table: "organisation_siloed_user" */
  update_organisation_siloed_user_many?: Maybe<Array<Maybe<Organisation_Siloed_User_Mutation_Response>>>;
  /** update data of the table: "organisation_user" */
  update_organisation_user?: Maybe<Organisation_User_Mutation_Response>;
  /** update single row of the table: "organisation_user" */
  update_organisation_user_by_pk?: Maybe<Organisation_User>;
  /** update multiples rows of table: "organisation_user" */
  update_organisation_user_many?: Maybe<Array<Maybe<Organisation_User_Mutation_Response>>>;
  /** update data of the table: "parent_child" */
  update_parent_child?: Maybe<Parent_Child_Mutation_Response>;
  /** update single row of the table: "parent_child" */
  update_parent_child_by_pk?: Maybe<Parent_Child>;
  /** update multiples rows of table: "parent_child" */
  update_parent_child_many?: Maybe<Array<Maybe<Parent_Child_Mutation_Response>>>;
  /** update data of the table: "participant" */
  update_participant?: Maybe<Participant_Mutation_Response>;
  /** update single row of the table: "participant" */
  update_participant_by_pk?: Maybe<Participant>;
  /** update data of the table: "participant_files" */
  update_participant_files?: Maybe<Participant_Files_Mutation_Response>;
  /** update single row of the table: "participant_files" */
  update_participant_files_by_pk?: Maybe<Participant_Files>;
  /** update multiples rows of table: "participant_files" */
  update_participant_files_many?: Maybe<Array<Maybe<Participant_Files_Mutation_Response>>>;
  /** update data of the table: "participant_language" */
  update_participant_language?: Maybe<Participant_Language_Mutation_Response>;
  /** update single row of the table: "participant_language" */
  update_participant_language_by_pk?: Maybe<Participant_Language>;
  /** update multiples rows of table: "participant_language" */
  update_participant_language_many?: Maybe<Array<Maybe<Participant_Language_Mutation_Response>>>;
  /** update multiples rows of table: "participant" */
  update_participant_many?: Maybe<Array<Maybe<Participant_Mutation_Response>>>;
  /** update data of the table: "participant_sensitive_fields" */
  update_participant_sensitive_fields?: Maybe<Participant_Sensitive_Fields_Mutation_Response>;
  /** update single row of the table: "participant_sensitive_fields" */
  update_participant_sensitive_fields_by_pk?: Maybe<Participant_Sensitive_Fields>;
  /** update multiples rows of table: "participant_sensitive_fields" */
  update_participant_sensitive_fields_many?: Maybe<Array<Maybe<Participant_Sensitive_Fields_Mutation_Response>>>;
  /** update data of the table: "participant_sibling" */
  update_participant_sibling?: Maybe<Participant_Sibling_Mutation_Response>;
  /** update single row of the table: "participant_sibling" */
  update_participant_sibling_by_pk?: Maybe<Participant_Sibling>;
  /** update multiples rows of table: "participant_sibling" */
  update_participant_sibling_many?: Maybe<Array<Maybe<Participant_Sibling_Mutation_Response>>>;
  /** update data of the table: "programme" */
  update_programme?: Maybe<Programme_Mutation_Response>;
  /** update single row of the table: "programme" */
  update_programme_by_pk?: Maybe<Programme>;
  /** update data of the table: "programme_group" */
  update_programme_group?: Maybe<Programme_Group_Mutation_Response>;
  /** update single row of the table: "programme_group" */
  update_programme_group_by_pk?: Maybe<Programme_Group>;
  /** update multiples rows of table: "programme_group" */
  update_programme_group_many?: Maybe<Array<Maybe<Programme_Group_Mutation_Response>>>;
  /** update data of the table: "programme_location" */
  update_programme_location?: Maybe<Programme_Location_Mutation_Response>;
  /** update single row of the table: "programme_location" */
  update_programme_location_by_pk?: Maybe<Programme_Location>;
  /** update multiples rows of table: "programme_location" */
  update_programme_location_many?: Maybe<Array<Maybe<Programme_Location_Mutation_Response>>>;
  /** update multiples rows of table: "programme" */
  update_programme_many?: Maybe<Array<Maybe<Programme_Mutation_Response>>>;
  /** update data of the table: "programme_participant" */
  update_programme_participant?: Maybe<Programme_Participant_Mutation_Response>;
  /** update single row of the table: "programme_participant" */
  update_programme_participant_by_pk?: Maybe<Programme_Participant>;
  /** update multiples rows of table: "programme_participant" */
  update_programme_participant_many?: Maybe<Array<Maybe<Programme_Participant_Mutation_Response>>>;
  /** update data of the table: "project" */
  update_project?: Maybe<Project_Mutation_Response>;
  /** update single row of the table: "project" */
  update_project_by_pk?: Maybe<Project>;
  /** update data of the table: "project_category" */
  update_project_category?: Maybe<Project_Category_Mutation_Response>;
  /** update single row of the table: "project_category" */
  update_project_category_by_pk?: Maybe<Project_Category>;
  /** update multiples rows of table: "project_category" */
  update_project_category_many?: Maybe<Array<Maybe<Project_Category_Mutation_Response>>>;
  /** update multiples rows of table: "project" */
  update_project_many?: Maybe<Array<Maybe<Project_Mutation_Response>>>;
  /** update data of the table: "register" */
  update_register?: Maybe<Register_Mutation_Response>;
  /** update single row of the table: "register" */
  update_register_by_pk?: Maybe<Register>;
  /** update data of the table: "register_facilitator" */
  update_register_facilitator?: Maybe<Register_Facilitator_Mutation_Response>;
  /** update single row of the table: "register_facilitator" */
  update_register_facilitator_by_pk?: Maybe<Register_Facilitator>;
  /** update multiples rows of table: "register_facilitator" */
  update_register_facilitator_many?: Maybe<Array<Maybe<Register_Facilitator_Mutation_Response>>>;
  /** update multiples rows of table: "register" */
  update_register_many?: Maybe<Array<Maybe<Register_Mutation_Response>>>;
  /** update data of the table: "register_participant" */
  update_register_participant?: Maybe<Register_Participant_Mutation_Response>;
  /** update single row of the table: "register_participant" */
  update_register_participant_by_pk?: Maybe<Register_Participant>;
  /** update data of the table: "register_participant_computed" */
  update_register_participant_computed?: Maybe<Register_Participant_Computed_Mutation_Response>;
  /** update multiples rows of table: "register_participant_computed" */
  update_register_participant_computed_many?: Maybe<Array<Maybe<Register_Participant_Computed_Mutation_Response>>>;
  /** update multiples rows of table: "register_participant" */
  update_register_participant_many?: Maybe<Array<Maybe<Register_Participant_Mutation_Response>>>;
  /** update data of the table: "register_participant_sensitive_fields" */
  update_register_participant_sensitive_fields?: Maybe<Register_Participant_Sensitive_Fields_Mutation_Response>;
  /** update single row of the table: "register_participant_sensitive_fields" */
  update_register_participant_sensitive_fields_by_pk?: Maybe<Register_Participant_Sensitive_Fields>;
  /** update multiples rows of table: "register_participant_sensitive_fields" */
  update_register_participant_sensitive_fields_many?: Maybe<Array<Maybe<Register_Participant_Sensitive_Fields_Mutation_Response>>>;
  /** update data of the table: "register_project_category" */
  update_register_project_category?: Maybe<Register_Project_Category_Mutation_Response>;
  /** update single row of the table: "register_project_category" */
  update_register_project_category_by_pk?: Maybe<Register_Project_Category>;
  /** update multiples rows of table: "register_project_category" */
  update_register_project_category_many?: Maybe<Array<Maybe<Register_Project_Category_Mutation_Response>>>;
  /** update data of the table: "register_sensitive_fields" */
  update_register_sensitive_fields?: Maybe<Register_Sensitive_Fields_Mutation_Response>;
  /** update single row of the table: "register_sensitive_fields" */
  update_register_sensitive_fields_by_pk?: Maybe<Register_Sensitive_Fields>;
  /** update multiples rows of table: "register_sensitive_fields" */
  update_register_sensitive_fields_many?: Maybe<Array<Maybe<Register_Sensitive_Fields_Mutation_Response>>>;
  /** update data of the table: "user" */
  update_user?: Maybe<User_Mutation_Response>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<User>;
  /** update data of the table: "user_language" */
  update_user_language?: Maybe<User_Language_Mutation_Response>;
  /** update single row of the table: "user_language" */
  update_user_language_by_pk?: Maybe<User_Language>;
  /** update multiples rows of table: "user_language" */
  update_user_language_many?: Maybe<Array<Maybe<User_Language_Mutation_Response>>>;
  /** update data of the table: "user_login_code" */
  update_user_login_code?: Maybe<User_Login_Code_Mutation_Response>;
  /** update single row of the table: "user_login_code" */
  update_user_login_code_by_pk?: Maybe<User_Login_Code>;
  /** update multiples rows of table: "user_login_code" */
  update_user_login_code_many?: Maybe<Array<Maybe<User_Login_Code_Mutation_Response>>>;
  /** update multiples rows of table: "user" */
  update_user_many?: Maybe<Array<Maybe<User_Mutation_Response>>>;
  /** update data of the table: "user_warning" */
  update_user_warning?: Maybe<User_Warning_Mutation_Response>;
  /** update single row of the table: "user_warning" */
  update_user_warning_by_pk?: Maybe<User_Warning>;
  /** update multiples rows of table: "user_warning" */
  update_user_warning_many?: Maybe<Array<Maybe<User_Warning_Mutation_Response>>>;
  /** update data of the table: "warning" */
  update_warning?: Maybe<Warning_Mutation_Response>;
  /** update single row of the table: "warning" */
  update_warning_by_pk?: Maybe<Warning>;
  /** update multiples rows of table: "warning" */
  update_warning_many?: Maybe<Array<Maybe<Warning_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_LanguageArgs = {
  where: Language_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Language_By_PkArgs = {
  code: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_LocationArgs = {
  where: Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrganisationArgs = {
  where: Organisation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_ManagerArgs = {
  where: Organisation_Manager_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Manager_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_ParticipantArgs = {
  where: Organisation_Participant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Participant_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  participant_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_ProgrammeArgs = {
  where: Organisation_Programme_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Programme_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  programme_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Restricted_Access_UsersArgs = {
  where: Organisation_Restricted_Access_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Restricted_Access_Users_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Siloed_UserArgs = {
  where: Organisation_Siloed_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Siloed_User_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_UserArgs = {
  where: Organisation_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_User_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parent_ChildArgs = {
  where: Parent_Child_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parent_Child_By_PkArgs = {
  child_id: Scalars['uuid']['input'];
  parent_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ParticipantArgs = {
  where: Participant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Participant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Participant_FilesArgs = {
  where: Participant_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Participant_Files_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Participant_LanguageArgs = {
  where: Participant_Language_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Participant_Language_By_PkArgs = {
  language_code: Scalars['String']['input'];
  participant_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Participant_Sensitive_FieldsArgs = {
  where: Participant_Sensitive_Fields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Participant_Sensitive_Fields_By_PkArgs = {
  participant_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Participant_SiblingArgs = {
  where: Participant_Sibling_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Participant_Sibling_By_PkArgs = {
  participant_id: Scalars['uuid']['input'];
  sibling_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProgrammeArgs = {
  where: Programme_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Programme_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Programme_GroupArgs = {
  where: Programme_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Programme_Group_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Programme_LocationArgs = {
  where: Programme_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Programme_Location_By_PkArgs = {
  location_id: Scalars['uuid']['input'];
  programme_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Programme_ParticipantArgs = {
  where: Programme_Participant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Programme_Participant_By_PkArgs = {
  participant_id: Scalars['uuid']['input'];
  programme_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectArgs = {
  where: Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_CategoryArgs = {
  where: Project_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RegisterArgs = {
  where: Register_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Register_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Register_FacilitatorArgs = {
  where: Register_Facilitator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Register_Facilitator_By_PkArgs = {
  facilitator_id: Scalars['uuid']['input'];
  register_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Register_ParticipantArgs = {
  where: Register_Participant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Register_Participant_By_PkArgs = {
  participant_id: Scalars['uuid']['input'];
  register_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Register_Participant_ComputedArgs = {
  where: Register_Participant_Computed_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Register_Participant_Sensitive_FieldsArgs = {
  where: Register_Participant_Sensitive_Fields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Register_Participant_Sensitive_Fields_By_PkArgs = {
  participant_id: Scalars['uuid']['input'];
  register_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Register_Project_CategoryArgs = {
  where: Register_Project_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Register_Project_Category_By_PkArgs = {
  project_category_id: Scalars['uuid']['input'];
  register_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Register_Sensitive_FieldsArgs = {
  where: Register_Sensitive_Fields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Register_Sensitive_Fields_By_PkArgs = {
  register_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserArgs = {
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_LanguageArgs = {
  where: User_Language_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Language_By_PkArgs = {
  language_code: Scalars['String']['input'];
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Login_CodeArgs = {
  where: User_Login_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Login_Code_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_WarningArgs = {
  where: User_Warning_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Warning_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
  warning_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_WarningArgs = {
  where: Warning_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Warning_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsert_LanguageArgs = {
  objects: Array<Language_Insert_Input>;
  on_conflict?: InputMaybe<Language_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Language_OneArgs = {
  object: Language_Insert_Input;
  on_conflict?: InputMaybe<Language_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LocationArgs = {
  objects: Array<Location_Insert_Input>;
  on_conflict?: InputMaybe<Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Location_OneArgs = {
  object: Location_Insert_Input;
  on_conflict?: InputMaybe<Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganisationArgs = {
  objects: Array<Organisation_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_ManagerArgs = {
  objects: Array<Organisation_Manager_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Manager_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Manager_OneArgs = {
  object: Organisation_Manager_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Manager_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_OneArgs = {
  object: Organisation_Insert_Input;
  on_conflict?: InputMaybe<Organisation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_ParticipantArgs = {
  objects: Array<Organisation_Participant_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Participant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Participant_OneArgs = {
  object: Organisation_Participant_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Participant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_ProgrammeArgs = {
  objects: Array<Organisation_Programme_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Programme_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Programme_OneArgs = {
  object: Organisation_Programme_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Programme_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Restricted_Access_UsersArgs = {
  objects: Array<Organisation_Restricted_Access_Users_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Restricted_Access_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Restricted_Access_Users_OneArgs = {
  object: Organisation_Restricted_Access_Users_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Restricted_Access_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Siloed_UserArgs = {
  objects: Array<Organisation_Siloed_User_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Siloed_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Siloed_User_OneArgs = {
  object: Organisation_Siloed_User_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Siloed_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_UserArgs = {
  objects: Array<Organisation_User_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_User_OneArgs = {
  object: Organisation_User_Insert_Input;
  on_conflict?: InputMaybe<Organisation_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parent_ChildArgs = {
  objects: Array<Parent_Child_Insert_Input>;
  on_conflict?: InputMaybe<Parent_Child_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parent_Child_OneArgs = {
  object: Parent_Child_Insert_Input;
  on_conflict?: InputMaybe<Parent_Child_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ParticipantArgs = {
  objects: Array<Participant_Insert_Input>;
  on_conflict?: InputMaybe<Participant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Participant_FilesArgs = {
  objects: Array<Participant_Files_Insert_Input>;
  on_conflict?: InputMaybe<Participant_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Participant_Files_OneArgs = {
  object: Participant_Files_Insert_Input;
  on_conflict?: InputMaybe<Participant_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Participant_LanguageArgs = {
  objects: Array<Participant_Language_Insert_Input>;
  on_conflict?: InputMaybe<Participant_Language_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Participant_Language_OneArgs = {
  object: Participant_Language_Insert_Input;
  on_conflict?: InputMaybe<Participant_Language_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Participant_OneArgs = {
  object: Participant_Insert_Input;
  on_conflict?: InputMaybe<Participant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Participant_Sensitive_FieldsArgs = {
  objects: Array<Participant_Sensitive_Fields_Insert_Input>;
  on_conflict?: InputMaybe<Participant_Sensitive_Fields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Participant_Sensitive_Fields_OneArgs = {
  object: Participant_Sensitive_Fields_Insert_Input;
  on_conflict?: InputMaybe<Participant_Sensitive_Fields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Participant_SiblingArgs = {
  objects: Array<Participant_Sibling_Insert_Input>;
  on_conflict?: InputMaybe<Participant_Sibling_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Participant_Sibling_OneArgs = {
  object: Participant_Sibling_Insert_Input;
  on_conflict?: InputMaybe<Participant_Sibling_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProgrammeArgs = {
  objects: Array<Programme_Insert_Input>;
  on_conflict?: InputMaybe<Programme_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Programme_GroupArgs = {
  objects: Array<Programme_Group_Insert_Input>;
  on_conflict?: InputMaybe<Programme_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Programme_Group_OneArgs = {
  object: Programme_Group_Insert_Input;
  on_conflict?: InputMaybe<Programme_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Programme_LocationArgs = {
  objects: Array<Programme_Location_Insert_Input>;
  on_conflict?: InputMaybe<Programme_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Programme_Location_OneArgs = {
  object: Programme_Location_Insert_Input;
  on_conflict?: InputMaybe<Programme_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Programme_OneArgs = {
  object: Programme_Insert_Input;
  on_conflict?: InputMaybe<Programme_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Programme_ParticipantArgs = {
  objects: Array<Programme_Participant_Insert_Input>;
  on_conflict?: InputMaybe<Programme_Participant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Programme_Participant_OneArgs = {
  object: Programme_Participant_Insert_Input;
  on_conflict?: InputMaybe<Programme_Participant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectArgs = {
  objects: Array<Project_Insert_Input>;
  on_conflict?: InputMaybe<Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_CategoryArgs = {
  objects: Array<Project_Category_Insert_Input>;
  on_conflict?: InputMaybe<Project_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Category_OneArgs = {
  object: Project_Category_Insert_Input;
  on_conflict?: InputMaybe<Project_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_OneArgs = {
  object: Project_Insert_Input;
  on_conflict?: InputMaybe<Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RegisterArgs = {
  objects: Array<Register_Insert_Input>;
  on_conflict?: InputMaybe<Register_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Register_FacilitatorArgs = {
  objects: Array<Register_Facilitator_Insert_Input>;
  on_conflict?: InputMaybe<Register_Facilitator_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Register_Facilitator_OneArgs = {
  object: Register_Facilitator_Insert_Input;
  on_conflict?: InputMaybe<Register_Facilitator_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Register_OneArgs = {
  object: Register_Insert_Input;
  on_conflict?: InputMaybe<Register_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Register_ParticipantArgs = {
  objects: Array<Register_Participant_Insert_Input>;
  on_conflict?: InputMaybe<Register_Participant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Register_Participant_ComputedArgs = {
  objects: Array<Register_Participant_Computed_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Register_Participant_Computed_OneArgs = {
  object: Register_Participant_Computed_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Register_Participant_OneArgs = {
  object: Register_Participant_Insert_Input;
  on_conflict?: InputMaybe<Register_Participant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Register_Participant_Sensitive_FieldsArgs = {
  objects: Array<Register_Participant_Sensitive_Fields_Insert_Input>;
  on_conflict?: InputMaybe<Register_Participant_Sensitive_Fields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Register_Participant_Sensitive_Fields_OneArgs = {
  object: Register_Participant_Sensitive_Fields_Insert_Input;
  on_conflict?: InputMaybe<Register_Participant_Sensitive_Fields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Register_Project_CategoryArgs = {
  objects: Array<Register_Project_Category_Insert_Input>;
  on_conflict?: InputMaybe<Register_Project_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Register_Project_Category_OneArgs = {
  object: Register_Project_Category_Insert_Input;
  on_conflict?: InputMaybe<Register_Project_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Register_Sensitive_FieldsArgs = {
  objects: Array<Register_Sensitive_Fields_Insert_Input>;
  on_conflict?: InputMaybe<Register_Sensitive_Fields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Register_Sensitive_Fields_OneArgs = {
  object: Register_Sensitive_Fields_Insert_Input;
  on_conflict?: InputMaybe<Register_Sensitive_Fields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserArgs = {
  objects: Array<User_Insert_Input>;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_LanguageArgs = {
  objects: Array<User_Language_Insert_Input>;
  on_conflict?: InputMaybe<User_Language_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Language_OneArgs = {
  object: User_Language_Insert_Input;
  on_conflict?: InputMaybe<User_Language_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Login_CodeArgs = {
  objects: Array<User_Login_Code_Insert_Input>;
  on_conflict?: InputMaybe<User_Login_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Login_Code_OneArgs = {
  object: User_Login_Code_Insert_Input;
  on_conflict?: InputMaybe<User_Login_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_OneArgs = {
  object: User_Insert_Input;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_WarningArgs = {
  objects: Array<User_Warning_Insert_Input>;
  on_conflict?: InputMaybe<User_Warning_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Warning_OneArgs = {
  object: User_Warning_Insert_Input;
  on_conflict?: InputMaybe<User_Warning_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_WarningArgs = {
  objects: Array<Warning_Insert_Input>;
  on_conflict?: InputMaybe<Warning_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Warning_OneArgs = {
  object: Warning_Insert_Input;
  on_conflict?: InputMaybe<Warning_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_LanguageArgs = {
  _set?: InputMaybe<Language_Set_Input>;
  where: Language_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Language_By_PkArgs = {
  _set?: InputMaybe<Language_Set_Input>;
  pk_columns: Language_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Language_ManyArgs = {
  updates: Array<Language_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LocationArgs = {
  _set?: InputMaybe<Location_Set_Input>;
  where: Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Location_By_PkArgs = {
  _set?: InputMaybe<Location_Set_Input>;
  pk_columns: Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Location_ManyArgs = {
  updates: Array<Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganisationArgs = {
  _set?: InputMaybe<Organisation_Set_Input>;
  where: Organisation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_By_PkArgs = {
  _set?: InputMaybe<Organisation_Set_Input>;
  pk_columns: Organisation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_ManagerArgs = {
  _set?: InputMaybe<Organisation_Manager_Set_Input>;
  where: Organisation_Manager_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Manager_By_PkArgs = {
  _set?: InputMaybe<Organisation_Manager_Set_Input>;
  pk_columns: Organisation_Manager_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Manager_ManyArgs = {
  updates: Array<Organisation_Manager_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_ManyArgs = {
  updates: Array<Organisation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_ParticipantArgs = {
  _set?: InputMaybe<Organisation_Participant_Set_Input>;
  where: Organisation_Participant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Participant_By_PkArgs = {
  _set?: InputMaybe<Organisation_Participant_Set_Input>;
  pk_columns: Organisation_Participant_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Participant_ManyArgs = {
  updates: Array<Organisation_Participant_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_ProgrammeArgs = {
  _set?: InputMaybe<Organisation_Programme_Set_Input>;
  where: Organisation_Programme_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Programme_By_PkArgs = {
  _set?: InputMaybe<Organisation_Programme_Set_Input>;
  pk_columns: Organisation_Programme_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Programme_ManyArgs = {
  updates: Array<Organisation_Programme_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Restricted_Access_UsersArgs = {
  _set?: InputMaybe<Organisation_Restricted_Access_Users_Set_Input>;
  where: Organisation_Restricted_Access_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Restricted_Access_Users_By_PkArgs = {
  _set?: InputMaybe<Organisation_Restricted_Access_Users_Set_Input>;
  pk_columns: Organisation_Restricted_Access_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Restricted_Access_Users_ManyArgs = {
  updates: Array<Organisation_Restricted_Access_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Siloed_UserArgs = {
  _set?: InputMaybe<Organisation_Siloed_User_Set_Input>;
  where: Organisation_Siloed_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Siloed_User_By_PkArgs = {
  _set?: InputMaybe<Organisation_Siloed_User_Set_Input>;
  pk_columns: Organisation_Siloed_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Siloed_User_ManyArgs = {
  updates: Array<Organisation_Siloed_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_UserArgs = {
  _set?: InputMaybe<Organisation_User_Set_Input>;
  where: Organisation_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_User_By_PkArgs = {
  _set?: InputMaybe<Organisation_User_Set_Input>;
  pk_columns: Organisation_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_User_ManyArgs = {
  updates: Array<Organisation_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parent_ChildArgs = {
  _set?: InputMaybe<Parent_Child_Set_Input>;
  where: Parent_Child_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parent_Child_By_PkArgs = {
  _set?: InputMaybe<Parent_Child_Set_Input>;
  pk_columns: Parent_Child_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parent_Child_ManyArgs = {
  updates: Array<Parent_Child_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ParticipantArgs = {
  _set?: InputMaybe<Participant_Set_Input>;
  where: Participant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Participant_By_PkArgs = {
  _set?: InputMaybe<Participant_Set_Input>;
  pk_columns: Participant_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Participant_FilesArgs = {
  _inc?: InputMaybe<Participant_Files_Inc_Input>;
  _set?: InputMaybe<Participant_Files_Set_Input>;
  where: Participant_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Participant_Files_By_PkArgs = {
  _inc?: InputMaybe<Participant_Files_Inc_Input>;
  _set?: InputMaybe<Participant_Files_Set_Input>;
  pk_columns: Participant_Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Participant_Files_ManyArgs = {
  updates: Array<Participant_Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Participant_LanguageArgs = {
  _set?: InputMaybe<Participant_Language_Set_Input>;
  where: Participant_Language_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Participant_Language_By_PkArgs = {
  _set?: InputMaybe<Participant_Language_Set_Input>;
  pk_columns: Participant_Language_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Participant_Language_ManyArgs = {
  updates: Array<Participant_Language_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Participant_ManyArgs = {
  updates: Array<Participant_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Participant_Sensitive_FieldsArgs = {
  _set?: InputMaybe<Participant_Sensitive_Fields_Set_Input>;
  where: Participant_Sensitive_Fields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Participant_Sensitive_Fields_By_PkArgs = {
  _set?: InputMaybe<Participant_Sensitive_Fields_Set_Input>;
  pk_columns: Participant_Sensitive_Fields_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Participant_Sensitive_Fields_ManyArgs = {
  updates: Array<Participant_Sensitive_Fields_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Participant_SiblingArgs = {
  _set?: InputMaybe<Participant_Sibling_Set_Input>;
  where: Participant_Sibling_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Participant_Sibling_By_PkArgs = {
  _set?: InputMaybe<Participant_Sibling_Set_Input>;
  pk_columns: Participant_Sibling_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Participant_Sibling_ManyArgs = {
  updates: Array<Participant_Sibling_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProgrammeArgs = {
  _set?: InputMaybe<Programme_Set_Input>;
  where: Programme_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Programme_By_PkArgs = {
  _set?: InputMaybe<Programme_Set_Input>;
  pk_columns: Programme_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Programme_GroupArgs = {
  _set?: InputMaybe<Programme_Group_Set_Input>;
  where: Programme_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Programme_Group_By_PkArgs = {
  _set?: InputMaybe<Programme_Group_Set_Input>;
  pk_columns: Programme_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Programme_Group_ManyArgs = {
  updates: Array<Programme_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Programme_LocationArgs = {
  _set?: InputMaybe<Programme_Location_Set_Input>;
  where: Programme_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Programme_Location_By_PkArgs = {
  _set?: InputMaybe<Programme_Location_Set_Input>;
  pk_columns: Programme_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Programme_Location_ManyArgs = {
  updates: Array<Programme_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Programme_ManyArgs = {
  updates: Array<Programme_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Programme_ParticipantArgs = {
  _set?: InputMaybe<Programme_Participant_Set_Input>;
  where: Programme_Participant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Programme_Participant_By_PkArgs = {
  _set?: InputMaybe<Programme_Participant_Set_Input>;
  pk_columns: Programme_Participant_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Programme_Participant_ManyArgs = {
  updates: Array<Programme_Participant_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectArgs = {
  _set?: InputMaybe<Project_Set_Input>;
  where: Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_By_PkArgs = {
  _set?: InputMaybe<Project_Set_Input>;
  pk_columns: Project_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_CategoryArgs = {
  _set?: InputMaybe<Project_Category_Set_Input>;
  where: Project_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Category_By_PkArgs = {
  _set?: InputMaybe<Project_Category_Set_Input>;
  pk_columns: Project_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Category_ManyArgs = {
  updates: Array<Project_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_ManyArgs = {
  updates: Array<Project_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RegisterArgs = {
  _inc?: InputMaybe<Register_Inc_Input>;
  _set?: InputMaybe<Register_Set_Input>;
  where: Register_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Register_By_PkArgs = {
  _inc?: InputMaybe<Register_Inc_Input>;
  _set?: InputMaybe<Register_Set_Input>;
  pk_columns: Register_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Register_FacilitatorArgs = {
  _set?: InputMaybe<Register_Facilitator_Set_Input>;
  where: Register_Facilitator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Register_Facilitator_By_PkArgs = {
  _set?: InputMaybe<Register_Facilitator_Set_Input>;
  pk_columns: Register_Facilitator_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Register_Facilitator_ManyArgs = {
  updates: Array<Register_Facilitator_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Register_ManyArgs = {
  updates: Array<Register_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Register_ParticipantArgs = {
  _set?: InputMaybe<Register_Participant_Set_Input>;
  where: Register_Participant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Register_Participant_By_PkArgs = {
  _set?: InputMaybe<Register_Participant_Set_Input>;
  pk_columns: Register_Participant_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Register_Participant_ComputedArgs = {
  _inc?: InputMaybe<Register_Participant_Computed_Inc_Input>;
  _set?: InputMaybe<Register_Participant_Computed_Set_Input>;
  where: Register_Participant_Computed_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Register_Participant_Computed_ManyArgs = {
  updates: Array<Register_Participant_Computed_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Register_Participant_ManyArgs = {
  updates: Array<Register_Participant_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Register_Participant_Sensitive_FieldsArgs = {
  _set?: InputMaybe<Register_Participant_Sensitive_Fields_Set_Input>;
  where: Register_Participant_Sensitive_Fields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Register_Participant_Sensitive_Fields_By_PkArgs = {
  _set?: InputMaybe<Register_Participant_Sensitive_Fields_Set_Input>;
  pk_columns: Register_Participant_Sensitive_Fields_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Register_Participant_Sensitive_Fields_ManyArgs = {
  updates: Array<Register_Participant_Sensitive_Fields_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Register_Project_CategoryArgs = {
  _set?: InputMaybe<Register_Project_Category_Set_Input>;
  where: Register_Project_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Register_Project_Category_By_PkArgs = {
  _set?: InputMaybe<Register_Project_Category_Set_Input>;
  pk_columns: Register_Project_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Register_Project_Category_ManyArgs = {
  updates: Array<Register_Project_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Register_Sensitive_FieldsArgs = {
  _set?: InputMaybe<Register_Sensitive_Fields_Set_Input>;
  where: Register_Sensitive_Fields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Register_Sensitive_Fields_By_PkArgs = {
  _set?: InputMaybe<Register_Sensitive_Fields_Set_Input>;
  pk_columns: Register_Sensitive_Fields_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Register_Sensitive_Fields_ManyArgs = {
  updates: Array<Register_Sensitive_Fields_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserArgs = {
  _set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_By_PkArgs = {
  _set?: InputMaybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_LanguageArgs = {
  _set?: InputMaybe<User_Language_Set_Input>;
  where: User_Language_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Language_By_PkArgs = {
  _set?: InputMaybe<User_Language_Set_Input>;
  pk_columns: User_Language_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Language_ManyArgs = {
  updates: Array<User_Language_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Login_CodeArgs = {
  _inc?: InputMaybe<User_Login_Code_Inc_Input>;
  _set?: InputMaybe<User_Login_Code_Set_Input>;
  where: User_Login_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Login_Code_By_PkArgs = {
  _inc?: InputMaybe<User_Login_Code_Inc_Input>;
  _set?: InputMaybe<User_Login_Code_Set_Input>;
  pk_columns: User_Login_Code_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Login_Code_ManyArgs = {
  updates: Array<User_Login_Code_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ManyArgs = {
  updates: Array<User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_WarningArgs = {
  _set?: InputMaybe<User_Warning_Set_Input>;
  where: User_Warning_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Warning_By_PkArgs = {
  _set?: InputMaybe<User_Warning_Set_Input>;
  pk_columns: User_Warning_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Warning_ManyArgs = {
  updates: Array<User_Warning_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_WarningArgs = {
  _set?: InputMaybe<Warning_Set_Input>;
  where: Warning_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Warning_By_PkArgs = {
  _set?: InputMaybe<Warning_Set_Input>;
  pk_columns: Warning_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Warning_ManyArgs = {
  updates: Array<Warning_Updates>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "organisation" */
export type Organisation = {
  __typename?: 'organisation';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  locations: Array<Location>;
  /** An aggregate relationship */
  locations_aggregate: Location_Aggregate;
  name: Scalars['String']['output'];
  /** An array relationship */
  organisation_managers: Array<Organisation_Manager>;
  /** An aggregate relationship */
  organisation_managers_aggregate: Organisation_Manager_Aggregate;
  /** An array relationship */
  organisation_participants: Array<Organisation_Participant>;
  /** An aggregate relationship */
  organisation_participants_aggregate: Organisation_Participant_Aggregate;
  /** An array relationship */
  organisation_programmes: Array<Organisation_Programme>;
  /** An aggregate relationship */
  organisation_programmes_aggregate: Organisation_Programme_Aggregate;
  /** An array relationship */
  organisation_users: Array<Organisation_User>;
  /** An aggregate relationship */
  organisation_users_aggregate: Organisation_User_Aggregate;
  /** An array relationship */
  projects: Array<Project>;
  /** An aggregate relationship */
  projects_aggregate: Project_Aggregate;
  /** An array relationship */
  registers: Array<Register>;
  /** An aggregate relationship */
  registers_aggregate: Register_Aggregate;
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "organisation" */
export type OrganisationLocationsArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrganisation_ManagersArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Manager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Manager_Order_By>>;
  where?: InputMaybe<Organisation_Manager_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrganisation_Managers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Manager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Manager_Order_By>>;
  where?: InputMaybe<Organisation_Manager_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrganisation_ParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Participant_Order_By>>;
  where?: InputMaybe<Organisation_Participant_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrganisation_Participants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Participant_Order_By>>;
  where?: InputMaybe<Organisation_Participant_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrganisation_ProgrammesArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Programme_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Programme_Order_By>>;
  where?: InputMaybe<Organisation_Programme_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrganisation_Programmes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Programme_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Programme_Order_By>>;
  where?: InputMaybe<Organisation_Programme_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrganisation_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organisation_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_User_Order_By>>;
  where?: InputMaybe<Organisation_User_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrganisation_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_User_Order_By>>;
  where?: InputMaybe<Organisation_User_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationProjectsArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationRegistersArgs = {
  distinct_on?: InputMaybe<Array<Register_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Order_By>>;
  where?: InputMaybe<Register_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationRegisters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Order_By>>;
  where?: InputMaybe<Register_Bool_Exp>;
};

/** aggregated selection of "organisation" */
export type Organisation_Aggregate = {
  __typename?: 'organisation_aggregate';
  aggregate?: Maybe<Organisation_Aggregate_Fields>;
  nodes: Array<Organisation>;
};

/** aggregate fields of "organisation" */
export type Organisation_Aggregate_Fields = {
  __typename?: 'organisation_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organisation_Max_Fields>;
  min?: Maybe<Organisation_Min_Fields>;
};


/** aggregate fields of "organisation" */
export type Organisation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "organisation". All fields are combined with a logical 'AND'. */
export type Organisation_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  locations?: InputMaybe<Location_Bool_Exp>;
  locations_aggregate?: InputMaybe<Location_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation_managers?: InputMaybe<Organisation_Manager_Bool_Exp>;
  organisation_managers_aggregate?: InputMaybe<Organisation_Manager_Aggregate_Bool_Exp>;
  organisation_participants?: InputMaybe<Organisation_Participant_Bool_Exp>;
  organisation_participants_aggregate?: InputMaybe<Organisation_Participant_Aggregate_Bool_Exp>;
  organisation_programmes?: InputMaybe<Organisation_Programme_Bool_Exp>;
  organisation_programmes_aggregate?: InputMaybe<Organisation_Programme_Aggregate_Bool_Exp>;
  organisation_users?: InputMaybe<Organisation_User_Bool_Exp>;
  organisation_users_aggregate?: InputMaybe<Organisation_User_Aggregate_Bool_Exp>;
  projects?: InputMaybe<Project_Bool_Exp>;
  projects_aggregate?: InputMaybe<Project_Aggregate_Bool_Exp>;
  registers?: InputMaybe<Register_Bool_Exp>;
  registers_aggregate?: InputMaybe<Register_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation" */
export enum Organisation_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganisationPkey = 'organisation_pkey',
  /** unique or primary key constraint on columns "slug" */
  OrganisationSlugKey = 'organisation_slug_key'
}

/** input type for inserting data into table "organisation" */
export type Organisation_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locations?: InputMaybe<Location_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_managers?: InputMaybe<Organisation_Manager_Arr_Rel_Insert_Input>;
  organisation_participants?: InputMaybe<Organisation_Participant_Arr_Rel_Insert_Input>;
  organisation_programmes?: InputMaybe<Organisation_Programme_Arr_Rel_Insert_Input>;
  organisation_users?: InputMaybe<Organisation_User_Arr_Rel_Insert_Input>;
  projects?: InputMaybe<Project_Arr_Rel_Insert_Input>;
  registers?: InputMaybe<Register_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "organisation_manager" */
export type Organisation_Manager = {
  __typename?: 'organisation_manager';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "organisation_manager" */
export type Organisation_Manager_Aggregate = {
  __typename?: 'organisation_manager_aggregate';
  aggregate?: Maybe<Organisation_Manager_Aggregate_Fields>;
  nodes: Array<Organisation_Manager>;
};

export type Organisation_Manager_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organisation_Manager_Aggregate_Bool_Exp_Count>;
};

export type Organisation_Manager_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organisation_Manager_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organisation_Manager_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organisation_manager" */
export type Organisation_Manager_Aggregate_Fields = {
  __typename?: 'organisation_manager_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organisation_Manager_Max_Fields>;
  min?: Maybe<Organisation_Manager_Min_Fields>;
};


/** aggregate fields of "organisation_manager" */
export type Organisation_Manager_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Manager_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organisation_manager" */
export type Organisation_Manager_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organisation_Manager_Max_Order_By>;
  min?: InputMaybe<Organisation_Manager_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_manager" */
export type Organisation_Manager_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Manager_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisation_Manager_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organisation_manager". All fields are combined with a logical 'AND'. */
export type Organisation_Manager_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Manager_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Manager_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Manager_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_manager" */
export enum Organisation_Manager_Constraint {
  /** unique or primary key constraint on columns "user_id", "organisation_id" */
  OrganisationManagerPkey = 'organisation_manager_pkey'
}

/** input type for inserting data into table "organisation_manager" */
export type Organisation_Manager_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Organisation_Manager_Max_Fields = {
  __typename?: 'organisation_manager_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "organisation_manager" */
export type Organisation_Manager_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_Manager_Min_Fields = {
  __typename?: 'organisation_manager_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "organisation_manager" */
export type Organisation_Manager_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organisation_manager" */
export type Organisation_Manager_Mutation_Response = {
  __typename?: 'organisation_manager_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Manager>;
};

/** on_conflict condition type for table "organisation_manager" */
export type Organisation_Manager_On_Conflict = {
  constraint: Organisation_Manager_Constraint;
  update_columns?: Array<Organisation_Manager_Update_Column>;
  where?: InputMaybe<Organisation_Manager_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_manager". */
export type Organisation_Manager_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation_manager */
export type Organisation_Manager_Pk_Columns_Input = {
  organisation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_manager" */
export enum Organisation_Manager_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "organisation_manager" */
export type Organisation_Manager_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "organisation_manager" */
export type Organisation_Manager_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Manager_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Manager_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organisation_manager" */
export enum Organisation_Manager_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Organisation_Manager_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Manager_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organisation_Manager_Bool_Exp;
};

/** aggregate max on columns */
export type Organisation_Max_Fields = {
  __typename?: 'organisation_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Organisation_Min_Fields = {
  __typename?: 'organisation_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "organisation" */
export type Organisation_Mutation_Response = {
  __typename?: 'organisation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation>;
};

/** input type for inserting object relation for remote table "organisation" */
export type Organisation_Obj_Rel_Insert_Input = {
  data: Organisation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisation_On_Conflict>;
};

/** on_conflict condition type for table "organisation" */
export type Organisation_On_Conflict = {
  constraint: Organisation_Constraint;
  update_columns?: Array<Organisation_Update_Column>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation". */
export type Organisation_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locations_aggregate?: InputMaybe<Location_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_managers_aggregate?: InputMaybe<Organisation_Manager_Aggregate_Order_By>;
  organisation_participants_aggregate?: InputMaybe<Organisation_Participant_Aggregate_Order_By>;
  organisation_programmes_aggregate?: InputMaybe<Organisation_Programme_Aggregate_Order_By>;
  organisation_users_aggregate?: InputMaybe<Organisation_User_Aggregate_Order_By>;
  projects_aggregate?: InputMaybe<Project_Aggregate_Order_By>;
  registers_aggregate?: InputMaybe<Register_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** columns and relationships of "organisation_participant" */
export type Organisation_Participant = {
  __typename?: 'organisation_participant';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  participant: Participant;
  participant_id: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "organisation_participant" */
export type Organisation_Participant_Aggregate = {
  __typename?: 'organisation_participant_aggregate';
  aggregate?: Maybe<Organisation_Participant_Aggregate_Fields>;
  nodes: Array<Organisation_Participant>;
};

export type Organisation_Participant_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organisation_Participant_Aggregate_Bool_Exp_Count>;
};

export type Organisation_Participant_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organisation_Participant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organisation_Participant_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organisation_participant" */
export type Organisation_Participant_Aggregate_Fields = {
  __typename?: 'organisation_participant_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organisation_Participant_Max_Fields>;
  min?: Maybe<Organisation_Participant_Min_Fields>;
};


/** aggregate fields of "organisation_participant" */
export type Organisation_Participant_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Participant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organisation_participant" */
export type Organisation_Participant_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organisation_Participant_Max_Order_By>;
  min?: InputMaybe<Organisation_Participant_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_participant" */
export type Organisation_Participant_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Participant_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisation_Participant_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organisation_participant". All fields are combined with a logical 'AND'. */
export type Organisation_Participant_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Participant_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Participant_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Participant_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  participant?: InputMaybe<Participant_Bool_Exp>;
  participant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_participant" */
export enum Organisation_Participant_Constraint {
  /** unique or primary key constraint on columns "participant_id", "organisation_id" */
  OrganisationParticipantPkey = 'organisation_participant_pkey'
}

/** input type for inserting data into table "organisation_participant" */
export type Organisation_Participant_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  participant?: InputMaybe<Participant_Obj_Rel_Insert_Input>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Organisation_Participant_Max_Fields = {
  __typename?: 'organisation_participant_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "organisation_participant" */
export type Organisation_Participant_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_Participant_Min_Fields = {
  __typename?: 'organisation_participant_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "organisation_participant" */
export type Organisation_Participant_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organisation_participant" */
export type Organisation_Participant_Mutation_Response = {
  __typename?: 'organisation_participant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Participant>;
};

/** on_conflict condition type for table "organisation_participant" */
export type Organisation_Participant_On_Conflict = {
  constraint: Organisation_Participant_Constraint;
  update_columns?: Array<Organisation_Participant_Update_Column>;
  where?: InputMaybe<Organisation_Participant_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_participant". */
export type Organisation_Participant_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  participant?: InputMaybe<Participant_Order_By>;
  participant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation_participant */
export type Organisation_Participant_Pk_Columns_Input = {
  organisation_id: Scalars['uuid']['input'];
  participant_id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_participant" */
export enum Organisation_Participant_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "organisation_participant" */
export type Organisation_Participant_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "organisation_participant" */
export type Organisation_Participant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Participant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Participant_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organisation_participant" */
export enum Organisation_Participant_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Organisation_Participant_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Participant_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organisation_Participant_Bool_Exp;
};

/** primary key columns input for table: organisation */
export type Organisation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "organisation_programme" */
export type Organisation_Programme = {
  __typename?: 'organisation_programme';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  programme: Programme;
  programme_id: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "organisation_programme" */
export type Organisation_Programme_Aggregate = {
  __typename?: 'organisation_programme_aggregate';
  aggregate?: Maybe<Organisation_Programme_Aggregate_Fields>;
  nodes: Array<Organisation_Programme>;
};

export type Organisation_Programme_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organisation_Programme_Aggregate_Bool_Exp_Count>;
};

export type Organisation_Programme_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organisation_Programme_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organisation_Programme_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organisation_programme" */
export type Organisation_Programme_Aggregate_Fields = {
  __typename?: 'organisation_programme_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organisation_Programme_Max_Fields>;
  min?: Maybe<Organisation_Programme_Min_Fields>;
};


/** aggregate fields of "organisation_programme" */
export type Organisation_Programme_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Programme_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organisation_programme" */
export type Organisation_Programme_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organisation_Programme_Max_Order_By>;
  min?: InputMaybe<Organisation_Programme_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_programme" */
export type Organisation_Programme_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Programme_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisation_Programme_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organisation_programme". All fields are combined with a logical 'AND'. */
export type Organisation_Programme_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Programme_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Programme_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Programme_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  programme?: InputMaybe<Programme_Bool_Exp>;
  programme_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_programme" */
export enum Organisation_Programme_Constraint {
  /** unique or primary key constraint on columns "organisation_id", "programme_id" */
  OrganisationProgrammePkey = 'organisation_programme_pkey'
}

/** input type for inserting data into table "organisation_programme" */
export type Organisation_Programme_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  programme?: InputMaybe<Programme_Obj_Rel_Insert_Input>;
  programme_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Organisation_Programme_Max_Fields = {
  __typename?: 'organisation_programme_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  programme_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "organisation_programme" */
export type Organisation_Programme_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  programme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_Programme_Min_Fields = {
  __typename?: 'organisation_programme_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  programme_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "organisation_programme" */
export type Organisation_Programme_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  programme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organisation_programme" */
export type Organisation_Programme_Mutation_Response = {
  __typename?: 'organisation_programme_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Programme>;
};

/** on_conflict condition type for table "organisation_programme" */
export type Organisation_Programme_On_Conflict = {
  constraint: Organisation_Programme_Constraint;
  update_columns?: Array<Organisation_Programme_Update_Column>;
  where?: InputMaybe<Organisation_Programme_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_programme". */
export type Organisation_Programme_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  programme?: InputMaybe<Programme_Order_By>;
  programme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation_programme */
export type Organisation_Programme_Pk_Columns_Input = {
  organisation_id: Scalars['uuid']['input'];
  programme_id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_programme" */
export enum Organisation_Programme_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ProgrammeId = 'programme_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "organisation_programme" */
export type Organisation_Programme_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  programme_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "organisation_programme" */
export type Organisation_Programme_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Programme_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Programme_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  programme_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organisation_programme" */
export enum Organisation_Programme_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ProgrammeId = 'programme_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Organisation_Programme_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Programme_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organisation_Programme_Bool_Exp;
};

/** columns and relationships of "organisation_restricted_access_users" */
export type Organisation_Restricted_Access_Users = {
  __typename?: 'organisation_restricted_access_users';
  organisation_id: Scalars['uuid']['output'];
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "organisation_restricted_access_users" */
export type Organisation_Restricted_Access_Users_Aggregate = {
  __typename?: 'organisation_restricted_access_users_aggregate';
  aggregate?: Maybe<Organisation_Restricted_Access_Users_Aggregate_Fields>;
  nodes: Array<Organisation_Restricted_Access_Users>;
};

/** aggregate fields of "organisation_restricted_access_users" */
export type Organisation_Restricted_Access_Users_Aggregate_Fields = {
  __typename?: 'organisation_restricted_access_users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organisation_Restricted_Access_Users_Max_Fields>;
  min?: Maybe<Organisation_Restricted_Access_Users_Min_Fields>;
};


/** aggregate fields of "organisation_restricted_access_users" */
export type Organisation_Restricted_Access_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Restricted_Access_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "organisation_restricted_access_users". All fields are combined with a logical 'AND'. */
export type Organisation_Restricted_Access_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Restricted_Access_Users_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Restricted_Access_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Restricted_Access_Users_Bool_Exp>>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_restricted_access_users" */
export enum Organisation_Restricted_Access_Users_Constraint {
  /** unique or primary key constraint on columns "user_id", "organisation_id" */
  OrganisationRestrictedAccessUsersPkey = 'organisation_restricted_access_users_pkey'
}

/** input type for inserting data into table "organisation_restricted_access_users" */
export type Organisation_Restricted_Access_Users_Insert_Input = {
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Organisation_Restricted_Access_Users_Max_Fields = {
  __typename?: 'organisation_restricted_access_users_max_fields';
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Organisation_Restricted_Access_Users_Min_Fields = {
  __typename?: 'organisation_restricted_access_users_min_fields';
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "organisation_restricted_access_users" */
export type Organisation_Restricted_Access_Users_Mutation_Response = {
  __typename?: 'organisation_restricted_access_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Restricted_Access_Users>;
};

/** on_conflict condition type for table "organisation_restricted_access_users" */
export type Organisation_Restricted_Access_Users_On_Conflict = {
  constraint: Organisation_Restricted_Access_Users_Constraint;
  update_columns?: Array<Organisation_Restricted_Access_Users_Update_Column>;
  where?: InputMaybe<Organisation_Restricted_Access_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_restricted_access_users". */
export type Organisation_Restricted_Access_Users_Order_By = {
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation_restricted_access_users */
export type Organisation_Restricted_Access_Users_Pk_Columns_Input = {
  organisation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_restricted_access_users" */
export enum Organisation_Restricted_Access_Users_Select_Column {
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "organisation_restricted_access_users" */
export type Organisation_Restricted_Access_Users_Set_Input = {
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "organisation_restricted_access_users" */
export type Organisation_Restricted_Access_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Restricted_Access_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Restricted_Access_Users_Stream_Cursor_Value_Input = {
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organisation_restricted_access_users" */
export enum Organisation_Restricted_Access_Users_Update_Column {
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UserId = 'user_id'
}

export type Organisation_Restricted_Access_Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Restricted_Access_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organisation_Restricted_Access_Users_Bool_Exp;
};

/** select columns of table "organisation" */
export enum Organisation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "organisation" */
export type Organisation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "organisation_siloed_user" */
export type Organisation_Siloed_User = {
  __typename?: 'organisation_siloed_user';
  created_at: Scalars['timestamptz']['output'];
  organisation_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "organisation_siloed_user" */
export type Organisation_Siloed_User_Aggregate = {
  __typename?: 'organisation_siloed_user_aggregate';
  aggregate?: Maybe<Organisation_Siloed_User_Aggregate_Fields>;
  nodes: Array<Organisation_Siloed_User>;
};

export type Organisation_Siloed_User_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organisation_Siloed_User_Aggregate_Bool_Exp_Count>;
};

export type Organisation_Siloed_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organisation_Siloed_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organisation_Siloed_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organisation_siloed_user" */
export type Organisation_Siloed_User_Aggregate_Fields = {
  __typename?: 'organisation_siloed_user_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organisation_Siloed_User_Max_Fields>;
  min?: Maybe<Organisation_Siloed_User_Min_Fields>;
};


/** aggregate fields of "organisation_siloed_user" */
export type Organisation_Siloed_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Siloed_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organisation_siloed_user" */
export type Organisation_Siloed_User_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organisation_Siloed_User_Max_Order_By>;
  min?: InputMaybe<Organisation_Siloed_User_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_siloed_user" */
export type Organisation_Siloed_User_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Siloed_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisation_Siloed_User_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organisation_siloed_user". All fields are combined with a logical 'AND'. */
export type Organisation_Siloed_User_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Siloed_User_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Siloed_User_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Siloed_User_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_siloed_user" */
export enum Organisation_Siloed_User_Constraint {
  /** unique or primary key constraint on columns "user_id", "organisation_id" */
  OrganisationSiloedUserPkey = 'organisation_siloed_user_pkey'
}

/** input type for inserting data into table "organisation_siloed_user" */
export type Organisation_Siloed_User_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Organisation_Siloed_User_Max_Fields = {
  __typename?: 'organisation_siloed_user_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "organisation_siloed_user" */
export type Organisation_Siloed_User_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_Siloed_User_Min_Fields = {
  __typename?: 'organisation_siloed_user_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "organisation_siloed_user" */
export type Organisation_Siloed_User_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organisation_siloed_user" */
export type Organisation_Siloed_User_Mutation_Response = {
  __typename?: 'organisation_siloed_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Siloed_User>;
};

/** on_conflict condition type for table "organisation_siloed_user" */
export type Organisation_Siloed_User_On_Conflict = {
  constraint: Organisation_Siloed_User_Constraint;
  update_columns?: Array<Organisation_Siloed_User_Update_Column>;
  where?: InputMaybe<Organisation_Siloed_User_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_siloed_user". */
export type Organisation_Siloed_User_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation_siloed_user */
export type Organisation_Siloed_User_Pk_Columns_Input = {
  organisation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_siloed_user" */
export enum Organisation_Siloed_User_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "organisation_siloed_user" */
export type Organisation_Siloed_User_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "organisation_siloed_user" */
export type Organisation_Siloed_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Siloed_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Siloed_User_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organisation_siloed_user" */
export enum Organisation_Siloed_User_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Organisation_Siloed_User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Siloed_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organisation_Siloed_User_Bool_Exp;
};

/** Streaming cursor of the table "organisation" */
export type Organisation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organisation" */
export enum Organisation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Organisation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organisation_Bool_Exp;
};

/** columns and relationships of "organisation_user" */
export type Organisation_User = {
  __typename?: 'organisation_user';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "organisation_user" */
export type Organisation_User_Aggregate = {
  __typename?: 'organisation_user_aggregate';
  aggregate?: Maybe<Organisation_User_Aggregate_Fields>;
  nodes: Array<Organisation_User>;
};

export type Organisation_User_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organisation_User_Aggregate_Bool_Exp_Count>;
};

export type Organisation_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organisation_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organisation_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organisation_user" */
export type Organisation_User_Aggregate_Fields = {
  __typename?: 'organisation_user_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organisation_User_Max_Fields>;
  min?: Maybe<Organisation_User_Min_Fields>;
};


/** aggregate fields of "organisation_user" */
export type Organisation_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organisation_user" */
export type Organisation_User_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organisation_User_Max_Order_By>;
  min?: InputMaybe<Organisation_User_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_user" */
export type Organisation_User_Arr_Rel_Insert_Input = {
  data: Array<Organisation_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisation_User_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organisation_user". All fields are combined with a logical 'AND'. */
export type Organisation_User_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_User_Bool_Exp>>;
  _not?: InputMaybe<Organisation_User_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_User_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_user" */
export enum Organisation_User_Constraint {
  /** unique or primary key constraint on columns "user_id", "organisation_id" */
  OrganisationUserPkey = 'organisation_user_pkey'
}

/** input type for inserting data into table "organisation_user" */
export type Organisation_User_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Organisation_User_Max_Fields = {
  __typename?: 'organisation_user_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "organisation_user" */
export type Organisation_User_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_User_Min_Fields = {
  __typename?: 'organisation_user_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "organisation_user" */
export type Organisation_User_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organisation_user" */
export type Organisation_User_Mutation_Response = {
  __typename?: 'organisation_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_User>;
};

/** on_conflict condition type for table "organisation_user" */
export type Organisation_User_On_Conflict = {
  constraint: Organisation_User_Constraint;
  update_columns?: Array<Organisation_User_Update_Column>;
  where?: InputMaybe<Organisation_User_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_user". */
export type Organisation_User_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation_user */
export type Organisation_User_Pk_Columns_Input = {
  organisation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_user" */
export enum Organisation_User_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "organisation_user" */
export type Organisation_User_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "organisation_user" */
export type Organisation_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_User_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organisation_user" */
export enum Organisation_User_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Organisation_User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organisation_User_Bool_Exp;
};

/** columns and relationships of "parent_child" */
export type Parent_Child = {
  __typename?: 'parent_child';
  /** An object relationship */
  child: Participant;
  child_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  parent: Participant;
  parent_id: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "parent_child" */
export type Parent_Child_Aggregate = {
  __typename?: 'parent_child_aggregate';
  aggregate?: Maybe<Parent_Child_Aggregate_Fields>;
  nodes: Array<Parent_Child>;
};

export type Parent_Child_Aggregate_Bool_Exp = {
  count?: InputMaybe<Parent_Child_Aggregate_Bool_Exp_Count>;
};

export type Parent_Child_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parent_Child_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parent_Child_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parent_child" */
export type Parent_Child_Aggregate_Fields = {
  __typename?: 'parent_child_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Parent_Child_Max_Fields>;
  min?: Maybe<Parent_Child_Min_Fields>;
};


/** aggregate fields of "parent_child" */
export type Parent_Child_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parent_Child_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parent_child" */
export type Parent_Child_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parent_Child_Max_Order_By>;
  min?: InputMaybe<Parent_Child_Min_Order_By>;
};

/** input type for inserting array relation for remote table "parent_child" */
export type Parent_Child_Arr_Rel_Insert_Input = {
  data: Array<Parent_Child_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parent_Child_On_Conflict>;
};

/** Boolean expression to filter rows from the table "parent_child". All fields are combined with a logical 'AND'. */
export type Parent_Child_Bool_Exp = {
  _and?: InputMaybe<Array<Parent_Child_Bool_Exp>>;
  _not?: InputMaybe<Parent_Child_Bool_Exp>;
  _or?: InputMaybe<Array<Parent_Child_Bool_Exp>>;
  child?: InputMaybe<Participant_Bool_Exp>;
  child_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  parent?: InputMaybe<Participant_Bool_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "parent_child" */
export enum Parent_Child_Constraint {
  /** unique or primary key constraint on columns "parent_id", "child_id" */
  ParentChildPkey = 'parent_child_pkey'
}

/** input type for inserting data into table "parent_child" */
export type Parent_Child_Insert_Input = {
  child?: InputMaybe<Participant_Obj_Rel_Insert_Input>;
  child_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  parent?: InputMaybe<Participant_Obj_Rel_Insert_Input>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Parent_Child_Max_Fields = {
  __typename?: 'parent_child_max_fields';
  child_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "parent_child" */
export type Parent_Child_Max_Order_By = {
  child_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parent_Child_Min_Fields = {
  __typename?: 'parent_child_min_fields';
  child_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "parent_child" */
export type Parent_Child_Min_Order_By = {
  child_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parent_child" */
export type Parent_Child_Mutation_Response = {
  __typename?: 'parent_child_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parent_Child>;
};

/** on_conflict condition type for table "parent_child" */
export type Parent_Child_On_Conflict = {
  constraint: Parent_Child_Constraint;
  update_columns?: Array<Parent_Child_Update_Column>;
  where?: InputMaybe<Parent_Child_Bool_Exp>;
};

/** Ordering options when selecting data from "parent_child". */
export type Parent_Child_Order_By = {
  child?: InputMaybe<Participant_Order_By>;
  child_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  parent?: InputMaybe<Participant_Order_By>;
  parent_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parent_child */
export type Parent_Child_Pk_Columns_Input = {
  child_id: Scalars['uuid']['input'];
  parent_id: Scalars['uuid']['input'];
};

/** select columns of table "parent_child" */
export enum Parent_Child_Select_Column {
  /** column name */
  ChildId = 'child_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "parent_child" */
export type Parent_Child_Set_Input = {
  child_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "parent_child" */
export type Parent_Child_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parent_Child_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parent_Child_Stream_Cursor_Value_Input = {
  child_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "parent_child" */
export enum Parent_Child_Update_Column {
  /** column name */
  ChildId = 'child_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Parent_Child_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parent_Child_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parent_Child_Bool_Exp;
};

/** columns and relationships of "participant" */
export type Participant = {
  __typename?: 'participant';
  _temp_child_names?: Maybe<Scalars['String']['output']>;
  _temp_id?: Maybe<Scalars['String']['output']>;
  _temp_parent_names?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  children: Array<Parent_Child>;
  /** An aggregate relationship */
  children_aggregate: Parent_Child_Aggregate;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by_user: User;
  created_by_user_id: Scalars['uuid']['output'];
  data_protection_signed: Scalars['Boolean']['output'];
  date_of_birth?: Maybe<Scalars['date']['output']>;
  date_of_birth_accuracy?: Maybe<Scalars['String']['output']>;
  date_of_first_attendance?: Maybe<Scalars['date']['output']>;
  has_disability?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  is_caregiver?: Maybe<Scalars['Boolean']['output']>;
  is_refugee?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  organisation_participants: Array<Organisation_Participant>;
  /** An aggregate relationship */
  organisation_participants_aggregate: Organisation_Participant_Aggregate;
  /** An array relationship */
  parents: Array<Parent_Child>;
  /** An aggregate relationship */
  parents_aggregate: Parent_Child_Aggregate;
  /** An array relationship */
  participant_files: Array<Participant_Files>;
  /** An aggregate relationship */
  participant_files_aggregate: Participant_Files_Aggregate;
  /** An array relationship */
  participant_languages: Array<Participant_Language>;
  /** An aggregate relationship */
  participant_languages_aggregate: Participant_Language_Aggregate;
  /** An array relationship */
  permissions: Array<User_Participant_Permissions>;
  /** An aggregate relationship */
  permissions_aggregate: User_Participant_Permissions_Aggregate;
  preferred_contact_method?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  programme_participants: Array<Programme_Participant>;
  /** An aggregate relationship */
  programme_participants_aggregate: Programme_Participant_Aggregate;
  referral_organisation?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  register_participants: Array<Register_Participant>;
  /** An aggregate relationship */
  register_participants_aggregate: Register_Participant_Aggregate;
  /** An object relationship */
  sensitive_fields?: Maybe<Participant_Sensitive_Fields>;
  sex?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  siblings: Array<Participant_Sibling>;
  /** An aggregate relationship */
  siblings_aggregate: Participant_Sibling_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "participant" */
export type ParticipantChildrenArgs = {
  distinct_on?: InputMaybe<Array<Parent_Child_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parent_Child_Order_By>>;
  where?: InputMaybe<Parent_Child_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantChildren_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parent_Child_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parent_Child_Order_By>>;
  where?: InputMaybe<Parent_Child_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantOrganisation_ParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Participant_Order_By>>;
  where?: InputMaybe<Organisation_Participant_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantOrganisation_Participants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Participant_Order_By>>;
  where?: InputMaybe<Organisation_Participant_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantParentsArgs = {
  distinct_on?: InputMaybe<Array<Parent_Child_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parent_Child_Order_By>>;
  where?: InputMaybe<Parent_Child_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parent_Child_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parent_Child_Order_By>>;
  where?: InputMaybe<Parent_Child_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantParticipant_FilesArgs = {
  distinct_on?: InputMaybe<Array<Participant_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Files_Order_By>>;
  where?: InputMaybe<Participant_Files_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantParticipant_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Files_Order_By>>;
  where?: InputMaybe<Participant_Files_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantParticipant_LanguagesArgs = {
  distinct_on?: InputMaybe<Array<Participant_Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Language_Order_By>>;
  where?: InputMaybe<Participant_Language_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantParticipant_Languages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Language_Order_By>>;
  where?: InputMaybe<Participant_Language_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantPermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Participant_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Participant_Permissions_Order_By>>;
  where?: InputMaybe<User_Participant_Permissions_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Participant_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Participant_Permissions_Order_By>>;
  where?: InputMaybe<User_Participant_Permissions_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantProgramme_ParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Programme_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Participant_Order_By>>;
  where?: InputMaybe<Programme_Participant_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantProgramme_Participants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Programme_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Participant_Order_By>>;
  where?: InputMaybe<Programme_Participant_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantRegister_ParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Order_By>>;
  where?: InputMaybe<Register_Participant_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantRegister_Participants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Order_By>>;
  where?: InputMaybe<Register_Participant_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantSiblingsArgs = {
  distinct_on?: InputMaybe<Array<Participant_Sibling_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Sibling_Order_By>>;
  where?: InputMaybe<Participant_Sibling_Bool_Exp>;
};


/** columns and relationships of "participant" */
export type ParticipantSiblings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Sibling_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Sibling_Order_By>>;
  where?: InputMaybe<Participant_Sibling_Bool_Exp>;
};

/** aggregated selection of "participant" */
export type Participant_Aggregate = {
  __typename?: 'participant_aggregate';
  aggregate?: Maybe<Participant_Aggregate_Fields>;
  nodes: Array<Participant>;
};

/** aggregate fields of "participant" */
export type Participant_Aggregate_Fields = {
  __typename?: 'participant_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Participant_Max_Fields>;
  min?: Maybe<Participant_Min_Fields>;
};


/** aggregate fields of "participant" */
export type Participant_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Participant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "participant". All fields are combined with a logical 'AND'. */
export type Participant_Bool_Exp = {
  _and?: InputMaybe<Array<Participant_Bool_Exp>>;
  _not?: InputMaybe<Participant_Bool_Exp>;
  _or?: InputMaybe<Array<Participant_Bool_Exp>>;
  _temp_child_names?: InputMaybe<String_Comparison_Exp>;
  _temp_id?: InputMaybe<String_Comparison_Exp>;
  _temp_parent_names?: InputMaybe<String_Comparison_Exp>;
  children?: InputMaybe<Parent_Child_Bool_Exp>;
  children_aggregate?: InputMaybe<Parent_Child_Aggregate_Bool_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Bool_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  data_protection_signed?: InputMaybe<Boolean_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  date_of_birth_accuracy?: InputMaybe<String_Comparison_Exp>;
  date_of_first_attendance?: InputMaybe<Date_Comparison_Exp>;
  has_disability?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_caregiver?: InputMaybe<Boolean_Comparison_Exp>;
  is_refugee?: InputMaybe<Boolean_Comparison_Exp>;
  organisation_participants?: InputMaybe<Organisation_Participant_Bool_Exp>;
  organisation_participants_aggregate?: InputMaybe<Organisation_Participant_Aggregate_Bool_Exp>;
  parents?: InputMaybe<Parent_Child_Bool_Exp>;
  parents_aggregate?: InputMaybe<Parent_Child_Aggregate_Bool_Exp>;
  participant_files?: InputMaybe<Participant_Files_Bool_Exp>;
  participant_files_aggregate?: InputMaybe<Participant_Files_Aggregate_Bool_Exp>;
  participant_languages?: InputMaybe<Participant_Language_Bool_Exp>;
  participant_languages_aggregate?: InputMaybe<Participant_Language_Aggregate_Bool_Exp>;
  permissions?: InputMaybe<User_Participant_Permissions_Bool_Exp>;
  permissions_aggregate?: InputMaybe<User_Participant_Permissions_Aggregate_Bool_Exp>;
  preferred_contact_method?: InputMaybe<String_Comparison_Exp>;
  programme_participants?: InputMaybe<Programme_Participant_Bool_Exp>;
  programme_participants_aggregate?: InputMaybe<Programme_Participant_Aggregate_Bool_Exp>;
  referral_organisation?: InputMaybe<String_Comparison_Exp>;
  register_participants?: InputMaybe<Register_Participant_Bool_Exp>;
  register_participants_aggregate?: InputMaybe<Register_Participant_Aggregate_Bool_Exp>;
  sensitive_fields?: InputMaybe<Participant_Sensitive_Fields_Bool_Exp>;
  sex?: InputMaybe<String_Comparison_Exp>;
  siblings?: InputMaybe<Participant_Sibling_Bool_Exp>;
  siblings_aggregate?: InputMaybe<Participant_Sibling_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "participant" */
export enum Participant_Constraint {
  /** unique or primary key constraint on columns "_temp_id" */
  ParticipantTempIdKey = 'participant___temp_id_key',
  /** unique or primary key constraint on columns "id" */
  ParticipantPkey = 'participant_pkey'
}

/** columns and relationships of "participant_files" */
export type Participant_Files = {
  __typename?: 'participant_files';
  created_at: Scalars['timestamptz']['output'];
  file_base64: Scalars['String']['output'];
  file_name: Scalars['String']['output'];
  file_size: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  participant: Participant;
  participant_id: Scalars['uuid']['output'];
  purpose: Scalars['String']['output'];
};

/** aggregated selection of "participant_files" */
export type Participant_Files_Aggregate = {
  __typename?: 'participant_files_aggregate';
  aggregate?: Maybe<Participant_Files_Aggregate_Fields>;
  nodes: Array<Participant_Files>;
};

export type Participant_Files_Aggregate_Bool_Exp = {
  count?: InputMaybe<Participant_Files_Aggregate_Bool_Exp_Count>;
};

export type Participant_Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Participant_Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Participant_Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "participant_files" */
export type Participant_Files_Aggregate_Fields = {
  __typename?: 'participant_files_aggregate_fields';
  avg?: Maybe<Participant_Files_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Participant_Files_Max_Fields>;
  min?: Maybe<Participant_Files_Min_Fields>;
  stddev?: Maybe<Participant_Files_Stddev_Fields>;
  stddev_pop?: Maybe<Participant_Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Participant_Files_Stddev_Samp_Fields>;
  sum?: Maybe<Participant_Files_Sum_Fields>;
  var_pop?: Maybe<Participant_Files_Var_Pop_Fields>;
  var_samp?: Maybe<Participant_Files_Var_Samp_Fields>;
  variance?: Maybe<Participant_Files_Variance_Fields>;
};


/** aggregate fields of "participant_files" */
export type Participant_Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Participant_Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "participant_files" */
export type Participant_Files_Aggregate_Order_By = {
  avg?: InputMaybe<Participant_Files_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Participant_Files_Max_Order_By>;
  min?: InputMaybe<Participant_Files_Min_Order_By>;
  stddev?: InputMaybe<Participant_Files_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Participant_Files_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Participant_Files_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Participant_Files_Sum_Order_By>;
  var_pop?: InputMaybe<Participant_Files_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Participant_Files_Var_Samp_Order_By>;
  variance?: InputMaybe<Participant_Files_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "participant_files" */
export type Participant_Files_Arr_Rel_Insert_Input = {
  data: Array<Participant_Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Participant_Files_On_Conflict>;
};

/** aggregate avg on columns */
export type Participant_Files_Avg_Fields = {
  __typename?: 'participant_files_avg_fields';
  file_size?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "participant_files" */
export type Participant_Files_Avg_Order_By = {
  file_size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "participant_files". All fields are combined with a logical 'AND'. */
export type Participant_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Participant_Files_Bool_Exp>>;
  _not?: InputMaybe<Participant_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Participant_Files_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_base64?: InputMaybe<String_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  file_size?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  participant?: InputMaybe<Participant_Bool_Exp>;
  participant_id?: InputMaybe<Uuid_Comparison_Exp>;
  purpose?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "participant_files" */
export enum Participant_Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  ParticipantGdprPkey = 'participant_gdpr_pkey'
}

/** input type for incrementing numeric columns in table "participant_files" */
export type Participant_Files_Inc_Input = {
  file_size?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "participant_files" */
export type Participant_Files_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_base64?: InputMaybe<Scalars['String']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  participant?: InputMaybe<Participant_Obj_Rel_Insert_Input>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Participant_Files_Max_Fields = {
  __typename?: 'participant_files_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  file_base64?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_size?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "participant_files" */
export type Participant_Files_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_base64?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_size?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  purpose?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Participant_Files_Min_Fields = {
  __typename?: 'participant_files_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  file_base64?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_size?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "participant_files" */
export type Participant_Files_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_base64?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_size?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  purpose?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "participant_files" */
export type Participant_Files_Mutation_Response = {
  __typename?: 'participant_files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Participant_Files>;
};

/** on_conflict condition type for table "participant_files" */
export type Participant_Files_On_Conflict = {
  constraint: Participant_Files_Constraint;
  update_columns?: Array<Participant_Files_Update_Column>;
  where?: InputMaybe<Participant_Files_Bool_Exp>;
};

/** Ordering options when selecting data from "participant_files". */
export type Participant_Files_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_base64?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_size?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participant?: InputMaybe<Participant_Order_By>;
  participant_id?: InputMaybe<Order_By>;
  purpose?: InputMaybe<Order_By>;
};

/** primary key columns input for table: participant_files */
export type Participant_Files_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "participant_files" */
export enum Participant_Files_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileBase64 = 'file_base64',
  /** column name */
  FileName = 'file_name',
  /** column name */
  FileSize = 'file_size',
  /** column name */
  Id = 'id',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  Purpose = 'purpose'
}

/** input type for updating data in table "participant_files" */
export type Participant_Files_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_base64?: InputMaybe<Scalars['String']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Participant_Files_Stddev_Fields = {
  __typename?: 'participant_files_stddev_fields';
  file_size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "participant_files" */
export type Participant_Files_Stddev_Order_By = {
  file_size?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Participant_Files_Stddev_Pop_Fields = {
  __typename?: 'participant_files_stddev_pop_fields';
  file_size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "participant_files" */
export type Participant_Files_Stddev_Pop_Order_By = {
  file_size?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Participant_Files_Stddev_Samp_Fields = {
  __typename?: 'participant_files_stddev_samp_fields';
  file_size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "participant_files" */
export type Participant_Files_Stddev_Samp_Order_By = {
  file_size?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "participant_files" */
export type Participant_Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Participant_Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Participant_Files_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_base64?: InputMaybe<Scalars['String']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Participant_Files_Sum_Fields = {
  __typename?: 'participant_files_sum_fields';
  file_size?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "participant_files" */
export type Participant_Files_Sum_Order_By = {
  file_size?: InputMaybe<Order_By>;
};

/** update columns of table "participant_files" */
export enum Participant_Files_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileBase64 = 'file_base64',
  /** column name */
  FileName = 'file_name',
  /** column name */
  FileSize = 'file_size',
  /** column name */
  Id = 'id',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  Purpose = 'purpose'
}

export type Participant_Files_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Participant_Files_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Participant_Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Participant_Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Participant_Files_Var_Pop_Fields = {
  __typename?: 'participant_files_var_pop_fields';
  file_size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "participant_files" */
export type Participant_Files_Var_Pop_Order_By = {
  file_size?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Participant_Files_Var_Samp_Fields = {
  __typename?: 'participant_files_var_samp_fields';
  file_size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "participant_files" */
export type Participant_Files_Var_Samp_Order_By = {
  file_size?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Participant_Files_Variance_Fields = {
  __typename?: 'participant_files_variance_fields';
  file_size?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "participant_files" */
export type Participant_Files_Variance_Order_By = {
  file_size?: InputMaybe<Order_By>;
};

/** input type for inserting data into table "participant" */
export type Participant_Insert_Input = {
  _temp_child_names?: InputMaybe<Scalars['String']['input']>;
  _temp_id?: InputMaybe<Scalars['String']['input']>;
  _temp_parent_names?: InputMaybe<Scalars['String']['input']>;
  children?: InputMaybe<Parent_Child_Arr_Rel_Insert_Input>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  data_protection_signed?: InputMaybe<Scalars['Boolean']['input']>;
  date_of_birth?: InputMaybe<Scalars['date']['input']>;
  date_of_birth_accuracy?: InputMaybe<Scalars['String']['input']>;
  date_of_first_attendance?: InputMaybe<Scalars['date']['input']>;
  has_disability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_caregiver?: InputMaybe<Scalars['Boolean']['input']>;
  is_refugee?: InputMaybe<Scalars['Boolean']['input']>;
  organisation_participants?: InputMaybe<Organisation_Participant_Arr_Rel_Insert_Input>;
  parents?: InputMaybe<Parent_Child_Arr_Rel_Insert_Input>;
  participant_files?: InputMaybe<Participant_Files_Arr_Rel_Insert_Input>;
  participant_languages?: InputMaybe<Participant_Language_Arr_Rel_Insert_Input>;
  permissions?: InputMaybe<User_Participant_Permissions_Arr_Rel_Insert_Input>;
  preferred_contact_method?: InputMaybe<Scalars['String']['input']>;
  programme_participants?: InputMaybe<Programme_Participant_Arr_Rel_Insert_Input>;
  referral_organisation?: InputMaybe<Scalars['String']['input']>;
  register_participants?: InputMaybe<Register_Participant_Arr_Rel_Insert_Input>;
  sensitive_fields?: InputMaybe<Participant_Sensitive_Fields_Obj_Rel_Insert_Input>;
  sex?: InputMaybe<Scalars['String']['input']>;
  siblings?: InputMaybe<Participant_Sibling_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "participant_language" */
export type Participant_Language = {
  __typename?: 'participant_language';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  language: Language;
  language_code: Scalars['String']['output'];
  /** An object relationship */
  participant: Participant;
  participant_id: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "participant_language" */
export type Participant_Language_Aggregate = {
  __typename?: 'participant_language_aggregate';
  aggregate?: Maybe<Participant_Language_Aggregate_Fields>;
  nodes: Array<Participant_Language>;
};

export type Participant_Language_Aggregate_Bool_Exp = {
  count?: InputMaybe<Participant_Language_Aggregate_Bool_Exp_Count>;
};

export type Participant_Language_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Participant_Language_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Participant_Language_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "participant_language" */
export type Participant_Language_Aggregate_Fields = {
  __typename?: 'participant_language_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Participant_Language_Max_Fields>;
  min?: Maybe<Participant_Language_Min_Fields>;
};


/** aggregate fields of "participant_language" */
export type Participant_Language_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Participant_Language_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "participant_language" */
export type Participant_Language_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Participant_Language_Max_Order_By>;
  min?: InputMaybe<Participant_Language_Min_Order_By>;
};

/** input type for inserting array relation for remote table "participant_language" */
export type Participant_Language_Arr_Rel_Insert_Input = {
  data: Array<Participant_Language_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Participant_Language_On_Conflict>;
};

/** Boolean expression to filter rows from the table "participant_language". All fields are combined with a logical 'AND'. */
export type Participant_Language_Bool_Exp = {
  _and?: InputMaybe<Array<Participant_Language_Bool_Exp>>;
  _not?: InputMaybe<Participant_Language_Bool_Exp>;
  _or?: InputMaybe<Array<Participant_Language_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  language?: InputMaybe<Language_Bool_Exp>;
  language_code?: InputMaybe<String_Comparison_Exp>;
  participant?: InputMaybe<Participant_Bool_Exp>;
  participant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "participant_language" */
export enum Participant_Language_Constraint {
  /** unique or primary key constraint on columns "language_code", "participant_id" */
  ParticipantLanguagePkey = 'participant_language_pkey'
}

/** input type for inserting data into table "participant_language" */
export type Participant_Language_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  language?: InputMaybe<Language_Obj_Rel_Insert_Input>;
  language_code?: InputMaybe<Scalars['String']['input']>;
  participant?: InputMaybe<Participant_Obj_Rel_Insert_Input>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Participant_Language_Max_Fields = {
  __typename?: 'participant_language_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  language_code?: Maybe<Scalars['String']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "participant_language" */
export type Participant_Language_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  language_code?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Participant_Language_Min_Fields = {
  __typename?: 'participant_language_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  language_code?: Maybe<Scalars['String']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "participant_language" */
export type Participant_Language_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  language_code?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "participant_language" */
export type Participant_Language_Mutation_Response = {
  __typename?: 'participant_language_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Participant_Language>;
};

/** on_conflict condition type for table "participant_language" */
export type Participant_Language_On_Conflict = {
  constraint: Participant_Language_Constraint;
  update_columns?: Array<Participant_Language_Update_Column>;
  where?: InputMaybe<Participant_Language_Bool_Exp>;
};

/** Ordering options when selecting data from "participant_language". */
export type Participant_Language_Order_By = {
  created_at?: InputMaybe<Order_By>;
  language?: InputMaybe<Language_Order_By>;
  language_code?: InputMaybe<Order_By>;
  participant?: InputMaybe<Participant_Order_By>;
  participant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: participant_language */
export type Participant_Language_Pk_Columns_Input = {
  language_code: Scalars['String']['input'];
  participant_id: Scalars['uuid']['input'];
};

/** select columns of table "participant_language" */
export enum Participant_Language_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LanguageCode = 'language_code',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "participant_language" */
export type Participant_Language_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  language_code?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "participant_language" */
export type Participant_Language_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Participant_Language_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Participant_Language_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  language_code?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "participant_language" */
export enum Participant_Language_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LanguageCode = 'language_code',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Participant_Language_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Participant_Language_Set_Input>;
  /** filter the rows which have to be updated */
  where: Participant_Language_Bool_Exp;
};

/** aggregate max on columns */
export type Participant_Max_Fields = {
  __typename?: 'participant_max_fields';
  _temp_child_names?: Maybe<Scalars['String']['output']>;
  _temp_id?: Maybe<Scalars['String']['output']>;
  _temp_parent_names?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  date_of_birth?: Maybe<Scalars['date']['output']>;
  date_of_birth_accuracy?: Maybe<Scalars['String']['output']>;
  date_of_first_attendance?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  preferred_contact_method?: Maybe<Scalars['String']['output']>;
  referral_organisation?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Participant_Min_Fields = {
  __typename?: 'participant_min_fields';
  _temp_child_names?: Maybe<Scalars['String']['output']>;
  _temp_id?: Maybe<Scalars['String']['output']>;
  _temp_parent_names?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  date_of_birth?: Maybe<Scalars['date']['output']>;
  date_of_birth_accuracy?: Maybe<Scalars['String']['output']>;
  date_of_first_attendance?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  preferred_contact_method?: Maybe<Scalars['String']['output']>;
  referral_organisation?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "participant" */
export type Participant_Mutation_Response = {
  __typename?: 'participant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Participant>;
};

/** input type for inserting object relation for remote table "participant" */
export type Participant_Obj_Rel_Insert_Input = {
  data: Participant_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Participant_On_Conflict>;
};

/** on_conflict condition type for table "participant" */
export type Participant_On_Conflict = {
  constraint: Participant_Constraint;
  update_columns?: Array<Participant_Update_Column>;
  where?: InputMaybe<Participant_Bool_Exp>;
};

/** Ordering options when selecting data from "participant". */
export type Participant_Order_By = {
  _temp_child_names?: InputMaybe<Order_By>;
  _temp_id?: InputMaybe<Order_By>;
  _temp_parent_names?: InputMaybe<Order_By>;
  children_aggregate?: InputMaybe<Parent_Child_Aggregate_Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  data_protection_signed?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  date_of_birth_accuracy?: InputMaybe<Order_By>;
  date_of_first_attendance?: InputMaybe<Order_By>;
  has_disability?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_caregiver?: InputMaybe<Order_By>;
  is_refugee?: InputMaybe<Order_By>;
  organisation_participants_aggregate?: InputMaybe<Organisation_Participant_Aggregate_Order_By>;
  parents_aggregate?: InputMaybe<Parent_Child_Aggregate_Order_By>;
  participant_files_aggregate?: InputMaybe<Participant_Files_Aggregate_Order_By>;
  participant_languages_aggregate?: InputMaybe<Participant_Language_Aggregate_Order_By>;
  permissions_aggregate?: InputMaybe<User_Participant_Permissions_Aggregate_Order_By>;
  preferred_contact_method?: InputMaybe<Order_By>;
  programme_participants_aggregate?: InputMaybe<Programme_Participant_Aggregate_Order_By>;
  referral_organisation?: InputMaybe<Order_By>;
  register_participants_aggregate?: InputMaybe<Register_Participant_Aggregate_Order_By>;
  sensitive_fields?: InputMaybe<Participant_Sensitive_Fields_Order_By>;
  sex?: InputMaybe<Order_By>;
  siblings_aggregate?: InputMaybe<Participant_Sibling_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: participant */
export type Participant_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

export type Participant_Search_By_Name_Args = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type Participant_Search_By_Name_Sensitive_Args = {
  search?: InputMaybe<Scalars['String']['input']>;
};

/** select columns of table "participant" */
export enum Participant_Select_Column {
  /** column name */
  TempChildNames = '_temp_child_names',
  /** column name */
  TempId = '_temp_id',
  /** column name */
  TempParentNames = '_temp_parent_names',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DataProtectionSigned = 'data_protection_signed',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  DateOfBirthAccuracy = 'date_of_birth_accuracy',
  /** column name */
  DateOfFirstAttendance = 'date_of_first_attendance',
  /** column name */
  HasDisability = 'has_disability',
  /** column name */
  Id = 'id',
  /** column name */
  IsCaregiver = 'is_caregiver',
  /** column name */
  IsRefugee = 'is_refugee',
  /** column name */
  PreferredContactMethod = 'preferred_contact_method',
  /** column name */
  ReferralOrganisation = 'referral_organisation',
  /** column name */
  Sex = 'sex',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** keep sensitive fields separate, so that we can make permission on participant more lax */
export type Participant_Sensitive_Fields = {
  __typename?: 'participant_sensitive_fields';
  created_at: Scalars['timestamptz']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emergency_contact_detail?: Maybe<Scalars['String']['output']>;
  emergency_contact_name?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  participant: Participant;
  participant_id: Scalars['uuid']['output'];
  /** An array relationship */
  permissions: Array<User_Participant_Permissions>;
  /** An aggregate relationship */
  permissions_aggregate: User_Participant_Permissions_Aggregate;
  phone?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** keep sensitive fields separate, so that we can make permission on participant more lax */
export type Participant_Sensitive_FieldsPermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Participant_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Participant_Permissions_Order_By>>;
  where?: InputMaybe<User_Participant_Permissions_Bool_Exp>;
};


/** keep sensitive fields separate, so that we can make permission on participant more lax */
export type Participant_Sensitive_FieldsPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Participant_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Participant_Permissions_Order_By>>;
  where?: InputMaybe<User_Participant_Permissions_Bool_Exp>;
};

export type Participant_Sensitive_Fields_Aggregate = {
  __typename?: 'participant_sensitive_fields_aggregate';
  aggregate?: Maybe<Participant_Sensitive_Fields_Aggregate_Fields>;
  nodes: Array<Participant_Sensitive_Fields>;
};

/** aggregate fields of "participant_sensitive_fields" */
export type Participant_Sensitive_Fields_Aggregate_Fields = {
  __typename?: 'participant_sensitive_fields_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Participant_Sensitive_Fields_Max_Fields>;
  min?: Maybe<Participant_Sensitive_Fields_Min_Fields>;
};


/** aggregate fields of "participant_sensitive_fields" */
export type Participant_Sensitive_Fields_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Participant_Sensitive_Fields_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "participant_sensitive_fields". All fields are combined with a logical 'AND'. */
export type Participant_Sensitive_Fields_Bool_Exp = {
  _and?: InputMaybe<Array<Participant_Sensitive_Fields_Bool_Exp>>;
  _not?: InputMaybe<Participant_Sensitive_Fields_Bool_Exp>;
  _or?: InputMaybe<Array<Participant_Sensitive_Fields_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  emergency_contact_detail?: InputMaybe<String_Comparison_Exp>;
  emergency_contact_name?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  participant?: InputMaybe<Participant_Bool_Exp>;
  participant_id?: InputMaybe<Uuid_Comparison_Exp>;
  permissions?: InputMaybe<User_Participant_Permissions_Bool_Exp>;
  permissions_aggregate?: InputMaybe<User_Participant_Permissions_Aggregate_Bool_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "participant_sensitive_fields" */
export enum Participant_Sensitive_Fields_Constraint {
  /** unique or primary key constraint on columns "participant_id" */
  ParticipantSensitiveFieldsPkey = 'participant_sensitive_fields_pkey'
}

/** input type for inserting data into table "participant_sensitive_fields" */
export type Participant_Sensitive_Fields_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_detail?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_name?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  participant?: InputMaybe<Participant_Obj_Rel_Insert_Input>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  permissions?: InputMaybe<User_Participant_Permissions_Arr_Rel_Insert_Input>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Participant_Sensitive_Fields_Max_Fields = {
  __typename?: 'participant_sensitive_fields_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emergency_contact_detail?: Maybe<Scalars['String']['output']>;
  emergency_contact_name?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Participant_Sensitive_Fields_Min_Fields = {
  __typename?: 'participant_sensitive_fields_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emergency_contact_detail?: Maybe<Scalars['String']['output']>;
  emergency_contact_name?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "participant_sensitive_fields" */
export type Participant_Sensitive_Fields_Mutation_Response = {
  __typename?: 'participant_sensitive_fields_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Participant_Sensitive_Fields>;
};

/** input type for inserting object relation for remote table "participant_sensitive_fields" */
export type Participant_Sensitive_Fields_Obj_Rel_Insert_Input = {
  data: Participant_Sensitive_Fields_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Participant_Sensitive_Fields_On_Conflict>;
};

/** on_conflict condition type for table "participant_sensitive_fields" */
export type Participant_Sensitive_Fields_On_Conflict = {
  constraint: Participant_Sensitive_Fields_Constraint;
  update_columns?: Array<Participant_Sensitive_Fields_Update_Column>;
  where?: InputMaybe<Participant_Sensitive_Fields_Bool_Exp>;
};

/** Ordering options when selecting data from "participant_sensitive_fields". */
export type Participant_Sensitive_Fields_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  emergency_contact_detail?: InputMaybe<Order_By>;
  emergency_contact_name?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  participant?: InputMaybe<Participant_Order_By>;
  participant_id?: InputMaybe<Order_By>;
  permissions_aggregate?: InputMaybe<User_Participant_Permissions_Aggregate_Order_By>;
  phone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: participant_sensitive_fields */
export type Participant_Sensitive_Fields_Pk_Columns_Input = {
  participant_id: Scalars['uuid']['input'];
};

/** select columns of table "participant_sensitive_fields" */
export enum Participant_Sensitive_Fields_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmergencyContactDetail = 'emergency_contact_detail',
  /** column name */
  EmergencyContactName = 'emergency_contact_name',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Notes = 'notes',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "participant_sensitive_fields" */
export type Participant_Sensitive_Fields_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_detail?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_name?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "participant_sensitive_fields" */
export type Participant_Sensitive_Fields_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Participant_Sensitive_Fields_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Participant_Sensitive_Fields_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_detail?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_name?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "participant_sensitive_fields" */
export enum Participant_Sensitive_Fields_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmergencyContactDetail = 'emergency_contact_detail',
  /** column name */
  EmergencyContactName = 'emergency_contact_name',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Notes = 'notes',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Participant_Sensitive_Fields_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Participant_Sensitive_Fields_Set_Input>;
  /** filter the rows which have to be updated */
  where: Participant_Sensitive_Fields_Bool_Exp;
};

/** input type for updating data in table "participant" */
export type Participant_Set_Input = {
  _temp_child_names?: InputMaybe<Scalars['String']['input']>;
  _temp_id?: InputMaybe<Scalars['String']['input']>;
  _temp_parent_names?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  data_protection_signed?: InputMaybe<Scalars['Boolean']['input']>;
  date_of_birth?: InputMaybe<Scalars['date']['input']>;
  date_of_birth_accuracy?: InputMaybe<Scalars['String']['input']>;
  date_of_first_attendance?: InputMaybe<Scalars['date']['input']>;
  has_disability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_caregiver?: InputMaybe<Scalars['Boolean']['input']>;
  is_refugee?: InputMaybe<Scalars['Boolean']['input']>;
  preferred_contact_method?: InputMaybe<Scalars['String']['input']>;
  referral_organisation?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "participant_sibling" */
export type Participant_Sibling = {
  __typename?: 'participant_sibling';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  participant_id: Scalars['uuid']['output'];
  /** An object relationship */
  sibling: Participant;
  sibling_id: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "participant_sibling" */
export type Participant_Sibling_Aggregate = {
  __typename?: 'participant_sibling_aggregate';
  aggregate?: Maybe<Participant_Sibling_Aggregate_Fields>;
  nodes: Array<Participant_Sibling>;
};

export type Participant_Sibling_Aggregate_Bool_Exp = {
  count?: InputMaybe<Participant_Sibling_Aggregate_Bool_Exp_Count>;
};

export type Participant_Sibling_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Participant_Sibling_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Participant_Sibling_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "participant_sibling" */
export type Participant_Sibling_Aggregate_Fields = {
  __typename?: 'participant_sibling_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Participant_Sibling_Max_Fields>;
  min?: Maybe<Participant_Sibling_Min_Fields>;
};


/** aggregate fields of "participant_sibling" */
export type Participant_Sibling_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Participant_Sibling_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "participant_sibling" */
export type Participant_Sibling_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Participant_Sibling_Max_Order_By>;
  min?: InputMaybe<Participant_Sibling_Min_Order_By>;
};

/** input type for inserting array relation for remote table "participant_sibling" */
export type Participant_Sibling_Arr_Rel_Insert_Input = {
  data: Array<Participant_Sibling_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Participant_Sibling_On_Conflict>;
};

/** Boolean expression to filter rows from the table "participant_sibling". All fields are combined with a logical 'AND'. */
export type Participant_Sibling_Bool_Exp = {
  _and?: InputMaybe<Array<Participant_Sibling_Bool_Exp>>;
  _not?: InputMaybe<Participant_Sibling_Bool_Exp>;
  _or?: InputMaybe<Array<Participant_Sibling_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  participant_id?: InputMaybe<Uuid_Comparison_Exp>;
  sibling?: InputMaybe<Participant_Bool_Exp>;
  sibling_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "participant_sibling" */
export enum Participant_Sibling_Constraint {
  /** unique or primary key constraint on columns "sibling_id", "participant_id" */
  ParticipantSiblingPkey = 'participant_sibling_pkey'
}

/** input type for inserting data into table "participant_sibling" */
export type Participant_Sibling_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  sibling?: InputMaybe<Participant_Obj_Rel_Insert_Input>;
  sibling_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Participant_Sibling_Max_Fields = {
  __typename?: 'participant_sibling_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  sibling_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "participant_sibling" */
export type Participant_Sibling_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  sibling_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Participant_Sibling_Min_Fields = {
  __typename?: 'participant_sibling_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  sibling_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "participant_sibling" */
export type Participant_Sibling_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  sibling_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "participant_sibling" */
export type Participant_Sibling_Mutation_Response = {
  __typename?: 'participant_sibling_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Participant_Sibling>;
};

/** on_conflict condition type for table "participant_sibling" */
export type Participant_Sibling_On_Conflict = {
  constraint: Participant_Sibling_Constraint;
  update_columns?: Array<Participant_Sibling_Update_Column>;
  where?: InputMaybe<Participant_Sibling_Bool_Exp>;
};

/** Ordering options when selecting data from "participant_sibling". */
export type Participant_Sibling_Order_By = {
  created_at?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  sibling?: InputMaybe<Participant_Order_By>;
  sibling_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: participant_sibling */
export type Participant_Sibling_Pk_Columns_Input = {
  participant_id: Scalars['uuid']['input'];
  sibling_id: Scalars['uuid']['input'];
};

/** select columns of table "participant_sibling" */
export enum Participant_Sibling_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  SiblingId = 'sibling_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "participant_sibling" */
export type Participant_Sibling_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  sibling_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "participant_sibling" */
export type Participant_Sibling_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Participant_Sibling_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Participant_Sibling_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  sibling_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "participant_sibling" */
export enum Participant_Sibling_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  SiblingId = 'sibling_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Participant_Sibling_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Participant_Sibling_Set_Input>;
  /** filter the rows which have to be updated */
  where: Participant_Sibling_Bool_Exp;
};

/** Streaming cursor of the table "participant" */
export type Participant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Participant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Participant_Stream_Cursor_Value_Input = {
  _temp_child_names?: InputMaybe<Scalars['String']['input']>;
  _temp_id?: InputMaybe<Scalars['String']['input']>;
  _temp_parent_names?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  data_protection_signed?: InputMaybe<Scalars['Boolean']['input']>;
  date_of_birth?: InputMaybe<Scalars['date']['input']>;
  date_of_birth_accuracy?: InputMaybe<Scalars['String']['input']>;
  date_of_first_attendance?: InputMaybe<Scalars['date']['input']>;
  has_disability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_caregiver?: InputMaybe<Scalars['Boolean']['input']>;
  is_refugee?: InputMaybe<Scalars['Boolean']['input']>;
  preferred_contact_method?: InputMaybe<Scalars['String']['input']>;
  referral_organisation?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "participant" */
export enum Participant_Update_Column {
  /** column name */
  TempChildNames = '_temp_child_names',
  /** column name */
  TempId = '_temp_id',
  /** column name */
  TempParentNames = '_temp_parent_names',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DataProtectionSigned = 'data_protection_signed',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  DateOfBirthAccuracy = 'date_of_birth_accuracy',
  /** column name */
  DateOfFirstAttendance = 'date_of_first_attendance',
  /** column name */
  HasDisability = 'has_disability',
  /** column name */
  Id = 'id',
  /** column name */
  IsCaregiver = 'is_caregiver',
  /** column name */
  IsRefugee = 'is_refugee',
  /** column name */
  PreferredContactMethod = 'preferred_contact_method',
  /** column name */
  ReferralOrganisation = 'referral_organisation',
  /** column name */
  Sex = 'sex',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Participant_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Participant_Set_Input>;
  /** filter the rows which have to be updated */
  where: Participant_Bool_Exp;
};

/** columns and relationships of "programme" */
export type Programme = {
  __typename?: 'programme';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  organisation_programmes: Array<Organisation_Programme>;
  /** An aggregate relationship */
  organisation_programmes_aggregate: Organisation_Programme_Aggregate;
  /** An object relationship */
  programme_group?: Maybe<Programme_Group>;
  programme_group_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  programme_locations: Array<Programme_Location>;
  /** An aggregate relationship */
  programme_locations_aggregate: Programme_Location_Aggregate;
  /** An array relationship */
  programme_participants: Array<Programme_Participant>;
  /** An aggregate relationship */
  programme_participants_aggregate: Programme_Participant_Aggregate;
  /** An array relationship */
  projects: Array<Project>;
  /** An aggregate relationship */
  projects_aggregate: Project_Aggregate;
  slug: Scalars['String']['output'];
  start_date?: Maybe<Scalars['date']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "programme" */
export type ProgrammeOrganisation_ProgrammesArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Programme_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Programme_Order_By>>;
  where?: InputMaybe<Organisation_Programme_Bool_Exp>;
};


/** columns and relationships of "programme" */
export type ProgrammeOrganisation_Programmes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Programme_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Programme_Order_By>>;
  where?: InputMaybe<Organisation_Programme_Bool_Exp>;
};


/** columns and relationships of "programme" */
export type ProgrammeProgramme_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Programme_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Location_Order_By>>;
  where?: InputMaybe<Programme_Location_Bool_Exp>;
};


/** columns and relationships of "programme" */
export type ProgrammeProgramme_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Programme_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Location_Order_By>>;
  where?: InputMaybe<Programme_Location_Bool_Exp>;
};


/** columns and relationships of "programme" */
export type ProgrammeProgramme_ParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Programme_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Participant_Order_By>>;
  where?: InputMaybe<Programme_Participant_Bool_Exp>;
};


/** columns and relationships of "programme" */
export type ProgrammeProgramme_Participants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Programme_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Participant_Order_By>>;
  where?: InputMaybe<Programme_Participant_Bool_Exp>;
};


/** columns and relationships of "programme" */
export type ProgrammeProjectsArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


/** columns and relationships of "programme" */
export type ProgrammeProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};

/** aggregated selection of "programme" */
export type Programme_Aggregate = {
  __typename?: 'programme_aggregate';
  aggregate?: Maybe<Programme_Aggregate_Fields>;
  nodes: Array<Programme>;
};

export type Programme_Aggregate_Bool_Exp = {
  count?: InputMaybe<Programme_Aggregate_Bool_Exp_Count>;
};

export type Programme_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Programme_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Programme_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "programme" */
export type Programme_Aggregate_Fields = {
  __typename?: 'programme_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Programme_Max_Fields>;
  min?: Maybe<Programme_Min_Fields>;
};


/** aggregate fields of "programme" */
export type Programme_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Programme_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "programme" */
export type Programme_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Programme_Max_Order_By>;
  min?: InputMaybe<Programme_Min_Order_By>;
};

/** input type for inserting array relation for remote table "programme" */
export type Programme_Arr_Rel_Insert_Input = {
  data: Array<Programme_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Programme_On_Conflict>;
};

/** Boolean expression to filter rows from the table "programme". All fields are combined with a logical 'AND'. */
export type Programme_Bool_Exp = {
  _and?: InputMaybe<Array<Programme_Bool_Exp>>;
  _not?: InputMaybe<Programme_Bool_Exp>;
  _or?: InputMaybe<Array<Programme_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation_programmes?: InputMaybe<Organisation_Programme_Bool_Exp>;
  organisation_programmes_aggregate?: InputMaybe<Organisation_Programme_Aggregate_Bool_Exp>;
  programme_group?: InputMaybe<Programme_Group_Bool_Exp>;
  programme_group_id?: InputMaybe<Uuid_Comparison_Exp>;
  programme_locations?: InputMaybe<Programme_Location_Bool_Exp>;
  programme_locations_aggregate?: InputMaybe<Programme_Location_Aggregate_Bool_Exp>;
  programme_participants?: InputMaybe<Programme_Participant_Bool_Exp>;
  programme_participants_aggregate?: InputMaybe<Programme_Participant_Aggregate_Bool_Exp>;
  projects?: InputMaybe<Project_Bool_Exp>;
  projects_aggregate?: InputMaybe<Project_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "programme" */
export enum Programme_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProgrammePkey = 'programme_pkey',
  /** unique or primary key constraint on columns "slug" */
  ProgrammeSlugKey = 'programme_slug_key'
}

/** columns and relationships of "programme_group" */
export type Programme_Group = {
  __typename?: 'programme_group';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  programmes: Array<Programme>;
  /** An aggregate relationship */
  programmes_aggregate: Programme_Aggregate;
  slug: Scalars['String']['output'];
};


/** columns and relationships of "programme_group" */
export type Programme_GroupProgrammesArgs = {
  distinct_on?: InputMaybe<Array<Programme_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Order_By>>;
  where?: InputMaybe<Programme_Bool_Exp>;
};


/** columns and relationships of "programme_group" */
export type Programme_GroupProgrammes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Programme_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Order_By>>;
  where?: InputMaybe<Programme_Bool_Exp>;
};

/** aggregated selection of "programme_group" */
export type Programme_Group_Aggregate = {
  __typename?: 'programme_group_aggregate';
  aggregate?: Maybe<Programme_Group_Aggregate_Fields>;
  nodes: Array<Programme_Group>;
};

/** aggregate fields of "programme_group" */
export type Programme_Group_Aggregate_Fields = {
  __typename?: 'programme_group_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Programme_Group_Max_Fields>;
  min?: Maybe<Programme_Group_Min_Fields>;
};


/** aggregate fields of "programme_group" */
export type Programme_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Programme_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "programme_group". All fields are combined with a logical 'AND'. */
export type Programme_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Programme_Group_Bool_Exp>>;
  _not?: InputMaybe<Programme_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Programme_Group_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  programmes?: InputMaybe<Programme_Bool_Exp>;
  programmes_aggregate?: InputMaybe<Programme_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "programme_group" */
export enum Programme_Group_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProgrammeGroupPkey = 'programme_group_pkey',
  /** unique or primary key constraint on columns "slug" */
  ProgrammeGroupSlugKey = 'programme_group_slug_key'
}

/** input type for inserting data into table "programme_group" */
export type Programme_Group_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  programmes?: InputMaybe<Programme_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Programme_Group_Max_Fields = {
  __typename?: 'programme_group_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Programme_Group_Min_Fields = {
  __typename?: 'programme_group_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "programme_group" */
export type Programme_Group_Mutation_Response = {
  __typename?: 'programme_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Programme_Group>;
};

/** input type for inserting object relation for remote table "programme_group" */
export type Programme_Group_Obj_Rel_Insert_Input = {
  data: Programme_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Programme_Group_On_Conflict>;
};

/** on_conflict condition type for table "programme_group" */
export type Programme_Group_On_Conflict = {
  constraint: Programme_Group_Constraint;
  update_columns?: Array<Programme_Group_Update_Column>;
  where?: InputMaybe<Programme_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "programme_group". */
export type Programme_Group_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  programmes_aggregate?: InputMaybe<Programme_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** primary key columns input for table: programme_group */
export type Programme_Group_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "programme_group" */
export enum Programme_Group_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "programme_group" */
export type Programme_Group_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "programme_group" */
export type Programme_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Programme_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Programme_Group_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "programme_group" */
export enum Programme_Group_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

export type Programme_Group_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Programme_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Programme_Group_Bool_Exp;
};

/** input type for inserting data into table "programme" */
export type Programme_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_programmes?: InputMaybe<Organisation_Programme_Arr_Rel_Insert_Input>;
  programme_group?: InputMaybe<Programme_Group_Obj_Rel_Insert_Input>;
  programme_group_id?: InputMaybe<Scalars['uuid']['input']>;
  programme_locations?: InputMaybe<Programme_Location_Arr_Rel_Insert_Input>;
  programme_participants?: InputMaybe<Programme_Participant_Arr_Rel_Insert_Input>;
  projects?: InputMaybe<Project_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "programme_location" */
export type Programme_Location = {
  __typename?: 'programme_location';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  location: Location;
  location_id: Scalars['uuid']['output'];
  /** An object relationship */
  programme: Programme;
  programme_id: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "programme_location" */
export type Programme_Location_Aggregate = {
  __typename?: 'programme_location_aggregate';
  aggregate?: Maybe<Programme_Location_Aggregate_Fields>;
  nodes: Array<Programme_Location>;
};

export type Programme_Location_Aggregate_Bool_Exp = {
  count?: InputMaybe<Programme_Location_Aggregate_Bool_Exp_Count>;
};

export type Programme_Location_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Programme_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Programme_Location_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "programme_location" */
export type Programme_Location_Aggregate_Fields = {
  __typename?: 'programme_location_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Programme_Location_Max_Fields>;
  min?: Maybe<Programme_Location_Min_Fields>;
};


/** aggregate fields of "programme_location" */
export type Programme_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Programme_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "programme_location" */
export type Programme_Location_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Programme_Location_Max_Order_By>;
  min?: InputMaybe<Programme_Location_Min_Order_By>;
};

/** input type for inserting array relation for remote table "programme_location" */
export type Programme_Location_Arr_Rel_Insert_Input = {
  data: Array<Programme_Location_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Programme_Location_On_Conflict>;
};

/** Boolean expression to filter rows from the table "programme_location". All fields are combined with a logical 'AND'. */
export type Programme_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Programme_Location_Bool_Exp>>;
  _not?: InputMaybe<Programme_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Programme_Location_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  location?: InputMaybe<Location_Bool_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  programme?: InputMaybe<Programme_Bool_Exp>;
  programme_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "programme_location" */
export enum Programme_Location_Constraint {
  /** unique or primary key constraint on columns "programme_id", "location_id" */
  ProgrammeCentrePkey = 'programme_centre_pkey'
}

/** input type for inserting data into table "programme_location" */
export type Programme_Location_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  location?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  programme?: InputMaybe<Programme_Obj_Rel_Insert_Input>;
  programme_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Programme_Location_Max_Fields = {
  __typename?: 'programme_location_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  programme_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "programme_location" */
export type Programme_Location_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  programme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Programme_Location_Min_Fields = {
  __typename?: 'programme_location_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  programme_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "programme_location" */
export type Programme_Location_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  programme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "programme_location" */
export type Programme_Location_Mutation_Response = {
  __typename?: 'programme_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Programme_Location>;
};

/** on_conflict condition type for table "programme_location" */
export type Programme_Location_On_Conflict = {
  constraint: Programme_Location_Constraint;
  update_columns?: Array<Programme_Location_Update_Column>;
  where?: InputMaybe<Programme_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "programme_location". */
export type Programme_Location_Order_By = {
  created_at?: InputMaybe<Order_By>;
  location?: InputMaybe<Location_Order_By>;
  location_id?: InputMaybe<Order_By>;
  programme?: InputMaybe<Programme_Order_By>;
  programme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: programme_location */
export type Programme_Location_Pk_Columns_Input = {
  location_id: Scalars['uuid']['input'];
  programme_id: Scalars['uuid']['input'];
};

/** select columns of table "programme_location" */
export enum Programme_Location_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  ProgrammeId = 'programme_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "programme_location" */
export type Programme_Location_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  programme_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "programme_location" */
export type Programme_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Programme_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Programme_Location_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  programme_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "programme_location" */
export enum Programme_Location_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  ProgrammeId = 'programme_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Programme_Location_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Programme_Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: Programme_Location_Bool_Exp;
};

/** aggregate max on columns */
export type Programme_Max_Fields = {
  __typename?: 'programme_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  programme_group_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "programme" */
export type Programme_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  programme_group_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Programme_Min_Fields = {
  __typename?: 'programme_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  programme_group_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "programme" */
export type Programme_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  programme_group_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "programme" */
export type Programme_Mutation_Response = {
  __typename?: 'programme_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Programme>;
};

/** input type for inserting object relation for remote table "programme" */
export type Programme_Obj_Rel_Insert_Input = {
  data: Programme_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Programme_On_Conflict>;
};

/** on_conflict condition type for table "programme" */
export type Programme_On_Conflict = {
  constraint: Programme_Constraint;
  update_columns?: Array<Programme_Update_Column>;
  where?: InputMaybe<Programme_Bool_Exp>;
};

/** Ordering options when selecting data from "programme". */
export type Programme_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_programmes_aggregate?: InputMaybe<Organisation_Programme_Aggregate_Order_By>;
  programme_group?: InputMaybe<Programme_Group_Order_By>;
  programme_group_id?: InputMaybe<Order_By>;
  programme_locations_aggregate?: InputMaybe<Programme_Location_Aggregate_Order_By>;
  programme_participants_aggregate?: InputMaybe<Programme_Participant_Aggregate_Order_By>;
  projects_aggregate?: InputMaybe<Project_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** columns and relationships of "programme_participant" */
export type Programme_Participant = {
  __typename?: 'programme_participant';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  participant: Participant;
  participant_id: Scalars['uuid']['output'];
  /** An object relationship */
  programme: Programme;
  programme_id: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "programme_participant" */
export type Programme_Participant_Aggregate = {
  __typename?: 'programme_participant_aggregate';
  aggregate?: Maybe<Programme_Participant_Aggregate_Fields>;
  nodes: Array<Programme_Participant>;
};

export type Programme_Participant_Aggregate_Bool_Exp = {
  count?: InputMaybe<Programme_Participant_Aggregate_Bool_Exp_Count>;
};

export type Programme_Participant_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Programme_Participant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Programme_Participant_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "programme_participant" */
export type Programme_Participant_Aggregate_Fields = {
  __typename?: 'programme_participant_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Programme_Participant_Max_Fields>;
  min?: Maybe<Programme_Participant_Min_Fields>;
};


/** aggregate fields of "programme_participant" */
export type Programme_Participant_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Programme_Participant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "programme_participant" */
export type Programme_Participant_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Programme_Participant_Max_Order_By>;
  min?: InputMaybe<Programme_Participant_Min_Order_By>;
};

/** input type for inserting array relation for remote table "programme_participant" */
export type Programme_Participant_Arr_Rel_Insert_Input = {
  data: Array<Programme_Participant_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Programme_Participant_On_Conflict>;
};

/** Boolean expression to filter rows from the table "programme_participant". All fields are combined with a logical 'AND'. */
export type Programme_Participant_Bool_Exp = {
  _and?: InputMaybe<Array<Programme_Participant_Bool_Exp>>;
  _not?: InputMaybe<Programme_Participant_Bool_Exp>;
  _or?: InputMaybe<Array<Programme_Participant_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  participant?: InputMaybe<Participant_Bool_Exp>;
  participant_id?: InputMaybe<Uuid_Comparison_Exp>;
  programme?: InputMaybe<Programme_Bool_Exp>;
  programme_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "programme_participant" */
export enum Programme_Participant_Constraint {
  /** unique or primary key constraint on columns "participant_id", "programme_id" */
  ProgrammeParticipantPkey = 'programme_participant_pkey'
}

/** input type for inserting data into table "programme_participant" */
export type Programme_Participant_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  participant?: InputMaybe<Participant_Obj_Rel_Insert_Input>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  programme?: InputMaybe<Programme_Obj_Rel_Insert_Input>;
  programme_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Programme_Participant_Max_Fields = {
  __typename?: 'programme_participant_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  programme_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "programme_participant" */
export type Programme_Participant_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  programme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Programme_Participant_Min_Fields = {
  __typename?: 'programme_participant_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  programme_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "programme_participant" */
export type Programme_Participant_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  programme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "programme_participant" */
export type Programme_Participant_Mutation_Response = {
  __typename?: 'programme_participant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Programme_Participant>;
};

/** on_conflict condition type for table "programme_participant" */
export type Programme_Participant_On_Conflict = {
  constraint: Programme_Participant_Constraint;
  update_columns?: Array<Programme_Participant_Update_Column>;
  where?: InputMaybe<Programme_Participant_Bool_Exp>;
};

/** Ordering options when selecting data from "programme_participant". */
export type Programme_Participant_Order_By = {
  created_at?: InputMaybe<Order_By>;
  participant?: InputMaybe<Participant_Order_By>;
  participant_id?: InputMaybe<Order_By>;
  programme?: InputMaybe<Programme_Order_By>;
  programme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: programme_participant */
export type Programme_Participant_Pk_Columns_Input = {
  participant_id: Scalars['uuid']['input'];
  programme_id: Scalars['uuid']['input'];
};

/** select columns of table "programme_participant" */
export enum Programme_Participant_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  ProgrammeId = 'programme_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "programme_participant" */
export type Programme_Participant_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  programme_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "programme_participant" */
export type Programme_Participant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Programme_Participant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Programme_Participant_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  programme_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "programme_participant" */
export enum Programme_Participant_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  ProgrammeId = 'programme_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Programme_Participant_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Programme_Participant_Set_Input>;
  /** filter the rows which have to be updated */
  where: Programme_Participant_Bool_Exp;
};

/** primary key columns input for table: programme */
export type Programme_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "programme" */
export enum Programme_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProgrammeGroupId = 'programme_group_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "programme" */
export type Programme_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  programme_group_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "programme" */
export type Programme_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Programme_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Programme_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  programme_group_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "programme" */
export enum Programme_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProgrammeGroupId = 'programme_group_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Programme_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Programme_Set_Input>;
  /** filter the rows which have to be updated */
  where: Programme_Bool_Exp;
};

/** columns and relationships of "project" */
export type Project = {
  __typename?: 'project';
  /** An array relationship */
  categories: Array<Project_Category>;
  /** An aggregate relationship */
  categories_aggregate: Project_Category_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  programme: Programme;
  programme_id: Scalars['uuid']['output'];
  /** An array relationship */
  registers: Array<Register>;
  /** An aggregate relationship */
  registers_aggregate: Register_Aggregate;
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "project" */
export type ProjectCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Project_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Category_Order_By>>;
  where?: InputMaybe<Project_Category_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Category_Order_By>>;
  where?: InputMaybe<Project_Category_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectRegistersArgs = {
  distinct_on?: InputMaybe<Array<Register_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Order_By>>;
  where?: InputMaybe<Register_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectRegisters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Order_By>>;
  where?: InputMaybe<Register_Bool_Exp>;
};

/** aggregated selection of "project" */
export type Project_Aggregate = {
  __typename?: 'project_aggregate';
  aggregate?: Maybe<Project_Aggregate_Fields>;
  nodes: Array<Project>;
};

export type Project_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Aggregate_Bool_Exp_Count>;
};

export type Project_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project" */
export type Project_Aggregate_Fields = {
  __typename?: 'project_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Max_Fields>;
  min?: Maybe<Project_Min_Fields>;
};


/** aggregate fields of "project" */
export type Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project" */
export type Project_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Max_Order_By>;
  min?: InputMaybe<Project_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project" */
export type Project_Arr_Rel_Insert_Input = {
  data: Array<Project_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project". All fields are combined with a logical 'AND'. */
export type Project_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Bool_Exp>>;
  _not?: InputMaybe<Project_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Bool_Exp>>;
  categories?: InputMaybe<Project_Category_Bool_Exp>;
  categories_aggregate?: InputMaybe<Project_Category_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  programme?: InputMaybe<Programme_Bool_Exp>;
  programme_id?: InputMaybe<Uuid_Comparison_Exp>;
  registers?: InputMaybe<Register_Bool_Exp>;
  registers_aggregate?: InputMaybe<Register_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "project_category" */
export type Project_Category = {
  __typename?: 'project_category';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  project: Project;
  project_id: Scalars['uuid']['output'];
  /** An array relationship */
  register_project_category: Array<Register_Project_Category>;
  /** An aggregate relationship */
  register_project_category_aggregate: Register_Project_Category_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "project_category" */
export type Project_CategoryRegister_Project_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Register_Project_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Project_Category_Order_By>>;
  where?: InputMaybe<Register_Project_Category_Bool_Exp>;
};


/** columns and relationships of "project_category" */
export type Project_CategoryRegister_Project_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Project_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Project_Category_Order_By>>;
  where?: InputMaybe<Register_Project_Category_Bool_Exp>;
};

/** aggregated selection of "project_category" */
export type Project_Category_Aggregate = {
  __typename?: 'project_category_aggregate';
  aggregate?: Maybe<Project_Category_Aggregate_Fields>;
  nodes: Array<Project_Category>;
};

export type Project_Category_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Category_Aggregate_Bool_Exp_Count>;
};

export type Project_Category_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Category_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_category" */
export type Project_Category_Aggregate_Fields = {
  __typename?: 'project_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Category_Max_Fields>;
  min?: Maybe<Project_Category_Min_Fields>;
};


/** aggregate fields of "project_category" */
export type Project_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_category" */
export type Project_Category_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Category_Max_Order_By>;
  min?: InputMaybe<Project_Category_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_category" */
export type Project_Category_Arr_Rel_Insert_Input = {
  data: Array<Project_Category_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Category_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_category". All fields are combined with a logical 'AND'. */
export type Project_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Category_Bool_Exp>>;
  _not?: InputMaybe<Project_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Category_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  register_project_category?: InputMaybe<Register_Project_Category_Bool_Exp>;
  register_project_category_aggregate?: InputMaybe<Register_Project_Category_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_category" */
export enum Project_Category_Constraint {
  /** unique or primary key constraint on columns "project_id", "name" */
  ProjectCategoryNameProjectIdKey = 'project_category_name_project_id_key',
  /** unique or primary key constraint on columns "id" */
  ProjectCategoryPkey = 'project_category_pkey'
}

/** input type for inserting data into table "project_category" */
export type Project_Category_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  register_project_category?: InputMaybe<Register_Project_Category_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Project_Category_Max_Fields = {
  __typename?: 'project_category_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "project_category" */
export type Project_Category_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Category_Min_Fields = {
  __typename?: 'project_category_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "project_category" */
export type Project_Category_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_category" */
export type Project_Category_Mutation_Response = {
  __typename?: 'project_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Category>;
};

/** input type for inserting object relation for remote table "project_category" */
export type Project_Category_Obj_Rel_Insert_Input = {
  data: Project_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Category_On_Conflict>;
};

/** on_conflict condition type for table "project_category" */
export type Project_Category_On_Conflict = {
  constraint: Project_Category_Constraint;
  update_columns?: Array<Project_Category_Update_Column>;
  where?: InputMaybe<Project_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "project_category". */
export type Project_Category_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  project_id?: InputMaybe<Order_By>;
  register_project_category_aggregate?: InputMaybe<Register_Project_Category_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_category */
export type Project_Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_category" */
export enum Project_Category_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "project_category" */
export type Project_Category_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "project_category" */
export type Project_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Category_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "project_category" */
export enum Project_Category_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Project_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Category_Bool_Exp;
};

/** unique or primary key constraints on table "project" */
export enum Project_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectPkey = 'project_pkey',
  /** unique or primary key constraint on columns "slug" */
  ProjectSlugKey = 'project_slug_key'
}

/** input type for inserting data into table "project" */
export type Project_Insert_Input = {
  categories?: InputMaybe<Project_Category_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  programme?: InputMaybe<Programme_Obj_Rel_Insert_Input>;
  programme_id?: InputMaybe<Scalars['uuid']['input']>;
  registers?: InputMaybe<Register_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Project_Max_Fields = {
  __typename?: 'project_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  programme_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "project" */
export type Project_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  programme_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Min_Fields = {
  __typename?: 'project_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  programme_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "project" */
export type Project_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  programme_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project" */
export type Project_Mutation_Response = {
  __typename?: 'project_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project>;
};

/** input type for inserting object relation for remote table "project" */
export type Project_Obj_Rel_Insert_Input = {
  data: Project_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_On_Conflict>;
};

/** on_conflict condition type for table "project" */
export type Project_On_Conflict = {
  constraint: Project_Constraint;
  update_columns?: Array<Project_Update_Column>;
  where?: InputMaybe<Project_Bool_Exp>;
};

/** Ordering options when selecting data from "project". */
export type Project_Order_By = {
  categories_aggregate?: InputMaybe<Project_Category_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  programme?: InputMaybe<Programme_Order_By>;
  programme_id?: InputMaybe<Order_By>;
  registers_aggregate?: InputMaybe<Register_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project */
export type Project_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project" */
export enum Project_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ProgrammeId = 'programme_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "project" */
export type Project_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  programme_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "project" */
export type Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  programme_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "project" */
export enum Project_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ProgrammeId = 'programme_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Project_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Bool_Exp;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "language" */
  language: Array<Language>;
  /** fetch aggregated fields from the table: "language" */
  language_aggregate: Language_Aggregate;
  /** fetch data from the table: "language" using primary key columns */
  language_by_pk?: Maybe<Language>;
  /** fetch data from the table: "location" */
  location: Array<Location>;
  /** fetch aggregated fields from the table: "location" */
  location_aggregate: Location_Aggregate;
  /** fetch data from the table: "location" using primary key columns */
  location_by_pk?: Maybe<Location>;
  /** fetch data from the table: "organisation" */
  organisation: Array<Organisation>;
  /** fetch aggregated fields from the table: "organisation" */
  organisation_aggregate: Organisation_Aggregate;
  /** fetch data from the table: "organisation" using primary key columns */
  organisation_by_pk?: Maybe<Organisation>;
  /** fetch data from the table: "organisation_manager" */
  organisation_manager: Array<Organisation_Manager>;
  /** fetch aggregated fields from the table: "organisation_manager" */
  organisation_manager_aggregate: Organisation_Manager_Aggregate;
  /** fetch data from the table: "organisation_manager" using primary key columns */
  organisation_manager_by_pk?: Maybe<Organisation_Manager>;
  /** fetch data from the table: "organisation_participant" */
  organisation_participant: Array<Organisation_Participant>;
  /** fetch aggregated fields from the table: "organisation_participant" */
  organisation_participant_aggregate: Organisation_Participant_Aggregate;
  /** fetch data from the table: "organisation_participant" using primary key columns */
  organisation_participant_by_pk?: Maybe<Organisation_Participant>;
  /** fetch data from the table: "organisation_programme" */
  organisation_programme: Array<Organisation_Programme>;
  /** fetch aggregated fields from the table: "organisation_programme" */
  organisation_programme_aggregate: Organisation_Programme_Aggregate;
  /** fetch data from the table: "organisation_programme" using primary key columns */
  organisation_programme_by_pk?: Maybe<Organisation_Programme>;
  /** fetch data from the table: "organisation_restricted_access_users" */
  organisation_restricted_access_users: Array<Organisation_Restricted_Access_Users>;
  /** fetch aggregated fields from the table: "organisation_restricted_access_users" */
  organisation_restricted_access_users_aggregate: Organisation_Restricted_Access_Users_Aggregate;
  /** fetch data from the table: "organisation_restricted_access_users" using primary key columns */
  organisation_restricted_access_users_by_pk?: Maybe<Organisation_Restricted_Access_Users>;
  /** fetch data from the table: "organisation_siloed_user" */
  organisation_siloed_user: Array<Organisation_Siloed_User>;
  /** fetch aggregated fields from the table: "organisation_siloed_user" */
  organisation_siloed_user_aggregate: Organisation_Siloed_User_Aggregate;
  /** fetch data from the table: "organisation_siloed_user" using primary key columns */
  organisation_siloed_user_by_pk?: Maybe<Organisation_Siloed_User>;
  /** fetch data from the table: "organisation_user" */
  organisation_user: Array<Organisation_User>;
  /** fetch aggregated fields from the table: "organisation_user" */
  organisation_user_aggregate: Organisation_User_Aggregate;
  /** fetch data from the table: "organisation_user" using primary key columns */
  organisation_user_by_pk?: Maybe<Organisation_User>;
  /** fetch data from the table: "parent_child" */
  parent_child: Array<Parent_Child>;
  /** fetch aggregated fields from the table: "parent_child" */
  parent_child_aggregate: Parent_Child_Aggregate;
  /** fetch data from the table: "parent_child" using primary key columns */
  parent_child_by_pk?: Maybe<Parent_Child>;
  /** fetch data from the table: "participant" */
  participant: Array<Participant>;
  /** fetch aggregated fields from the table: "participant" */
  participant_aggregate: Participant_Aggregate;
  /** fetch data from the table: "participant" using primary key columns */
  participant_by_pk?: Maybe<Participant>;
  /** An array relationship */
  participant_files: Array<Participant_Files>;
  /** An aggregate relationship */
  participant_files_aggregate: Participant_Files_Aggregate;
  /** fetch data from the table: "participant_files" using primary key columns */
  participant_files_by_pk?: Maybe<Participant_Files>;
  /** fetch data from the table: "participant_language" */
  participant_language: Array<Participant_Language>;
  /** fetch aggregated fields from the table: "participant_language" */
  participant_language_aggregate: Participant_Language_Aggregate;
  /** fetch data from the table: "participant_language" using primary key columns */
  participant_language_by_pk?: Maybe<Participant_Language>;
  /** execute function "participant_search_by_name" which returns "participant" */
  participant_search_by_name: Array<Participant>;
  /** execute function "participant_search_by_name" and query aggregates on result of table type "participant" */
  participant_search_by_name_aggregate: Participant_Aggregate;
  /** execute function "participant_search_by_name_sensitive" which returns "participant_sensitive_fields" */
  participant_search_by_name_sensitive: Array<Participant_Sensitive_Fields>;
  /** execute function "participant_search_by_name_sensitive" and query aggregates on result of table type "participant_sensitive_fields" */
  participant_search_by_name_sensitive_aggregate: Participant_Sensitive_Fields_Aggregate;
  /** fetch data from the table: "participant_sensitive_fields" */
  participant_sensitive_fields: Array<Participant_Sensitive_Fields>;
  /** fetch aggregated fields from the table: "participant_sensitive_fields" */
  participant_sensitive_fields_aggregate: Participant_Sensitive_Fields_Aggregate;
  /** fetch data from the table: "participant_sensitive_fields" using primary key columns */
  participant_sensitive_fields_by_pk?: Maybe<Participant_Sensitive_Fields>;
  /** fetch data from the table: "participant_sibling" */
  participant_sibling: Array<Participant_Sibling>;
  /** fetch aggregated fields from the table: "participant_sibling" */
  participant_sibling_aggregate: Participant_Sibling_Aggregate;
  /** fetch data from the table: "participant_sibling" using primary key columns */
  participant_sibling_by_pk?: Maybe<Participant_Sibling>;
  /** fetch data from the table: "programme" */
  programme: Array<Programme>;
  /** fetch aggregated fields from the table: "programme" */
  programme_aggregate: Programme_Aggregate;
  /** fetch data from the table: "programme" using primary key columns */
  programme_by_pk?: Maybe<Programme>;
  /** fetch data from the table: "programme_group" */
  programme_group: Array<Programme_Group>;
  /** fetch aggregated fields from the table: "programme_group" */
  programme_group_aggregate: Programme_Group_Aggregate;
  /** fetch data from the table: "programme_group" using primary key columns */
  programme_group_by_pk?: Maybe<Programme_Group>;
  /** fetch data from the table: "programme_location" */
  programme_location: Array<Programme_Location>;
  /** fetch aggregated fields from the table: "programme_location" */
  programme_location_aggregate: Programme_Location_Aggregate;
  /** fetch data from the table: "programme_location" using primary key columns */
  programme_location_by_pk?: Maybe<Programme_Location>;
  /** fetch data from the table: "programme_participant" */
  programme_participant: Array<Programme_Participant>;
  /** fetch aggregated fields from the table: "programme_participant" */
  programme_participant_aggregate: Programme_Participant_Aggregate;
  /** fetch data from the table: "programme_participant" using primary key columns */
  programme_participant_by_pk?: Maybe<Programme_Participant>;
  /** fetch data from the table: "project" */
  project: Array<Project>;
  /** fetch aggregated fields from the table: "project" */
  project_aggregate: Project_Aggregate;
  /** fetch data from the table: "project" using primary key columns */
  project_by_pk?: Maybe<Project>;
  /** fetch data from the table: "project_category" */
  project_category: Array<Project_Category>;
  /** fetch aggregated fields from the table: "project_category" */
  project_category_aggregate: Project_Category_Aggregate;
  /** fetch data from the table: "project_category" using primary key columns */
  project_category_by_pk?: Maybe<Project_Category>;
  /** fetch data from the table: "register" */
  register: Array<Register>;
  /** fetch aggregated fields from the table: "register" */
  register_aggregate: Register_Aggregate;
  /** fetch data from the table: "register" using primary key columns */
  register_by_pk?: Maybe<Register>;
  /** fetch data from the table: "register_facilitator" */
  register_facilitator: Array<Register_Facilitator>;
  /** fetch aggregated fields from the table: "register_facilitator" */
  register_facilitator_aggregate: Register_Facilitator_Aggregate;
  /** fetch data from the table: "register_facilitator" using primary key columns */
  register_facilitator_by_pk?: Maybe<Register_Facilitator>;
  /** fetch data from the table: "register_participant" */
  register_participant: Array<Register_Participant>;
  /** fetch aggregated fields from the table: "register_participant" */
  register_participant_aggregate: Register_Participant_Aggregate;
  /** fetch data from the table: "register_participant" using primary key columns */
  register_participant_by_pk?: Maybe<Register_Participant>;
  /** fetch data from the table: "register_participant_computed" */
  register_participant_computed: Array<Register_Participant_Computed>;
  /** fetch aggregated fields from the table: "register_participant_computed" */
  register_participant_computed_aggregate: Register_Participant_Computed_Aggregate;
  /** fetch data from the table: "register_participant_latest" */
  register_participant_latest: Array<Register_Participant_Latest>;
  /** fetch aggregated fields from the table: "register_participant_latest" */
  register_participant_latest_aggregate: Register_Participant_Latest_Aggregate;
  /** fetch data from the table: "register_participant_sensitive_fields" */
  register_participant_sensitive_fields: Array<Register_Participant_Sensitive_Fields>;
  /** fetch aggregated fields from the table: "register_participant_sensitive_fields" */
  register_participant_sensitive_fields_aggregate: Register_Participant_Sensitive_Fields_Aggregate;
  /** fetch data from the table: "register_participant_sensitive_fields" using primary key columns */
  register_participant_sensitive_fields_by_pk?: Maybe<Register_Participant_Sensitive_Fields>;
  /** An array relationship */
  register_project_category: Array<Register_Project_Category>;
  /** An aggregate relationship */
  register_project_category_aggregate: Register_Project_Category_Aggregate;
  /** fetch data from the table: "register_project_category" using primary key columns */
  register_project_category_by_pk?: Maybe<Register_Project_Category>;
  /** fetch data from the table: "register_sensitive_fields" */
  register_sensitive_fields: Array<Register_Sensitive_Fields>;
  /** fetch aggregated fields from the table: "register_sensitive_fields" */
  register_sensitive_fields_aggregate: Register_Sensitive_Fields_Aggregate;
  /** fetch data from the table: "register_sensitive_fields" using primary key columns */
  register_sensitive_fields_by_pk?: Maybe<Register_Sensitive_Fields>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_language" */
  user_language: Array<User_Language>;
  /** fetch aggregated fields from the table: "user_language" */
  user_language_aggregate: User_Language_Aggregate;
  /** fetch data from the table: "user_language" using primary key columns */
  user_language_by_pk?: Maybe<User_Language>;
  /** fetch data from the table: "user_login_code" */
  user_login_code: Array<User_Login_Code>;
  /** fetch aggregated fields from the table: "user_login_code" */
  user_login_code_aggregate: User_Login_Code_Aggregate;
  /** fetch data from the table: "user_login_code" using primary key columns */
  user_login_code_by_pk?: Maybe<User_Login_Code>;
  /** fetch data from the table: "user_participant_permissions" */
  user_participant_permissions: Array<User_Participant_Permissions>;
  /** fetch aggregated fields from the table: "user_participant_permissions" */
  user_participant_permissions_aggregate: User_Participant_Permissions_Aggregate;
  /** fetch data from the table: "user_register_permissions" */
  user_register_permissions: Array<User_Register_Permissions>;
  /** fetch aggregated fields from the table: "user_register_permissions" */
  user_register_permissions_aggregate: User_Register_Permissions_Aggregate;
  /** fetch data from the table: "user_warning" */
  user_warning: Array<User_Warning>;
  /** fetch aggregated fields from the table: "user_warning" */
  user_warning_aggregate: User_Warning_Aggregate;
  /** fetch data from the table: "user_warning" using primary key columns */
  user_warning_by_pk?: Maybe<User_Warning>;
  /** fetch data from the table: "warning" */
  warning: Array<Warning>;
  /** fetch aggregated fields from the table: "warning" */
  warning_aggregate: Warning_Aggregate;
  /** fetch data from the table: "warning" using primary key columns */
  warning_by_pk?: Maybe<Warning>;
};


export type Query_RootLanguageArgs = {
  distinct_on?: InputMaybe<Array<Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Language_Order_By>>;
  where?: InputMaybe<Language_Bool_Exp>;
};


export type Query_RootLanguage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Language_Order_By>>;
  where?: InputMaybe<Language_Bool_Exp>;
};


export type Query_RootLanguage_By_PkArgs = {
  code: Scalars['String']['input'];
};


export type Query_RootLocationArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Query_RootLocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Query_RootLocation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganisationArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Query_RootOrganisation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Query_RootOrganisation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganisation_ManagerArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Manager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Manager_Order_By>>;
  where?: InputMaybe<Organisation_Manager_Bool_Exp>;
};


export type Query_RootOrganisation_Manager_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Manager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Manager_Order_By>>;
  where?: InputMaybe<Organisation_Manager_Bool_Exp>;
};


export type Query_RootOrganisation_Manager_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Query_RootOrganisation_ParticipantArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Participant_Order_By>>;
  where?: InputMaybe<Organisation_Participant_Bool_Exp>;
};


export type Query_RootOrganisation_Participant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Participant_Order_By>>;
  where?: InputMaybe<Organisation_Participant_Bool_Exp>;
};


export type Query_RootOrganisation_Participant_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  participant_id: Scalars['uuid']['input'];
};


export type Query_RootOrganisation_ProgrammeArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Programme_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Programme_Order_By>>;
  where?: InputMaybe<Organisation_Programme_Bool_Exp>;
};


export type Query_RootOrganisation_Programme_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Programme_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Programme_Order_By>>;
  where?: InputMaybe<Organisation_Programme_Bool_Exp>;
};


export type Query_RootOrganisation_Programme_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  programme_id: Scalars['uuid']['input'];
};


export type Query_RootOrganisation_Restricted_Access_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Restricted_Access_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Restricted_Access_Users_Order_By>>;
  where?: InputMaybe<Organisation_Restricted_Access_Users_Bool_Exp>;
};


export type Query_RootOrganisation_Restricted_Access_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Restricted_Access_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Restricted_Access_Users_Order_By>>;
  where?: InputMaybe<Organisation_Restricted_Access_Users_Bool_Exp>;
};


export type Query_RootOrganisation_Restricted_Access_Users_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Query_RootOrganisation_Siloed_UserArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Siloed_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Siloed_User_Order_By>>;
  where?: InputMaybe<Organisation_Siloed_User_Bool_Exp>;
};


export type Query_RootOrganisation_Siloed_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Siloed_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Siloed_User_Order_By>>;
  where?: InputMaybe<Organisation_Siloed_User_Bool_Exp>;
};


export type Query_RootOrganisation_Siloed_User_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Query_RootOrganisation_UserArgs = {
  distinct_on?: InputMaybe<Array<Organisation_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_User_Order_By>>;
  where?: InputMaybe<Organisation_User_Bool_Exp>;
};


export type Query_RootOrganisation_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_User_Order_By>>;
  where?: InputMaybe<Organisation_User_Bool_Exp>;
};


export type Query_RootOrganisation_User_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Query_RootParent_ChildArgs = {
  distinct_on?: InputMaybe<Array<Parent_Child_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parent_Child_Order_By>>;
  where?: InputMaybe<Parent_Child_Bool_Exp>;
};


export type Query_RootParent_Child_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parent_Child_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parent_Child_Order_By>>;
  where?: InputMaybe<Parent_Child_Bool_Exp>;
};


export type Query_RootParent_Child_By_PkArgs = {
  child_id: Scalars['uuid']['input'];
  parent_id: Scalars['uuid']['input'];
};


export type Query_RootParticipantArgs = {
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


export type Query_RootParticipant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


export type Query_RootParticipant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootParticipant_FilesArgs = {
  distinct_on?: InputMaybe<Array<Participant_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Files_Order_By>>;
  where?: InputMaybe<Participant_Files_Bool_Exp>;
};


export type Query_RootParticipant_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Files_Order_By>>;
  where?: InputMaybe<Participant_Files_Bool_Exp>;
};


export type Query_RootParticipant_Files_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootParticipant_LanguageArgs = {
  distinct_on?: InputMaybe<Array<Participant_Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Language_Order_By>>;
  where?: InputMaybe<Participant_Language_Bool_Exp>;
};


export type Query_RootParticipant_Language_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Language_Order_By>>;
  where?: InputMaybe<Participant_Language_Bool_Exp>;
};


export type Query_RootParticipant_Language_By_PkArgs = {
  language_code: Scalars['String']['input'];
  participant_id: Scalars['uuid']['input'];
};


export type Query_RootParticipant_Search_By_NameArgs = {
  args: Participant_Search_By_Name_Args;
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


export type Query_RootParticipant_Search_By_Name_AggregateArgs = {
  args: Participant_Search_By_Name_Args;
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


export type Query_RootParticipant_Search_By_Name_SensitiveArgs = {
  args: Participant_Search_By_Name_Sensitive_Args;
  distinct_on?: InputMaybe<Array<Participant_Sensitive_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Sensitive_Fields_Order_By>>;
  where?: InputMaybe<Participant_Sensitive_Fields_Bool_Exp>;
};


export type Query_RootParticipant_Search_By_Name_Sensitive_AggregateArgs = {
  args: Participant_Search_By_Name_Sensitive_Args;
  distinct_on?: InputMaybe<Array<Participant_Sensitive_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Sensitive_Fields_Order_By>>;
  where?: InputMaybe<Participant_Sensitive_Fields_Bool_Exp>;
};


export type Query_RootParticipant_Sensitive_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Participant_Sensitive_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Sensitive_Fields_Order_By>>;
  where?: InputMaybe<Participant_Sensitive_Fields_Bool_Exp>;
};


export type Query_RootParticipant_Sensitive_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Sensitive_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Sensitive_Fields_Order_By>>;
  where?: InputMaybe<Participant_Sensitive_Fields_Bool_Exp>;
};


export type Query_RootParticipant_Sensitive_Fields_By_PkArgs = {
  participant_id: Scalars['uuid']['input'];
};


export type Query_RootParticipant_SiblingArgs = {
  distinct_on?: InputMaybe<Array<Participant_Sibling_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Sibling_Order_By>>;
  where?: InputMaybe<Participant_Sibling_Bool_Exp>;
};


export type Query_RootParticipant_Sibling_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Sibling_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Sibling_Order_By>>;
  where?: InputMaybe<Participant_Sibling_Bool_Exp>;
};


export type Query_RootParticipant_Sibling_By_PkArgs = {
  participant_id: Scalars['uuid']['input'];
  sibling_id: Scalars['uuid']['input'];
};


export type Query_RootProgrammeArgs = {
  distinct_on?: InputMaybe<Array<Programme_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Order_By>>;
  where?: InputMaybe<Programme_Bool_Exp>;
};


export type Query_RootProgramme_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Programme_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Order_By>>;
  where?: InputMaybe<Programme_Bool_Exp>;
};


export type Query_RootProgramme_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProgramme_GroupArgs = {
  distinct_on?: InputMaybe<Array<Programme_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Group_Order_By>>;
  where?: InputMaybe<Programme_Group_Bool_Exp>;
};


export type Query_RootProgramme_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Programme_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Group_Order_By>>;
  where?: InputMaybe<Programme_Group_Bool_Exp>;
};


export type Query_RootProgramme_Group_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProgramme_LocationArgs = {
  distinct_on?: InputMaybe<Array<Programme_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Location_Order_By>>;
  where?: InputMaybe<Programme_Location_Bool_Exp>;
};


export type Query_RootProgramme_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Programme_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Location_Order_By>>;
  where?: InputMaybe<Programme_Location_Bool_Exp>;
};


export type Query_RootProgramme_Location_By_PkArgs = {
  location_id: Scalars['uuid']['input'];
  programme_id: Scalars['uuid']['input'];
};


export type Query_RootProgramme_ParticipantArgs = {
  distinct_on?: InputMaybe<Array<Programme_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Participant_Order_By>>;
  where?: InputMaybe<Programme_Participant_Bool_Exp>;
};


export type Query_RootProgramme_Participant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Programme_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Participant_Order_By>>;
  where?: InputMaybe<Programme_Participant_Bool_Exp>;
};


export type Query_RootProgramme_Participant_By_PkArgs = {
  participant_id: Scalars['uuid']['input'];
  programme_id: Scalars['uuid']['input'];
};


export type Query_RootProjectArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Query_RootProject_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Query_RootProject_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Project_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Category_Order_By>>;
  where?: InputMaybe<Project_Category_Bool_Exp>;
};


export type Query_RootProject_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Category_Order_By>>;
  where?: InputMaybe<Project_Category_Bool_Exp>;
};


export type Query_RootProject_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRegisterArgs = {
  distinct_on?: InputMaybe<Array<Register_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Order_By>>;
  where?: InputMaybe<Register_Bool_Exp>;
};


export type Query_RootRegister_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Order_By>>;
  where?: InputMaybe<Register_Bool_Exp>;
};


export type Query_RootRegister_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRegister_FacilitatorArgs = {
  distinct_on?: InputMaybe<Array<Register_Facilitator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Facilitator_Order_By>>;
  where?: InputMaybe<Register_Facilitator_Bool_Exp>;
};


export type Query_RootRegister_Facilitator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Facilitator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Facilitator_Order_By>>;
  where?: InputMaybe<Register_Facilitator_Bool_Exp>;
};


export type Query_RootRegister_Facilitator_By_PkArgs = {
  facilitator_id: Scalars['uuid']['input'];
  register_id: Scalars['uuid']['input'];
};


export type Query_RootRegister_ParticipantArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Order_By>>;
  where?: InputMaybe<Register_Participant_Bool_Exp>;
};


export type Query_RootRegister_Participant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Order_By>>;
  where?: InputMaybe<Register_Participant_Bool_Exp>;
};


export type Query_RootRegister_Participant_By_PkArgs = {
  participant_id: Scalars['uuid']['input'];
  register_id: Scalars['uuid']['input'];
};


export type Query_RootRegister_Participant_ComputedArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Computed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Computed_Order_By>>;
  where?: InputMaybe<Register_Participant_Computed_Bool_Exp>;
};


export type Query_RootRegister_Participant_Computed_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Computed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Computed_Order_By>>;
  where?: InputMaybe<Register_Participant_Computed_Bool_Exp>;
};


export type Query_RootRegister_Participant_LatestArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Latest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Latest_Order_By>>;
  where?: InputMaybe<Register_Participant_Latest_Bool_Exp>;
};


export type Query_RootRegister_Participant_Latest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Latest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Latest_Order_By>>;
  where?: InputMaybe<Register_Participant_Latest_Bool_Exp>;
};


export type Query_RootRegister_Participant_Sensitive_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Sensitive_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Sensitive_Fields_Order_By>>;
  where?: InputMaybe<Register_Participant_Sensitive_Fields_Bool_Exp>;
};


export type Query_RootRegister_Participant_Sensitive_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Sensitive_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Sensitive_Fields_Order_By>>;
  where?: InputMaybe<Register_Participant_Sensitive_Fields_Bool_Exp>;
};


export type Query_RootRegister_Participant_Sensitive_Fields_By_PkArgs = {
  participant_id: Scalars['uuid']['input'];
  register_id: Scalars['uuid']['input'];
};


export type Query_RootRegister_Project_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Register_Project_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Project_Category_Order_By>>;
  where?: InputMaybe<Register_Project_Category_Bool_Exp>;
};


export type Query_RootRegister_Project_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Project_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Project_Category_Order_By>>;
  where?: InputMaybe<Register_Project_Category_Bool_Exp>;
};


export type Query_RootRegister_Project_Category_By_PkArgs = {
  project_category_id: Scalars['uuid']['input'];
  register_id: Scalars['uuid']['input'];
};


export type Query_RootRegister_Sensitive_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Register_Sensitive_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Sensitive_Fields_Order_By>>;
  where?: InputMaybe<Register_Sensitive_Fields_Bool_Exp>;
};


export type Query_RootRegister_Sensitive_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Sensitive_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Sensitive_Fields_Order_By>>;
  where?: InputMaybe<Register_Sensitive_Fields_Bool_Exp>;
};


export type Query_RootRegister_Sensitive_Fields_By_PkArgs = {
  register_id: Scalars['uuid']['input'];
};


export type Query_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_LanguageArgs = {
  distinct_on?: InputMaybe<Array<User_Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Language_Order_By>>;
  where?: InputMaybe<User_Language_Bool_Exp>;
};


export type Query_RootUser_Language_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Language_Order_By>>;
  where?: InputMaybe<User_Language_Bool_Exp>;
};


export type Query_RootUser_Language_By_PkArgs = {
  language_code: Scalars['String']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Query_RootUser_Login_CodeArgs = {
  distinct_on?: InputMaybe<Array<User_Login_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Login_Code_Order_By>>;
  where?: InputMaybe<User_Login_Code_Bool_Exp>;
};


export type Query_RootUser_Login_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Login_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Login_Code_Order_By>>;
  where?: InputMaybe<User_Login_Code_Bool_Exp>;
};


export type Query_RootUser_Login_Code_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_Participant_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Participant_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Participant_Permissions_Order_By>>;
  where?: InputMaybe<User_Participant_Permissions_Bool_Exp>;
};


export type Query_RootUser_Participant_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Participant_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Participant_Permissions_Order_By>>;
  where?: InputMaybe<User_Participant_Permissions_Bool_Exp>;
};


export type Query_RootUser_Register_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Register_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Register_Permissions_Order_By>>;
  where?: InputMaybe<User_Register_Permissions_Bool_Exp>;
};


export type Query_RootUser_Register_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Register_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Register_Permissions_Order_By>>;
  where?: InputMaybe<User_Register_Permissions_Bool_Exp>;
};


export type Query_RootUser_WarningArgs = {
  distinct_on?: InputMaybe<Array<User_Warning_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Warning_Order_By>>;
  where?: InputMaybe<User_Warning_Bool_Exp>;
};


export type Query_RootUser_Warning_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Warning_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Warning_Order_By>>;
  where?: InputMaybe<User_Warning_Bool_Exp>;
};


export type Query_RootUser_Warning_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
  warning_id: Scalars['uuid']['input'];
};


export type Query_RootWarningArgs = {
  distinct_on?: InputMaybe<Array<Warning_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Warning_Order_By>>;
  where?: InputMaybe<Warning_Bool_Exp>;
};


export type Query_RootWarning_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Warning_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Warning_Order_By>>;
  where?: InputMaybe<Warning_Bool_Exp>;
};


export type Query_RootWarning_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "register" */
export type Register = {
  __typename?: 'register';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  created_by_user: User;
  created_by_user_id: Scalars['uuid']['output'];
  date: Scalars['date']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  location: Location;
  location_id: Scalars['uuid']['output'];
  number_of_orgs_in_attendance?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['uuid']['output'];
  override_total_participants?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  permissions: Array<User_Register_Permissions>;
  /** An aggregate relationship */
  permissions_aggregate: User_Register_Permissions_Aggregate;
  /** An object relationship */
  project: Project;
  project_id: Scalars['uuid']['output'];
  /** An array relationship */
  register_facilitators: Array<Register_Facilitator>;
  /** An aggregate relationship */
  register_facilitators_aggregate: Register_Facilitator_Aggregate;
  /** An array relationship */
  register_participants: Array<Register_Participant>;
  /** An aggregate relationship */
  register_participants_aggregate: Register_Participant_Aggregate;
  /** An array relationship */
  register_project_categories: Array<Register_Project_Category>;
  /** An aggregate relationship */
  register_project_categories_aggregate: Register_Project_Category_Aggregate;
  /** An object relationship */
  sensitive_fields?: Maybe<Register_Sensitive_Fields>;
  time: Scalars['time']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "register" */
export type RegisterPermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Register_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Register_Permissions_Order_By>>;
  where?: InputMaybe<User_Register_Permissions_Bool_Exp>;
};


/** columns and relationships of "register" */
export type RegisterPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Register_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Register_Permissions_Order_By>>;
  where?: InputMaybe<User_Register_Permissions_Bool_Exp>;
};


/** columns and relationships of "register" */
export type RegisterRegister_FacilitatorsArgs = {
  distinct_on?: InputMaybe<Array<Register_Facilitator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Facilitator_Order_By>>;
  where?: InputMaybe<Register_Facilitator_Bool_Exp>;
};


/** columns and relationships of "register" */
export type RegisterRegister_Facilitators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Facilitator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Facilitator_Order_By>>;
  where?: InputMaybe<Register_Facilitator_Bool_Exp>;
};


/** columns and relationships of "register" */
export type RegisterRegister_ParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Order_By>>;
  where?: InputMaybe<Register_Participant_Bool_Exp>;
};


/** columns and relationships of "register" */
export type RegisterRegister_Participants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Order_By>>;
  where?: InputMaybe<Register_Participant_Bool_Exp>;
};


/** columns and relationships of "register" */
export type RegisterRegister_Project_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Register_Project_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Project_Category_Order_By>>;
  where?: InputMaybe<Register_Project_Category_Bool_Exp>;
};


/** columns and relationships of "register" */
export type RegisterRegister_Project_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Project_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Project_Category_Order_By>>;
  where?: InputMaybe<Register_Project_Category_Bool_Exp>;
};

/** aggregated selection of "register" */
export type Register_Aggregate = {
  __typename?: 'register_aggregate';
  aggregate?: Maybe<Register_Aggregate_Fields>;
  nodes: Array<Register>;
};

export type Register_Aggregate_Bool_Exp = {
  count?: InputMaybe<Register_Aggregate_Bool_Exp_Count>;
};

export type Register_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Register_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Register_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "register" */
export type Register_Aggregate_Fields = {
  __typename?: 'register_aggregate_fields';
  avg?: Maybe<Register_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Register_Max_Fields>;
  min?: Maybe<Register_Min_Fields>;
  stddev?: Maybe<Register_Stddev_Fields>;
  stddev_pop?: Maybe<Register_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Register_Stddev_Samp_Fields>;
  sum?: Maybe<Register_Sum_Fields>;
  var_pop?: Maybe<Register_Var_Pop_Fields>;
  var_samp?: Maybe<Register_Var_Samp_Fields>;
  variance?: Maybe<Register_Variance_Fields>;
};


/** aggregate fields of "register" */
export type Register_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Register_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "register" */
export type Register_Aggregate_Order_By = {
  avg?: InputMaybe<Register_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Register_Max_Order_By>;
  min?: InputMaybe<Register_Min_Order_By>;
  stddev?: InputMaybe<Register_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Register_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Register_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Register_Sum_Order_By>;
  var_pop?: InputMaybe<Register_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Register_Var_Samp_Order_By>;
  variance?: InputMaybe<Register_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "register" */
export type Register_Arr_Rel_Insert_Input = {
  data: Array<Register_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Register_On_Conflict>;
};

/** aggregate avg on columns */
export type Register_Avg_Fields = {
  __typename?: 'register_avg_fields';
  number_of_orgs_in_attendance?: Maybe<Scalars['Float']['output']>;
  override_total_participants?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "register" */
export type Register_Avg_Order_By = {
  number_of_orgs_in_attendance?: InputMaybe<Order_By>;
  override_total_participants?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "register". All fields are combined with a logical 'AND'. */
export type Register_Bool_Exp = {
  _and?: InputMaybe<Array<Register_Bool_Exp>>;
  _not?: InputMaybe<Register_Bool_Exp>;
  _or?: InputMaybe<Array<Register_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Bool_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Location_Bool_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_orgs_in_attendance?: InputMaybe<Int_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  override_total_participants?: InputMaybe<Int_Comparison_Exp>;
  permissions?: InputMaybe<User_Register_Permissions_Bool_Exp>;
  permissions_aggregate?: InputMaybe<User_Register_Permissions_Aggregate_Bool_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  register_facilitators?: InputMaybe<Register_Facilitator_Bool_Exp>;
  register_facilitators_aggregate?: InputMaybe<Register_Facilitator_Aggregate_Bool_Exp>;
  register_participants?: InputMaybe<Register_Participant_Bool_Exp>;
  register_participants_aggregate?: InputMaybe<Register_Participant_Aggregate_Bool_Exp>;
  register_project_categories?: InputMaybe<Register_Project_Category_Bool_Exp>;
  register_project_categories_aggregate?: InputMaybe<Register_Project_Category_Aggregate_Bool_Exp>;
  sensitive_fields?: InputMaybe<Register_Sensitive_Fields_Bool_Exp>;
  time?: InputMaybe<Time_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "register" */
export enum Register_Constraint {
  /** unique or primary key constraint on columns "id" */
  RegisterPkey = 'register_pkey'
}

/** columns and relationships of "register_facilitator" */
export type Register_Facilitator = {
  __typename?: 'register_facilitator';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  facilitator_id: Scalars['uuid']['output'];
  /** An object relationship */
  register: Register;
  register_id: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: User;
};

/** aggregated selection of "register_facilitator" */
export type Register_Facilitator_Aggregate = {
  __typename?: 'register_facilitator_aggregate';
  aggregate?: Maybe<Register_Facilitator_Aggregate_Fields>;
  nodes: Array<Register_Facilitator>;
};

export type Register_Facilitator_Aggregate_Bool_Exp = {
  count?: InputMaybe<Register_Facilitator_Aggregate_Bool_Exp_Count>;
};

export type Register_Facilitator_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Register_Facilitator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Register_Facilitator_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "register_facilitator" */
export type Register_Facilitator_Aggregate_Fields = {
  __typename?: 'register_facilitator_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Register_Facilitator_Max_Fields>;
  min?: Maybe<Register_Facilitator_Min_Fields>;
};


/** aggregate fields of "register_facilitator" */
export type Register_Facilitator_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Register_Facilitator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "register_facilitator" */
export type Register_Facilitator_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Register_Facilitator_Max_Order_By>;
  min?: InputMaybe<Register_Facilitator_Min_Order_By>;
};

/** input type for inserting array relation for remote table "register_facilitator" */
export type Register_Facilitator_Arr_Rel_Insert_Input = {
  data: Array<Register_Facilitator_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Register_Facilitator_On_Conflict>;
};

/** Boolean expression to filter rows from the table "register_facilitator". All fields are combined with a logical 'AND'. */
export type Register_Facilitator_Bool_Exp = {
  _and?: InputMaybe<Array<Register_Facilitator_Bool_Exp>>;
  _not?: InputMaybe<Register_Facilitator_Bool_Exp>;
  _or?: InputMaybe<Array<Register_Facilitator_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  facilitator_id?: InputMaybe<Uuid_Comparison_Exp>;
  register?: InputMaybe<Register_Bool_Exp>;
  register_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "register_facilitator" */
export enum Register_Facilitator_Constraint {
  /** unique or primary key constraint on columns "facilitator_id", "register_id" */
  RegisterFacilitatorPkey = 'register_facilitator_pkey'
}

/** input type for inserting data into table "register_facilitator" */
export type Register_Facilitator_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  facilitator_id?: InputMaybe<Scalars['uuid']['input']>;
  register?: InputMaybe<Register_Obj_Rel_Insert_Input>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Register_Facilitator_Max_Fields = {
  __typename?: 'register_facilitator_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  facilitator_id?: Maybe<Scalars['uuid']['output']>;
  register_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "register_facilitator" */
export type Register_Facilitator_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  register_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Register_Facilitator_Min_Fields = {
  __typename?: 'register_facilitator_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  facilitator_id?: Maybe<Scalars['uuid']['output']>;
  register_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "register_facilitator" */
export type Register_Facilitator_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  register_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "register_facilitator" */
export type Register_Facilitator_Mutation_Response = {
  __typename?: 'register_facilitator_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Register_Facilitator>;
};

/** on_conflict condition type for table "register_facilitator" */
export type Register_Facilitator_On_Conflict = {
  constraint: Register_Facilitator_Constraint;
  update_columns?: Array<Register_Facilitator_Update_Column>;
  where?: InputMaybe<Register_Facilitator_Bool_Exp>;
};

/** Ordering options when selecting data from "register_facilitator". */
export type Register_Facilitator_Order_By = {
  created_at?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  register?: InputMaybe<Register_Order_By>;
  register_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: register_facilitator */
export type Register_Facilitator_Pk_Columns_Input = {
  facilitator_id: Scalars['uuid']['input'];
  register_id: Scalars['uuid']['input'];
};

/** select columns of table "register_facilitator" */
export enum Register_Facilitator_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FacilitatorId = 'facilitator_id',
  /** column name */
  RegisterId = 'register_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "register_facilitator" */
export type Register_Facilitator_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  facilitator_id?: InputMaybe<Scalars['uuid']['input']>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "register_facilitator" */
export type Register_Facilitator_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Register_Facilitator_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Register_Facilitator_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  facilitator_id?: InputMaybe<Scalars['uuid']['input']>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "register_facilitator" */
export enum Register_Facilitator_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FacilitatorId = 'facilitator_id',
  /** column name */
  RegisterId = 'register_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Register_Facilitator_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Register_Facilitator_Set_Input>;
  /** filter the rows which have to be updated */
  where: Register_Facilitator_Bool_Exp;
};

/** input type for incrementing numeric columns in table "register" */
export type Register_Inc_Input = {
  number_of_orgs_in_attendance?: InputMaybe<Scalars['Int']['input']>;
  override_total_participants?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "register" */
export type Register_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  number_of_orgs_in_attendance?: InputMaybe<Scalars['Int']['input']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  override_total_participants?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<User_Register_Permissions_Arr_Rel_Insert_Input>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  register_facilitators?: InputMaybe<Register_Facilitator_Arr_Rel_Insert_Input>;
  register_participants?: InputMaybe<Register_Participant_Arr_Rel_Insert_Input>;
  register_project_categories?: InputMaybe<Register_Project_Category_Arr_Rel_Insert_Input>;
  sensitive_fields?: InputMaybe<Register_Sensitive_Fields_Obj_Rel_Insert_Input>;
  time?: InputMaybe<Scalars['time']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Register_Max_Fields = {
  __typename?: 'register_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  number_of_orgs_in_attendance?: Maybe<Scalars['Int']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  override_total_participants?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "register" */
export type Register_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  number_of_orgs_in_attendance?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  override_total_participants?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Register_Min_Fields = {
  __typename?: 'register_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  number_of_orgs_in_attendance?: Maybe<Scalars['Int']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  override_total_participants?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "register" */
export type Register_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  number_of_orgs_in_attendance?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  override_total_participants?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "register" */
export type Register_Mutation_Response = {
  __typename?: 'register_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Register>;
};

/** input type for inserting object relation for remote table "register" */
export type Register_Obj_Rel_Insert_Input = {
  data: Register_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Register_On_Conflict>;
};

/** on_conflict condition type for table "register" */
export type Register_On_Conflict = {
  constraint: Register_Constraint;
  update_columns?: Array<Register_Update_Column>;
  where?: InputMaybe<Register_Bool_Exp>;
};

/** Ordering options when selecting data from "register". */
export type Register_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Location_Order_By>;
  location_id?: InputMaybe<Order_By>;
  number_of_orgs_in_attendance?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  override_total_participants?: InputMaybe<Order_By>;
  permissions_aggregate?: InputMaybe<User_Register_Permissions_Aggregate_Order_By>;
  project?: InputMaybe<Project_Order_By>;
  project_id?: InputMaybe<Order_By>;
  register_facilitators_aggregate?: InputMaybe<Register_Facilitator_Aggregate_Order_By>;
  register_participants_aggregate?: InputMaybe<Register_Participant_Aggregate_Order_By>;
  register_project_categories_aggregate?: InputMaybe<Register_Project_Category_Aggregate_Order_By>;
  sensitive_fields?: InputMaybe<Register_Sensitive_Fields_Order_By>;
  time?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** columns and relationships of "register_participant" */
export type Register_Participant = {
  __typename?: 'register_participant';
  _temp_is_child?: Maybe<Scalars['Boolean']['output']>;
  _temp_is_parent?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  computed?: Maybe<Register_Participant_Computed>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  participant: Participant;
  participant_age?: Maybe<Scalars['float8']['output']>;
  participant_id: Scalars['uuid']['output'];
  /** An object relationship */
  register: Register;
  register_id: Scalars['uuid']['output'];
  /** An object relationship */
  sensitive_fields?: Maybe<Register_Participant_Sensitive_Fields>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "register_participant" */
export type Register_Participant_Aggregate = {
  __typename?: 'register_participant_aggregate';
  aggregate?: Maybe<Register_Participant_Aggregate_Fields>;
  nodes: Array<Register_Participant>;
};

export type Register_Participant_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Register_Participant_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Register_Participant_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Register_Participant_Aggregate_Bool_Exp_Count>;
};

export type Register_Participant_Aggregate_Bool_Exp_Bool_And = {
  arguments: Register_Participant_Select_Column_Register_Participant_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Register_Participant_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Register_Participant_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Register_Participant_Select_Column_Register_Participant_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Register_Participant_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Register_Participant_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Register_Participant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Register_Participant_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "register_participant" */
export type Register_Participant_Aggregate_Fields = {
  __typename?: 'register_participant_aggregate_fields';
  avg?: Maybe<Register_Participant_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Register_Participant_Max_Fields>;
  min?: Maybe<Register_Participant_Min_Fields>;
  stddev?: Maybe<Register_Participant_Stddev_Fields>;
  stddev_pop?: Maybe<Register_Participant_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Register_Participant_Stddev_Samp_Fields>;
  sum?: Maybe<Register_Participant_Sum_Fields>;
  var_pop?: Maybe<Register_Participant_Var_Pop_Fields>;
  var_samp?: Maybe<Register_Participant_Var_Samp_Fields>;
  variance?: Maybe<Register_Participant_Variance_Fields>;
};


/** aggregate fields of "register_participant" */
export type Register_Participant_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Register_Participant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "register_participant" */
export type Register_Participant_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Register_Participant_Max_Order_By>;
  min?: InputMaybe<Register_Participant_Min_Order_By>;
};

/** input type for inserting array relation for remote table "register_participant" */
export type Register_Participant_Arr_Rel_Insert_Input = {
  data: Array<Register_Participant_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Register_Participant_On_Conflict>;
};

/** aggregate avg on columns */
export type Register_Participant_Avg_Fields = {
  __typename?: 'register_participant_avg_fields';
  participant_age?: Maybe<Scalars['float8']['output']>;
};

/** Boolean expression to filter rows from the table "register_participant". All fields are combined with a logical 'AND'. */
export type Register_Participant_Bool_Exp = {
  _and?: InputMaybe<Array<Register_Participant_Bool_Exp>>;
  _not?: InputMaybe<Register_Participant_Bool_Exp>;
  _or?: InputMaybe<Array<Register_Participant_Bool_Exp>>;
  _temp_is_child?: InputMaybe<Boolean_Comparison_Exp>;
  _temp_is_parent?: InputMaybe<Boolean_Comparison_Exp>;
  computed?: InputMaybe<Register_Participant_Computed_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  participant?: InputMaybe<Participant_Bool_Exp>;
  participant_age?: InputMaybe<Float8_Comparison_Exp>;
  participant_id?: InputMaybe<Uuid_Comparison_Exp>;
  register?: InputMaybe<Register_Bool_Exp>;
  register_id?: InputMaybe<Uuid_Comparison_Exp>;
  sensitive_fields?: InputMaybe<Register_Participant_Sensitive_Fields_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "register_participant_computed" */
export type Register_Participant_Computed = {
  __typename?: 'register_participant_computed';
  /** An object relationship */
  participant?: Maybe<Participant>;
  participant_age?: Maybe<Scalars['float8']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  register?: Maybe<Register>;
  register_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "register_participant_computed" */
export type Register_Participant_Computed_Aggregate = {
  __typename?: 'register_participant_computed_aggregate';
  aggregate?: Maybe<Register_Participant_Computed_Aggregate_Fields>;
  nodes: Array<Register_Participant_Computed>;
};

/** aggregate fields of "register_participant_computed" */
export type Register_Participant_Computed_Aggregate_Fields = {
  __typename?: 'register_participant_computed_aggregate_fields';
  avg?: Maybe<Register_Participant_Computed_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Register_Participant_Computed_Max_Fields>;
  min?: Maybe<Register_Participant_Computed_Min_Fields>;
  stddev?: Maybe<Register_Participant_Computed_Stddev_Fields>;
  stddev_pop?: Maybe<Register_Participant_Computed_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Register_Participant_Computed_Stddev_Samp_Fields>;
  sum?: Maybe<Register_Participant_Computed_Sum_Fields>;
  var_pop?: Maybe<Register_Participant_Computed_Var_Pop_Fields>;
  var_samp?: Maybe<Register_Participant_Computed_Var_Samp_Fields>;
  variance?: Maybe<Register_Participant_Computed_Variance_Fields>;
};


/** aggregate fields of "register_participant_computed" */
export type Register_Participant_Computed_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Register_Participant_Computed_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Register_Participant_Computed_Avg_Fields = {
  __typename?: 'register_participant_computed_avg_fields';
  participant_age?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "register_participant_computed". All fields are combined with a logical 'AND'. */
export type Register_Participant_Computed_Bool_Exp = {
  _and?: InputMaybe<Array<Register_Participant_Computed_Bool_Exp>>;
  _not?: InputMaybe<Register_Participant_Computed_Bool_Exp>;
  _or?: InputMaybe<Array<Register_Participant_Computed_Bool_Exp>>;
  participant?: InputMaybe<Participant_Bool_Exp>;
  participant_age?: InputMaybe<Float8_Comparison_Exp>;
  participant_id?: InputMaybe<Uuid_Comparison_Exp>;
  register?: InputMaybe<Register_Bool_Exp>;
  register_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "register_participant_computed" */
export type Register_Participant_Computed_Inc_Input = {
  participant_age?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "register_participant_computed" */
export type Register_Participant_Computed_Insert_Input = {
  participant?: InputMaybe<Participant_Obj_Rel_Insert_Input>;
  participant_age?: InputMaybe<Scalars['float8']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  register?: InputMaybe<Register_Obj_Rel_Insert_Input>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Register_Participant_Computed_Max_Fields = {
  __typename?: 'register_participant_computed_max_fields';
  participant_age?: Maybe<Scalars['float8']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  register_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Register_Participant_Computed_Min_Fields = {
  __typename?: 'register_participant_computed_min_fields';
  participant_age?: Maybe<Scalars['float8']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  register_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "register_participant_computed" */
export type Register_Participant_Computed_Mutation_Response = {
  __typename?: 'register_participant_computed_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Register_Participant_Computed>;
};

/** input type for inserting object relation for remote table "register_participant_computed" */
export type Register_Participant_Computed_Obj_Rel_Insert_Input = {
  data: Register_Participant_Computed_Insert_Input;
};

/** Ordering options when selecting data from "register_participant_computed". */
export type Register_Participant_Computed_Order_By = {
  participant?: InputMaybe<Participant_Order_By>;
  participant_age?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  register?: InputMaybe<Register_Order_By>;
  register_id?: InputMaybe<Order_By>;
};

/** select columns of table "register_participant_computed" */
export enum Register_Participant_Computed_Select_Column {
  /** column name */
  ParticipantAge = 'participant_age',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  RegisterId = 'register_id'
}

/** input type for updating data in table "register_participant_computed" */
export type Register_Participant_Computed_Set_Input = {
  participant_age?: InputMaybe<Scalars['float8']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Register_Participant_Computed_Stddev_Fields = {
  __typename?: 'register_participant_computed_stddev_fields';
  participant_age?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Register_Participant_Computed_Stddev_Pop_Fields = {
  __typename?: 'register_participant_computed_stddev_pop_fields';
  participant_age?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Register_Participant_Computed_Stddev_Samp_Fields = {
  __typename?: 'register_participant_computed_stddev_samp_fields';
  participant_age?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "register_participant_computed" */
export type Register_Participant_Computed_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Register_Participant_Computed_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Register_Participant_Computed_Stream_Cursor_Value_Input = {
  participant_age?: InputMaybe<Scalars['float8']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Register_Participant_Computed_Sum_Fields = {
  __typename?: 'register_participant_computed_sum_fields';
  participant_age?: Maybe<Scalars['float8']['output']>;
};

export type Register_Participant_Computed_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Register_Participant_Computed_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Register_Participant_Computed_Set_Input>;
  /** filter the rows which have to be updated */
  where: Register_Participant_Computed_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Register_Participant_Computed_Var_Pop_Fields = {
  __typename?: 'register_participant_computed_var_pop_fields';
  participant_age?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Register_Participant_Computed_Var_Samp_Fields = {
  __typename?: 'register_participant_computed_var_samp_fields';
  participant_age?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Register_Participant_Computed_Variance_Fields = {
  __typename?: 'register_participant_computed_variance_fields';
  participant_age?: Maybe<Scalars['Float']['output']>;
};

/** unique or primary key constraints on table "register_participant" */
export enum Register_Participant_Constraint {
  /** unique or primary key constraint on columns "participant_id", "register_id" */
  RegisterParticipantPkey = 'register_participant_pkey'
}

/** input type for inserting data into table "register_participant" */
export type Register_Participant_Insert_Input = {
  _temp_is_child?: InputMaybe<Scalars['Boolean']['input']>;
  _temp_is_parent?: InputMaybe<Scalars['Boolean']['input']>;
  computed?: InputMaybe<Register_Participant_Computed_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  participant?: InputMaybe<Participant_Obj_Rel_Insert_Input>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  register?: InputMaybe<Register_Obj_Rel_Insert_Input>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
  sensitive_fields?: InputMaybe<Register_Participant_Sensitive_Fields_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "register_participant_latest" */
export type Register_Participant_Latest = {
  __typename?: 'register_participant_latest';
  /** An object relationship */
  participant?: Maybe<Participant>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  register?: Maybe<Register>;
  register_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "register_participant_latest" */
export type Register_Participant_Latest_Aggregate = {
  __typename?: 'register_participant_latest_aggregate';
  aggregate?: Maybe<Register_Participant_Latest_Aggregate_Fields>;
  nodes: Array<Register_Participant_Latest>;
};

/** aggregate fields of "register_participant_latest" */
export type Register_Participant_Latest_Aggregate_Fields = {
  __typename?: 'register_participant_latest_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Register_Participant_Latest_Max_Fields>;
  min?: Maybe<Register_Participant_Latest_Min_Fields>;
};


/** aggregate fields of "register_participant_latest" */
export type Register_Participant_Latest_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Register_Participant_Latest_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "register_participant_latest". All fields are combined with a logical 'AND'. */
export type Register_Participant_Latest_Bool_Exp = {
  _and?: InputMaybe<Array<Register_Participant_Latest_Bool_Exp>>;
  _not?: InputMaybe<Register_Participant_Latest_Bool_Exp>;
  _or?: InputMaybe<Array<Register_Participant_Latest_Bool_Exp>>;
  participant?: InputMaybe<Participant_Bool_Exp>;
  participant_id?: InputMaybe<Uuid_Comparison_Exp>;
  register?: InputMaybe<Register_Bool_Exp>;
  register_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Register_Participant_Latest_Max_Fields = {
  __typename?: 'register_participant_latest_max_fields';
  participant_id?: Maybe<Scalars['uuid']['output']>;
  register_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Register_Participant_Latest_Min_Fields = {
  __typename?: 'register_participant_latest_min_fields';
  participant_id?: Maybe<Scalars['uuid']['output']>;
  register_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "register_participant_latest". */
export type Register_Participant_Latest_Order_By = {
  participant?: InputMaybe<Participant_Order_By>;
  participant_id?: InputMaybe<Order_By>;
  register?: InputMaybe<Register_Order_By>;
  register_id?: InputMaybe<Order_By>;
};

/** select columns of table "register_participant_latest" */
export enum Register_Participant_Latest_Select_Column {
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  RegisterId = 'register_id'
}

/** Streaming cursor of the table "register_participant_latest" */
export type Register_Participant_Latest_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Register_Participant_Latest_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Register_Participant_Latest_Stream_Cursor_Value_Input = {
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Register_Participant_Max_Fields = {
  __typename?: 'register_participant_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  participant_age?: Maybe<Scalars['float8']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  register_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "register_participant" */
export type Register_Participant_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  register_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Register_Participant_Min_Fields = {
  __typename?: 'register_participant_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  participant_age?: Maybe<Scalars['float8']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  register_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "register_participant" */
export type Register_Participant_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  register_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "register_participant" */
export type Register_Participant_Mutation_Response = {
  __typename?: 'register_participant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Register_Participant>;
};

/** input type for inserting object relation for remote table "register_participant" */
export type Register_Participant_Obj_Rel_Insert_Input = {
  data: Register_Participant_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Register_Participant_On_Conflict>;
};

/** on_conflict condition type for table "register_participant" */
export type Register_Participant_On_Conflict = {
  constraint: Register_Participant_Constraint;
  update_columns?: Array<Register_Participant_Update_Column>;
  where?: InputMaybe<Register_Participant_Bool_Exp>;
};

/** Ordering options when selecting data from "register_participant". */
export type Register_Participant_Order_By = {
  _temp_is_child?: InputMaybe<Order_By>;
  _temp_is_parent?: InputMaybe<Order_By>;
  computed?: InputMaybe<Register_Participant_Computed_Order_By>;
  created_at?: InputMaybe<Order_By>;
  participant?: InputMaybe<Participant_Order_By>;
  participant_age?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  register?: InputMaybe<Register_Order_By>;
  register_id?: InputMaybe<Order_By>;
  sensitive_fields?: InputMaybe<Register_Participant_Sensitive_Fields_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: register_participant */
export type Register_Participant_Pk_Columns_Input = {
  participant_id: Scalars['uuid']['input'];
  register_id: Scalars['uuid']['input'];
};

/** select columns of table "register_participant" */
export enum Register_Participant_Select_Column {
  /** column name */
  TempIsChild = '_temp_is_child',
  /** column name */
  TempIsParent = '_temp_is_parent',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  RegisterId = 'register_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "register_participant_aggregate_bool_exp_bool_and_arguments_columns" columns of table "register_participant" */
export enum Register_Participant_Select_Column_Register_Participant_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  TempIsChild = '_temp_is_child',
  /** column name */
  TempIsParent = '_temp_is_parent'
}

/** select "register_participant_aggregate_bool_exp_bool_or_arguments_columns" columns of table "register_participant" */
export enum Register_Participant_Select_Column_Register_Participant_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  TempIsChild = '_temp_is_child',
  /** column name */
  TempIsParent = '_temp_is_parent'
}

/** keep sensitive fields separate, so that we can make permission on participant more lax */
export type Register_Participant_Sensitive_Fields = {
  __typename?: 'register_participant_sensitive_fields';
  created_at: Scalars['timestamptz']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  participant_id: Scalars['uuid']['output'];
  /** An object relationship */
  register: Register;
  register_id: Scalars['uuid']['output'];
  /** An object relationship */
  register_participant: Register_Participant;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "register_participant_sensitive_fields" */
export type Register_Participant_Sensitive_Fields_Aggregate = {
  __typename?: 'register_participant_sensitive_fields_aggregate';
  aggregate?: Maybe<Register_Participant_Sensitive_Fields_Aggregate_Fields>;
  nodes: Array<Register_Participant_Sensitive_Fields>;
};

/** aggregate fields of "register_participant_sensitive_fields" */
export type Register_Participant_Sensitive_Fields_Aggregate_Fields = {
  __typename?: 'register_participant_sensitive_fields_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Register_Participant_Sensitive_Fields_Max_Fields>;
  min?: Maybe<Register_Participant_Sensitive_Fields_Min_Fields>;
};


/** aggregate fields of "register_participant_sensitive_fields" */
export type Register_Participant_Sensitive_Fields_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Register_Participant_Sensitive_Fields_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "register_participant_sensitive_fields". All fields are combined with a logical 'AND'. */
export type Register_Participant_Sensitive_Fields_Bool_Exp = {
  _and?: InputMaybe<Array<Register_Participant_Sensitive_Fields_Bool_Exp>>;
  _not?: InputMaybe<Register_Participant_Sensitive_Fields_Bool_Exp>;
  _or?: InputMaybe<Array<Register_Participant_Sensitive_Fields_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  participant_id?: InputMaybe<Uuid_Comparison_Exp>;
  register?: InputMaybe<Register_Bool_Exp>;
  register_id?: InputMaybe<Uuid_Comparison_Exp>;
  register_participant?: InputMaybe<Register_Participant_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "register_participant_sensitive_fields" */
export enum Register_Participant_Sensitive_Fields_Constraint {
  /** unique or primary key constraint on columns "participant_id", "register_id" */
  RegisterParticipantSensitiveFieldsPkey = 'register_participant_sensitive_fields_pkey'
}

/** input type for inserting data into table "register_participant_sensitive_fields" */
export type Register_Participant_Sensitive_Fields_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  register?: InputMaybe<Register_Obj_Rel_Insert_Input>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
  register_participant?: InputMaybe<Register_Participant_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Register_Participant_Sensitive_Fields_Max_Fields = {
  __typename?: 'register_participant_sensitive_fields_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  register_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Register_Participant_Sensitive_Fields_Min_Fields = {
  __typename?: 'register_participant_sensitive_fields_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  participant_id?: Maybe<Scalars['uuid']['output']>;
  register_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "register_participant_sensitive_fields" */
export type Register_Participant_Sensitive_Fields_Mutation_Response = {
  __typename?: 'register_participant_sensitive_fields_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Register_Participant_Sensitive_Fields>;
};

/** input type for inserting object relation for remote table "register_participant_sensitive_fields" */
export type Register_Participant_Sensitive_Fields_Obj_Rel_Insert_Input = {
  data: Register_Participant_Sensitive_Fields_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Register_Participant_Sensitive_Fields_On_Conflict>;
};

/** on_conflict condition type for table "register_participant_sensitive_fields" */
export type Register_Participant_Sensitive_Fields_On_Conflict = {
  constraint: Register_Participant_Sensitive_Fields_Constraint;
  update_columns?: Array<Register_Participant_Sensitive_Fields_Update_Column>;
  where?: InputMaybe<Register_Participant_Sensitive_Fields_Bool_Exp>;
};

/** Ordering options when selecting data from "register_participant_sensitive_fields". */
export type Register_Participant_Sensitive_Fields_Order_By = {
  created_at?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
  register?: InputMaybe<Register_Order_By>;
  register_id?: InputMaybe<Order_By>;
  register_participant?: InputMaybe<Register_Participant_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: register_participant_sensitive_fields */
export type Register_Participant_Sensitive_Fields_Pk_Columns_Input = {
  participant_id: Scalars['uuid']['input'];
  register_id: Scalars['uuid']['input'];
};

/** select columns of table "register_participant_sensitive_fields" */
export enum Register_Participant_Sensitive_Fields_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Notes = 'notes',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  RegisterId = 'register_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "register_participant_sensitive_fields" */
export type Register_Participant_Sensitive_Fields_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "register_participant_sensitive_fields" */
export type Register_Participant_Sensitive_Fields_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Register_Participant_Sensitive_Fields_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Register_Participant_Sensitive_Fields_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "register_participant_sensitive_fields" */
export enum Register_Participant_Sensitive_Fields_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Notes = 'notes',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  RegisterId = 'register_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Register_Participant_Sensitive_Fields_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Register_Participant_Sensitive_Fields_Set_Input>;
  /** filter the rows which have to be updated */
  where: Register_Participant_Sensitive_Fields_Bool_Exp;
};

/** input type for updating data in table "register_participant" */
export type Register_Participant_Set_Input = {
  _temp_is_child?: InputMaybe<Scalars['Boolean']['input']>;
  _temp_is_parent?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Register_Participant_Stddev_Fields = {
  __typename?: 'register_participant_stddev_fields';
  participant_age?: Maybe<Scalars['float8']['output']>;
};

/** aggregate stddev_pop on columns */
export type Register_Participant_Stddev_Pop_Fields = {
  __typename?: 'register_participant_stddev_pop_fields';
  participant_age?: Maybe<Scalars['float8']['output']>;
};

/** aggregate stddev_samp on columns */
export type Register_Participant_Stddev_Samp_Fields = {
  __typename?: 'register_participant_stddev_samp_fields';
  participant_age?: Maybe<Scalars['float8']['output']>;
};

/** Streaming cursor of the table "register_participant" */
export type Register_Participant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Register_Participant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Register_Participant_Stream_Cursor_Value_Input = {
  _temp_is_child?: InputMaybe<Scalars['Boolean']['input']>;
  _temp_is_parent?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Register_Participant_Sum_Fields = {
  __typename?: 'register_participant_sum_fields';
  participant_age?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "register_participant" */
export enum Register_Participant_Update_Column {
  /** column name */
  TempIsChild = '_temp_is_child',
  /** column name */
  TempIsParent = '_temp_is_parent',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  RegisterId = 'register_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Register_Participant_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Register_Participant_Set_Input>;
  /** filter the rows which have to be updated */
  where: Register_Participant_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Register_Participant_Var_Pop_Fields = {
  __typename?: 'register_participant_var_pop_fields';
  participant_age?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_samp on columns */
export type Register_Participant_Var_Samp_Fields = {
  __typename?: 'register_participant_var_samp_fields';
  participant_age?: Maybe<Scalars['float8']['output']>;
};

/** aggregate variance on columns */
export type Register_Participant_Variance_Fields = {
  __typename?: 'register_participant_variance_fields';
  participant_age?: Maybe<Scalars['float8']['output']>;
};

/** primary key columns input for table: register */
export type Register_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "register_project_category" */
export type Register_Project_Category = {
  __typename?: 'register_project_category';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  project_category: Project_Category;
  project_category_id: Scalars['uuid']['output'];
  /** An object relationship */
  register: Register;
  register_id: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "register_project_category" */
export type Register_Project_Category_Aggregate = {
  __typename?: 'register_project_category_aggregate';
  aggregate?: Maybe<Register_Project_Category_Aggregate_Fields>;
  nodes: Array<Register_Project_Category>;
};

export type Register_Project_Category_Aggregate_Bool_Exp = {
  count?: InputMaybe<Register_Project_Category_Aggregate_Bool_Exp_Count>;
};

export type Register_Project_Category_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Register_Project_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Register_Project_Category_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "register_project_category" */
export type Register_Project_Category_Aggregate_Fields = {
  __typename?: 'register_project_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Register_Project_Category_Max_Fields>;
  min?: Maybe<Register_Project_Category_Min_Fields>;
};


/** aggregate fields of "register_project_category" */
export type Register_Project_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Register_Project_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "register_project_category" */
export type Register_Project_Category_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Register_Project_Category_Max_Order_By>;
  min?: InputMaybe<Register_Project_Category_Min_Order_By>;
};

/** input type for inserting array relation for remote table "register_project_category" */
export type Register_Project_Category_Arr_Rel_Insert_Input = {
  data: Array<Register_Project_Category_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Register_Project_Category_On_Conflict>;
};

/** Boolean expression to filter rows from the table "register_project_category". All fields are combined with a logical 'AND'. */
export type Register_Project_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Register_Project_Category_Bool_Exp>>;
  _not?: InputMaybe<Register_Project_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Register_Project_Category_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  project_category?: InputMaybe<Project_Category_Bool_Exp>;
  project_category_id?: InputMaybe<Uuid_Comparison_Exp>;
  register?: InputMaybe<Register_Bool_Exp>;
  register_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "register_project_category" */
export enum Register_Project_Category_Constraint {
  /** unique or primary key constraint on columns "project_category_id", "register_id" */
  RegisterProjectCategoryPkey = 'register_project_category_pkey'
}

/** input type for inserting data into table "register_project_category" */
export type Register_Project_Category_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  project_category?: InputMaybe<Project_Category_Obj_Rel_Insert_Input>;
  project_category_id?: InputMaybe<Scalars['uuid']['input']>;
  register?: InputMaybe<Register_Obj_Rel_Insert_Input>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Register_Project_Category_Max_Fields = {
  __typename?: 'register_project_category_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  project_category_id?: Maybe<Scalars['uuid']['output']>;
  register_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "register_project_category" */
export type Register_Project_Category_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project_category_id?: InputMaybe<Order_By>;
  register_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Register_Project_Category_Min_Fields = {
  __typename?: 'register_project_category_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  project_category_id?: Maybe<Scalars['uuid']['output']>;
  register_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "register_project_category" */
export type Register_Project_Category_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project_category_id?: InputMaybe<Order_By>;
  register_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "register_project_category" */
export type Register_Project_Category_Mutation_Response = {
  __typename?: 'register_project_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Register_Project_Category>;
};

/** on_conflict condition type for table "register_project_category" */
export type Register_Project_Category_On_Conflict = {
  constraint: Register_Project_Category_Constraint;
  update_columns?: Array<Register_Project_Category_Update_Column>;
  where?: InputMaybe<Register_Project_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "register_project_category". */
export type Register_Project_Category_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project_category?: InputMaybe<Project_Category_Order_By>;
  project_category_id?: InputMaybe<Order_By>;
  register?: InputMaybe<Register_Order_By>;
  register_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: register_project_category */
export type Register_Project_Category_Pk_Columns_Input = {
  project_category_id: Scalars['uuid']['input'];
  register_id: Scalars['uuid']['input'];
};

/** select columns of table "register_project_category" */
export enum Register_Project_Category_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ProjectCategoryId = 'project_category_id',
  /** column name */
  RegisterId = 'register_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "register_project_category" */
export type Register_Project_Category_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  project_category_id?: InputMaybe<Scalars['uuid']['input']>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "register_project_category" */
export type Register_Project_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Register_Project_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Register_Project_Category_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  project_category_id?: InputMaybe<Scalars['uuid']['input']>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "register_project_category" */
export enum Register_Project_Category_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ProjectCategoryId = 'project_category_id',
  /** column name */
  RegisterId = 'register_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Register_Project_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Register_Project_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Register_Project_Category_Bool_Exp;
};

/** select columns of table "register" */
export enum Register_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Date = 'date',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  NumberOfOrgsInAttendance = 'number_of_orgs_in_attendance',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  OverrideTotalParticipants = 'override_total_participants',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Time = 'time',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** keep sensitive fields separate, so that register permission can be more lax  */
export type Register_Sensitive_Fields = {
  __typename?: 'register_sensitive_fields';
  created_at: Scalars['timestamptz']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  permissions: Array<User_Register_Permissions>;
  /** An aggregate relationship */
  permissions_aggregate: User_Register_Permissions_Aggregate;
  /** An object relationship */
  register: Register;
  register_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** keep sensitive fields separate, so that register permission can be more lax  */
export type Register_Sensitive_FieldsPermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Register_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Register_Permissions_Order_By>>;
  where?: InputMaybe<User_Register_Permissions_Bool_Exp>;
};


/** keep sensitive fields separate, so that register permission can be more lax  */
export type Register_Sensitive_FieldsPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Register_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Register_Permissions_Order_By>>;
  where?: InputMaybe<User_Register_Permissions_Bool_Exp>;
};

/** aggregated selection of "register_sensitive_fields" */
export type Register_Sensitive_Fields_Aggregate = {
  __typename?: 'register_sensitive_fields_aggregate';
  aggregate?: Maybe<Register_Sensitive_Fields_Aggregate_Fields>;
  nodes: Array<Register_Sensitive_Fields>;
};

/** aggregate fields of "register_sensitive_fields" */
export type Register_Sensitive_Fields_Aggregate_Fields = {
  __typename?: 'register_sensitive_fields_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Register_Sensitive_Fields_Max_Fields>;
  min?: Maybe<Register_Sensitive_Fields_Min_Fields>;
};


/** aggregate fields of "register_sensitive_fields" */
export type Register_Sensitive_Fields_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Register_Sensitive_Fields_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "register_sensitive_fields". All fields are combined with a logical 'AND'. */
export type Register_Sensitive_Fields_Bool_Exp = {
  _and?: InputMaybe<Array<Register_Sensitive_Fields_Bool_Exp>>;
  _not?: InputMaybe<Register_Sensitive_Fields_Bool_Exp>;
  _or?: InputMaybe<Array<Register_Sensitive_Fields_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  permissions?: InputMaybe<User_Register_Permissions_Bool_Exp>;
  permissions_aggregate?: InputMaybe<User_Register_Permissions_Aggregate_Bool_Exp>;
  register?: InputMaybe<Register_Bool_Exp>;
  register_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "register_sensitive_fields" */
export enum Register_Sensitive_Fields_Constraint {
  /** unique or primary key constraint on columns "register_id" */
  RegisterSensitiveFieldsPkey = 'register_sensitive_fields_pkey'
}

/** input type for inserting data into table "register_sensitive_fields" */
export type Register_Sensitive_Fields_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<User_Register_Permissions_Arr_Rel_Insert_Input>;
  register?: InputMaybe<Register_Obj_Rel_Insert_Input>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Register_Sensitive_Fields_Max_Fields = {
  __typename?: 'register_sensitive_fields_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  register_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Register_Sensitive_Fields_Min_Fields = {
  __typename?: 'register_sensitive_fields_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  register_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "register_sensitive_fields" */
export type Register_Sensitive_Fields_Mutation_Response = {
  __typename?: 'register_sensitive_fields_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Register_Sensitive_Fields>;
};

/** input type for inserting object relation for remote table "register_sensitive_fields" */
export type Register_Sensitive_Fields_Obj_Rel_Insert_Input = {
  data: Register_Sensitive_Fields_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Register_Sensitive_Fields_On_Conflict>;
};

/** on_conflict condition type for table "register_sensitive_fields" */
export type Register_Sensitive_Fields_On_Conflict = {
  constraint: Register_Sensitive_Fields_Constraint;
  update_columns?: Array<Register_Sensitive_Fields_Update_Column>;
  where?: InputMaybe<Register_Sensitive_Fields_Bool_Exp>;
};

/** Ordering options when selecting data from "register_sensitive_fields". */
export type Register_Sensitive_Fields_Order_By = {
  created_at?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  permissions_aggregate?: InputMaybe<User_Register_Permissions_Aggregate_Order_By>;
  register?: InputMaybe<Register_Order_By>;
  register_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: register_sensitive_fields */
export type Register_Sensitive_Fields_Pk_Columns_Input = {
  register_id: Scalars['uuid']['input'];
};

/** select columns of table "register_sensitive_fields" */
export enum Register_Sensitive_Fields_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Notes = 'notes',
  /** column name */
  RegisterId = 'register_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "register_sensitive_fields" */
export type Register_Sensitive_Fields_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "register_sensitive_fields" */
export type Register_Sensitive_Fields_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Register_Sensitive_Fields_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Register_Sensitive_Fields_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  register_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "register_sensitive_fields" */
export enum Register_Sensitive_Fields_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Notes = 'notes',
  /** column name */
  RegisterId = 'register_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Register_Sensitive_Fields_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Register_Sensitive_Fields_Set_Input>;
  /** filter the rows which have to be updated */
  where: Register_Sensitive_Fields_Bool_Exp;
};

/** input type for updating data in table "register" */
export type Register_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  number_of_orgs_in_attendance?: InputMaybe<Scalars['Int']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  override_total_participants?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  time?: InputMaybe<Scalars['time']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Register_Stddev_Fields = {
  __typename?: 'register_stddev_fields';
  number_of_orgs_in_attendance?: Maybe<Scalars['Float']['output']>;
  override_total_participants?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "register" */
export type Register_Stddev_Order_By = {
  number_of_orgs_in_attendance?: InputMaybe<Order_By>;
  override_total_participants?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Register_Stddev_Pop_Fields = {
  __typename?: 'register_stddev_pop_fields';
  number_of_orgs_in_attendance?: Maybe<Scalars['Float']['output']>;
  override_total_participants?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "register" */
export type Register_Stddev_Pop_Order_By = {
  number_of_orgs_in_attendance?: InputMaybe<Order_By>;
  override_total_participants?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Register_Stddev_Samp_Fields = {
  __typename?: 'register_stddev_samp_fields';
  number_of_orgs_in_attendance?: Maybe<Scalars['Float']['output']>;
  override_total_participants?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "register" */
export type Register_Stddev_Samp_Order_By = {
  number_of_orgs_in_attendance?: InputMaybe<Order_By>;
  override_total_participants?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "register" */
export type Register_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Register_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Register_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  number_of_orgs_in_attendance?: InputMaybe<Scalars['Int']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  override_total_participants?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  time?: InputMaybe<Scalars['time']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Register_Sum_Fields = {
  __typename?: 'register_sum_fields';
  number_of_orgs_in_attendance?: Maybe<Scalars['Int']['output']>;
  override_total_participants?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "register" */
export type Register_Sum_Order_By = {
  number_of_orgs_in_attendance?: InputMaybe<Order_By>;
  override_total_participants?: InputMaybe<Order_By>;
};

/** update columns of table "register" */
export enum Register_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Date = 'date',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  NumberOfOrgsInAttendance = 'number_of_orgs_in_attendance',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  OverrideTotalParticipants = 'override_total_participants',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Time = 'time',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Register_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Register_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Register_Set_Input>;
  /** filter the rows which have to be updated */
  where: Register_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Register_Var_Pop_Fields = {
  __typename?: 'register_var_pop_fields';
  number_of_orgs_in_attendance?: Maybe<Scalars['Float']['output']>;
  override_total_participants?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "register" */
export type Register_Var_Pop_Order_By = {
  number_of_orgs_in_attendance?: InputMaybe<Order_By>;
  override_total_participants?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Register_Var_Samp_Fields = {
  __typename?: 'register_var_samp_fields';
  number_of_orgs_in_attendance?: Maybe<Scalars['Float']['output']>;
  override_total_participants?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "register" */
export type Register_Var_Samp_Order_By = {
  number_of_orgs_in_attendance?: InputMaybe<Order_By>;
  override_total_participants?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Register_Variance_Fields = {
  __typename?: 'register_variance_fields';
  number_of_orgs_in_attendance?: Maybe<Scalars['Float']['output']>;
  override_total_participants?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "register" */
export type Register_Variance_Order_By = {
  number_of_orgs_in_attendance?: InputMaybe<Order_By>;
  override_total_participants?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "language" */
  language: Array<Language>;
  /** fetch aggregated fields from the table: "language" */
  language_aggregate: Language_Aggregate;
  /** fetch data from the table: "language" using primary key columns */
  language_by_pk?: Maybe<Language>;
  /** fetch data from the table in a streaming manner: "language" */
  language_stream: Array<Language>;
  /** fetch data from the table: "location" */
  location: Array<Location>;
  /** fetch aggregated fields from the table: "location" */
  location_aggregate: Location_Aggregate;
  /** fetch data from the table: "location" using primary key columns */
  location_by_pk?: Maybe<Location>;
  /** fetch data from the table in a streaming manner: "location" */
  location_stream: Array<Location>;
  /** fetch data from the table: "organisation" */
  organisation: Array<Organisation>;
  /** fetch aggregated fields from the table: "organisation" */
  organisation_aggregate: Organisation_Aggregate;
  /** fetch data from the table: "organisation" using primary key columns */
  organisation_by_pk?: Maybe<Organisation>;
  /** fetch data from the table: "organisation_manager" */
  organisation_manager: Array<Organisation_Manager>;
  /** fetch aggregated fields from the table: "organisation_manager" */
  organisation_manager_aggregate: Organisation_Manager_Aggregate;
  /** fetch data from the table: "organisation_manager" using primary key columns */
  organisation_manager_by_pk?: Maybe<Organisation_Manager>;
  /** fetch data from the table in a streaming manner: "organisation_manager" */
  organisation_manager_stream: Array<Organisation_Manager>;
  /** fetch data from the table: "organisation_participant" */
  organisation_participant: Array<Organisation_Participant>;
  /** fetch aggregated fields from the table: "organisation_participant" */
  organisation_participant_aggregate: Organisation_Participant_Aggregate;
  /** fetch data from the table: "organisation_participant" using primary key columns */
  organisation_participant_by_pk?: Maybe<Organisation_Participant>;
  /** fetch data from the table in a streaming manner: "organisation_participant" */
  organisation_participant_stream: Array<Organisation_Participant>;
  /** fetch data from the table: "organisation_programme" */
  organisation_programme: Array<Organisation_Programme>;
  /** fetch aggregated fields from the table: "organisation_programme" */
  organisation_programme_aggregate: Organisation_Programme_Aggregate;
  /** fetch data from the table: "organisation_programme" using primary key columns */
  organisation_programme_by_pk?: Maybe<Organisation_Programme>;
  /** fetch data from the table in a streaming manner: "organisation_programme" */
  organisation_programme_stream: Array<Organisation_Programme>;
  /** fetch data from the table: "organisation_restricted_access_users" */
  organisation_restricted_access_users: Array<Organisation_Restricted_Access_Users>;
  /** fetch aggregated fields from the table: "organisation_restricted_access_users" */
  organisation_restricted_access_users_aggregate: Organisation_Restricted_Access_Users_Aggregate;
  /** fetch data from the table: "organisation_restricted_access_users" using primary key columns */
  organisation_restricted_access_users_by_pk?: Maybe<Organisation_Restricted_Access_Users>;
  /** fetch data from the table in a streaming manner: "organisation_restricted_access_users" */
  organisation_restricted_access_users_stream: Array<Organisation_Restricted_Access_Users>;
  /** fetch data from the table: "organisation_siloed_user" */
  organisation_siloed_user: Array<Organisation_Siloed_User>;
  /** fetch aggregated fields from the table: "organisation_siloed_user" */
  organisation_siloed_user_aggregate: Organisation_Siloed_User_Aggregate;
  /** fetch data from the table: "organisation_siloed_user" using primary key columns */
  organisation_siloed_user_by_pk?: Maybe<Organisation_Siloed_User>;
  /** fetch data from the table in a streaming manner: "organisation_siloed_user" */
  organisation_siloed_user_stream: Array<Organisation_Siloed_User>;
  /** fetch data from the table in a streaming manner: "organisation" */
  organisation_stream: Array<Organisation>;
  /** fetch data from the table: "organisation_user" */
  organisation_user: Array<Organisation_User>;
  /** fetch aggregated fields from the table: "organisation_user" */
  organisation_user_aggregate: Organisation_User_Aggregate;
  /** fetch data from the table: "organisation_user" using primary key columns */
  organisation_user_by_pk?: Maybe<Organisation_User>;
  /** fetch data from the table in a streaming manner: "organisation_user" */
  organisation_user_stream: Array<Organisation_User>;
  /** fetch data from the table: "parent_child" */
  parent_child: Array<Parent_Child>;
  /** fetch aggregated fields from the table: "parent_child" */
  parent_child_aggregate: Parent_Child_Aggregate;
  /** fetch data from the table: "parent_child" using primary key columns */
  parent_child_by_pk?: Maybe<Parent_Child>;
  /** fetch data from the table in a streaming manner: "parent_child" */
  parent_child_stream: Array<Parent_Child>;
  /** fetch data from the table: "participant" */
  participant: Array<Participant>;
  /** fetch aggregated fields from the table: "participant" */
  participant_aggregate: Participant_Aggregate;
  /** fetch data from the table: "participant" using primary key columns */
  participant_by_pk?: Maybe<Participant>;
  /** An array relationship */
  participant_files: Array<Participant_Files>;
  /** An aggregate relationship */
  participant_files_aggregate: Participant_Files_Aggregate;
  /** fetch data from the table: "participant_files" using primary key columns */
  participant_files_by_pk?: Maybe<Participant_Files>;
  /** fetch data from the table in a streaming manner: "participant_files" */
  participant_files_stream: Array<Participant_Files>;
  /** fetch data from the table: "participant_language" */
  participant_language: Array<Participant_Language>;
  /** fetch aggregated fields from the table: "participant_language" */
  participant_language_aggregate: Participant_Language_Aggregate;
  /** fetch data from the table: "participant_language" using primary key columns */
  participant_language_by_pk?: Maybe<Participant_Language>;
  /** fetch data from the table in a streaming manner: "participant_language" */
  participant_language_stream: Array<Participant_Language>;
  /** execute function "participant_search_by_name" which returns "participant" */
  participant_search_by_name: Array<Participant>;
  /** execute function "participant_search_by_name" and query aggregates on result of table type "participant" */
  participant_search_by_name_aggregate: Participant_Aggregate;
  /** execute function "participant_search_by_name_sensitive" which returns "participant_sensitive_fields" */
  participant_search_by_name_sensitive: Array<Participant_Sensitive_Fields>;
  /** execute function "participant_search_by_name_sensitive" and query aggregates on result of table type "participant_sensitive_fields" */
  participant_search_by_name_sensitive_aggregate: Participant_Sensitive_Fields_Aggregate;
  /** fetch data from the table: "participant_sensitive_fields" */
  participant_sensitive_fields: Array<Participant_Sensitive_Fields>;
  /** fetch aggregated fields from the table: "participant_sensitive_fields" */
  participant_sensitive_fields_aggregate: Participant_Sensitive_Fields_Aggregate;
  /** fetch data from the table: "participant_sensitive_fields" using primary key columns */
  participant_sensitive_fields_by_pk?: Maybe<Participant_Sensitive_Fields>;
  /** fetch data from the table in a streaming manner: "participant_sensitive_fields" */
  participant_sensitive_fields_stream: Array<Participant_Sensitive_Fields>;
  /** fetch data from the table: "participant_sibling" */
  participant_sibling: Array<Participant_Sibling>;
  /** fetch aggregated fields from the table: "participant_sibling" */
  participant_sibling_aggregate: Participant_Sibling_Aggregate;
  /** fetch data from the table: "participant_sibling" using primary key columns */
  participant_sibling_by_pk?: Maybe<Participant_Sibling>;
  /** fetch data from the table in a streaming manner: "participant_sibling" */
  participant_sibling_stream: Array<Participant_Sibling>;
  /** fetch data from the table in a streaming manner: "participant" */
  participant_stream: Array<Participant>;
  /** fetch data from the table: "programme" */
  programme: Array<Programme>;
  /** fetch aggregated fields from the table: "programme" */
  programme_aggregate: Programme_Aggregate;
  /** fetch data from the table: "programme" using primary key columns */
  programme_by_pk?: Maybe<Programme>;
  /** fetch data from the table: "programme_group" */
  programme_group: Array<Programme_Group>;
  /** fetch aggregated fields from the table: "programme_group" */
  programme_group_aggregate: Programme_Group_Aggregate;
  /** fetch data from the table: "programme_group" using primary key columns */
  programme_group_by_pk?: Maybe<Programme_Group>;
  /** fetch data from the table in a streaming manner: "programme_group" */
  programme_group_stream: Array<Programme_Group>;
  /** fetch data from the table: "programme_location" */
  programme_location: Array<Programme_Location>;
  /** fetch aggregated fields from the table: "programme_location" */
  programme_location_aggregate: Programme_Location_Aggregate;
  /** fetch data from the table: "programme_location" using primary key columns */
  programme_location_by_pk?: Maybe<Programme_Location>;
  /** fetch data from the table in a streaming manner: "programme_location" */
  programme_location_stream: Array<Programme_Location>;
  /** fetch data from the table: "programme_participant" */
  programme_participant: Array<Programme_Participant>;
  /** fetch aggregated fields from the table: "programme_participant" */
  programme_participant_aggregate: Programme_Participant_Aggregate;
  /** fetch data from the table: "programme_participant" using primary key columns */
  programme_participant_by_pk?: Maybe<Programme_Participant>;
  /** fetch data from the table in a streaming manner: "programme_participant" */
  programme_participant_stream: Array<Programme_Participant>;
  /** fetch data from the table in a streaming manner: "programme" */
  programme_stream: Array<Programme>;
  /** fetch data from the table: "project" */
  project: Array<Project>;
  /** fetch aggregated fields from the table: "project" */
  project_aggregate: Project_Aggregate;
  /** fetch data from the table: "project" using primary key columns */
  project_by_pk?: Maybe<Project>;
  /** fetch data from the table: "project_category" */
  project_category: Array<Project_Category>;
  /** fetch aggregated fields from the table: "project_category" */
  project_category_aggregate: Project_Category_Aggregate;
  /** fetch data from the table: "project_category" using primary key columns */
  project_category_by_pk?: Maybe<Project_Category>;
  /** fetch data from the table in a streaming manner: "project_category" */
  project_category_stream: Array<Project_Category>;
  /** fetch data from the table in a streaming manner: "project" */
  project_stream: Array<Project>;
  /** fetch data from the table: "register" */
  register: Array<Register>;
  /** fetch aggregated fields from the table: "register" */
  register_aggregate: Register_Aggregate;
  /** fetch data from the table: "register" using primary key columns */
  register_by_pk?: Maybe<Register>;
  /** fetch data from the table: "register_facilitator" */
  register_facilitator: Array<Register_Facilitator>;
  /** fetch aggregated fields from the table: "register_facilitator" */
  register_facilitator_aggregate: Register_Facilitator_Aggregate;
  /** fetch data from the table: "register_facilitator" using primary key columns */
  register_facilitator_by_pk?: Maybe<Register_Facilitator>;
  /** fetch data from the table in a streaming manner: "register_facilitator" */
  register_facilitator_stream: Array<Register_Facilitator>;
  /** fetch data from the table: "register_participant" */
  register_participant: Array<Register_Participant>;
  /** fetch aggregated fields from the table: "register_participant" */
  register_participant_aggregate: Register_Participant_Aggregate;
  /** fetch data from the table: "register_participant" using primary key columns */
  register_participant_by_pk?: Maybe<Register_Participant>;
  /** fetch data from the table: "register_participant_computed" */
  register_participant_computed: Array<Register_Participant_Computed>;
  /** fetch aggregated fields from the table: "register_participant_computed" */
  register_participant_computed_aggregate: Register_Participant_Computed_Aggregate;
  /** fetch data from the table in a streaming manner: "register_participant_computed" */
  register_participant_computed_stream: Array<Register_Participant_Computed>;
  /** fetch data from the table: "register_participant_latest" */
  register_participant_latest: Array<Register_Participant_Latest>;
  /** fetch aggregated fields from the table: "register_participant_latest" */
  register_participant_latest_aggregate: Register_Participant_Latest_Aggregate;
  /** fetch data from the table in a streaming manner: "register_participant_latest" */
  register_participant_latest_stream: Array<Register_Participant_Latest>;
  /** fetch data from the table: "register_participant_sensitive_fields" */
  register_participant_sensitive_fields: Array<Register_Participant_Sensitive_Fields>;
  /** fetch aggregated fields from the table: "register_participant_sensitive_fields" */
  register_participant_sensitive_fields_aggregate: Register_Participant_Sensitive_Fields_Aggregate;
  /** fetch data from the table: "register_participant_sensitive_fields" using primary key columns */
  register_participant_sensitive_fields_by_pk?: Maybe<Register_Participant_Sensitive_Fields>;
  /** fetch data from the table in a streaming manner: "register_participant_sensitive_fields" */
  register_participant_sensitive_fields_stream: Array<Register_Participant_Sensitive_Fields>;
  /** fetch data from the table in a streaming manner: "register_participant" */
  register_participant_stream: Array<Register_Participant>;
  /** An array relationship */
  register_project_category: Array<Register_Project_Category>;
  /** An aggregate relationship */
  register_project_category_aggregate: Register_Project_Category_Aggregate;
  /** fetch data from the table: "register_project_category" using primary key columns */
  register_project_category_by_pk?: Maybe<Register_Project_Category>;
  /** fetch data from the table in a streaming manner: "register_project_category" */
  register_project_category_stream: Array<Register_Project_Category>;
  /** fetch data from the table: "register_sensitive_fields" */
  register_sensitive_fields: Array<Register_Sensitive_Fields>;
  /** fetch aggregated fields from the table: "register_sensitive_fields" */
  register_sensitive_fields_aggregate: Register_Sensitive_Fields_Aggregate;
  /** fetch data from the table: "register_sensitive_fields" using primary key columns */
  register_sensitive_fields_by_pk?: Maybe<Register_Sensitive_Fields>;
  /** fetch data from the table in a streaming manner: "register_sensitive_fields" */
  register_sensitive_fields_stream: Array<Register_Sensitive_Fields>;
  /** fetch data from the table in a streaming manner: "register" */
  register_stream: Array<Register>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_language" */
  user_language: Array<User_Language>;
  /** fetch aggregated fields from the table: "user_language" */
  user_language_aggregate: User_Language_Aggregate;
  /** fetch data from the table: "user_language" using primary key columns */
  user_language_by_pk?: Maybe<User_Language>;
  /** fetch data from the table in a streaming manner: "user_language" */
  user_language_stream: Array<User_Language>;
  /** fetch data from the table: "user_login_code" */
  user_login_code: Array<User_Login_Code>;
  /** fetch aggregated fields from the table: "user_login_code" */
  user_login_code_aggregate: User_Login_Code_Aggregate;
  /** fetch data from the table: "user_login_code" using primary key columns */
  user_login_code_by_pk?: Maybe<User_Login_Code>;
  /** fetch data from the table in a streaming manner: "user_login_code" */
  user_login_code_stream: Array<User_Login_Code>;
  /** fetch data from the table: "user_participant_permissions" */
  user_participant_permissions: Array<User_Participant_Permissions>;
  /** fetch aggregated fields from the table: "user_participant_permissions" */
  user_participant_permissions_aggregate: User_Participant_Permissions_Aggregate;
  /** fetch data from the table in a streaming manner: "user_participant_permissions" */
  user_participant_permissions_stream: Array<User_Participant_Permissions>;
  /** fetch data from the table: "user_register_permissions" */
  user_register_permissions: Array<User_Register_Permissions>;
  /** fetch aggregated fields from the table: "user_register_permissions" */
  user_register_permissions_aggregate: User_Register_Permissions_Aggregate;
  /** fetch data from the table in a streaming manner: "user_register_permissions" */
  user_register_permissions_stream: Array<User_Register_Permissions>;
  /** fetch data from the table in a streaming manner: "user" */
  user_stream: Array<User>;
  /** fetch data from the table: "user_warning" */
  user_warning: Array<User_Warning>;
  /** fetch aggregated fields from the table: "user_warning" */
  user_warning_aggregate: User_Warning_Aggregate;
  /** fetch data from the table: "user_warning" using primary key columns */
  user_warning_by_pk?: Maybe<User_Warning>;
  /** fetch data from the table in a streaming manner: "user_warning" */
  user_warning_stream: Array<User_Warning>;
  /** fetch data from the table: "warning" */
  warning: Array<Warning>;
  /** fetch aggregated fields from the table: "warning" */
  warning_aggregate: Warning_Aggregate;
  /** fetch data from the table: "warning" using primary key columns */
  warning_by_pk?: Maybe<Warning>;
  /** fetch data from the table in a streaming manner: "warning" */
  warning_stream: Array<Warning>;
};


export type Subscription_RootLanguageArgs = {
  distinct_on?: InputMaybe<Array<Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Language_Order_By>>;
  where?: InputMaybe<Language_Bool_Exp>;
};


export type Subscription_RootLanguage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Language_Order_By>>;
  where?: InputMaybe<Language_Bool_Exp>;
};


export type Subscription_RootLanguage_By_PkArgs = {
  code: Scalars['String']['input'];
};


export type Subscription_RootLanguage_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Language_Stream_Cursor_Input>>;
  where?: InputMaybe<Language_Bool_Exp>;
};


export type Subscription_RootLocationArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Subscription_RootLocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Subscription_RootLocation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLocation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Subscription_RootOrganisationArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Subscription_RootOrganisation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Subscription_RootOrganisation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganisation_ManagerArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Manager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Manager_Order_By>>;
  where?: InputMaybe<Organisation_Manager_Bool_Exp>;
};


export type Subscription_RootOrganisation_Manager_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Manager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Manager_Order_By>>;
  where?: InputMaybe<Organisation_Manager_Bool_Exp>;
};


export type Subscription_RootOrganisation_Manager_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganisation_Manager_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organisation_Manager_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Manager_Bool_Exp>;
};


export type Subscription_RootOrganisation_ParticipantArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Participant_Order_By>>;
  where?: InputMaybe<Organisation_Participant_Bool_Exp>;
};


export type Subscription_RootOrganisation_Participant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Participant_Order_By>>;
  where?: InputMaybe<Organisation_Participant_Bool_Exp>;
};


export type Subscription_RootOrganisation_Participant_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  participant_id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganisation_Participant_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organisation_Participant_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Participant_Bool_Exp>;
};


export type Subscription_RootOrganisation_ProgrammeArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Programme_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Programme_Order_By>>;
  where?: InputMaybe<Organisation_Programme_Bool_Exp>;
};


export type Subscription_RootOrganisation_Programme_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Programme_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Programme_Order_By>>;
  where?: InputMaybe<Organisation_Programme_Bool_Exp>;
};


export type Subscription_RootOrganisation_Programme_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  programme_id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganisation_Programme_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organisation_Programme_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Programme_Bool_Exp>;
};


export type Subscription_RootOrganisation_Restricted_Access_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Restricted_Access_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Restricted_Access_Users_Order_By>>;
  where?: InputMaybe<Organisation_Restricted_Access_Users_Bool_Exp>;
};


export type Subscription_RootOrganisation_Restricted_Access_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Restricted_Access_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Restricted_Access_Users_Order_By>>;
  where?: InputMaybe<Organisation_Restricted_Access_Users_Bool_Exp>;
};


export type Subscription_RootOrganisation_Restricted_Access_Users_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganisation_Restricted_Access_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organisation_Restricted_Access_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Restricted_Access_Users_Bool_Exp>;
};


export type Subscription_RootOrganisation_Siloed_UserArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Siloed_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Siloed_User_Order_By>>;
  where?: InputMaybe<Organisation_Siloed_User_Bool_Exp>;
};


export type Subscription_RootOrganisation_Siloed_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Siloed_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Siloed_User_Order_By>>;
  where?: InputMaybe<Organisation_Siloed_User_Bool_Exp>;
};


export type Subscription_RootOrganisation_Siloed_User_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganisation_Siloed_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organisation_Siloed_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Siloed_User_Bool_Exp>;
};


export type Subscription_RootOrganisation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organisation_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Subscription_RootOrganisation_UserArgs = {
  distinct_on?: InputMaybe<Array<Organisation_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_User_Order_By>>;
  where?: InputMaybe<Organisation_User_Bool_Exp>;
};


export type Subscription_RootOrganisation_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_User_Order_By>>;
  where?: InputMaybe<Organisation_User_Bool_Exp>;
};


export type Subscription_RootOrganisation_User_By_PkArgs = {
  organisation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganisation_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organisation_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_User_Bool_Exp>;
};


export type Subscription_RootParent_ChildArgs = {
  distinct_on?: InputMaybe<Array<Parent_Child_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parent_Child_Order_By>>;
  where?: InputMaybe<Parent_Child_Bool_Exp>;
};


export type Subscription_RootParent_Child_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parent_Child_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parent_Child_Order_By>>;
  where?: InputMaybe<Parent_Child_Bool_Exp>;
};


export type Subscription_RootParent_Child_By_PkArgs = {
  child_id: Scalars['uuid']['input'];
  parent_id: Scalars['uuid']['input'];
};


export type Subscription_RootParent_Child_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parent_Child_Stream_Cursor_Input>>;
  where?: InputMaybe<Parent_Child_Bool_Exp>;
};


export type Subscription_RootParticipantArgs = {
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


export type Subscription_RootParticipant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


export type Subscription_RootParticipant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootParticipant_FilesArgs = {
  distinct_on?: InputMaybe<Array<Participant_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Files_Order_By>>;
  where?: InputMaybe<Participant_Files_Bool_Exp>;
};


export type Subscription_RootParticipant_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Files_Order_By>>;
  where?: InputMaybe<Participant_Files_Bool_Exp>;
};


export type Subscription_RootParticipant_Files_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootParticipant_Files_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Participant_Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Participant_Files_Bool_Exp>;
};


export type Subscription_RootParticipant_LanguageArgs = {
  distinct_on?: InputMaybe<Array<Participant_Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Language_Order_By>>;
  where?: InputMaybe<Participant_Language_Bool_Exp>;
};


export type Subscription_RootParticipant_Language_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Language_Order_By>>;
  where?: InputMaybe<Participant_Language_Bool_Exp>;
};


export type Subscription_RootParticipant_Language_By_PkArgs = {
  language_code: Scalars['String']['input'];
  participant_id: Scalars['uuid']['input'];
};


export type Subscription_RootParticipant_Language_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Participant_Language_Stream_Cursor_Input>>;
  where?: InputMaybe<Participant_Language_Bool_Exp>;
};


export type Subscription_RootParticipant_Search_By_NameArgs = {
  args: Participant_Search_By_Name_Args;
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


export type Subscription_RootParticipant_Search_By_Name_AggregateArgs = {
  args: Participant_Search_By_Name_Args;
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


export type Subscription_RootParticipant_Search_By_Name_SensitiveArgs = {
  args: Participant_Search_By_Name_Sensitive_Args;
  distinct_on?: InputMaybe<Array<Participant_Sensitive_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Sensitive_Fields_Order_By>>;
  where?: InputMaybe<Participant_Sensitive_Fields_Bool_Exp>;
};


export type Subscription_RootParticipant_Search_By_Name_Sensitive_AggregateArgs = {
  args: Participant_Search_By_Name_Sensitive_Args;
  distinct_on?: InputMaybe<Array<Participant_Sensitive_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Sensitive_Fields_Order_By>>;
  where?: InputMaybe<Participant_Sensitive_Fields_Bool_Exp>;
};


export type Subscription_RootParticipant_Sensitive_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Participant_Sensitive_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Sensitive_Fields_Order_By>>;
  where?: InputMaybe<Participant_Sensitive_Fields_Bool_Exp>;
};


export type Subscription_RootParticipant_Sensitive_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Sensitive_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Sensitive_Fields_Order_By>>;
  where?: InputMaybe<Participant_Sensitive_Fields_Bool_Exp>;
};


export type Subscription_RootParticipant_Sensitive_Fields_By_PkArgs = {
  participant_id: Scalars['uuid']['input'];
};


export type Subscription_RootParticipant_Sensitive_Fields_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Participant_Sensitive_Fields_Stream_Cursor_Input>>;
  where?: InputMaybe<Participant_Sensitive_Fields_Bool_Exp>;
};


export type Subscription_RootParticipant_SiblingArgs = {
  distinct_on?: InputMaybe<Array<Participant_Sibling_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Sibling_Order_By>>;
  where?: InputMaybe<Participant_Sibling_Bool_Exp>;
};


export type Subscription_RootParticipant_Sibling_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Sibling_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Participant_Sibling_Order_By>>;
  where?: InputMaybe<Participant_Sibling_Bool_Exp>;
};


export type Subscription_RootParticipant_Sibling_By_PkArgs = {
  participant_id: Scalars['uuid']['input'];
  sibling_id: Scalars['uuid']['input'];
};


export type Subscription_RootParticipant_Sibling_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Participant_Sibling_Stream_Cursor_Input>>;
  where?: InputMaybe<Participant_Sibling_Bool_Exp>;
};


export type Subscription_RootParticipant_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Participant_Stream_Cursor_Input>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


export type Subscription_RootProgrammeArgs = {
  distinct_on?: InputMaybe<Array<Programme_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Order_By>>;
  where?: InputMaybe<Programme_Bool_Exp>;
};


export type Subscription_RootProgramme_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Programme_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Order_By>>;
  where?: InputMaybe<Programme_Bool_Exp>;
};


export type Subscription_RootProgramme_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProgramme_GroupArgs = {
  distinct_on?: InputMaybe<Array<Programme_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Group_Order_By>>;
  where?: InputMaybe<Programme_Group_Bool_Exp>;
};


export type Subscription_RootProgramme_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Programme_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Group_Order_By>>;
  where?: InputMaybe<Programme_Group_Bool_Exp>;
};


export type Subscription_RootProgramme_Group_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProgramme_Group_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Programme_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Programme_Group_Bool_Exp>;
};


export type Subscription_RootProgramme_LocationArgs = {
  distinct_on?: InputMaybe<Array<Programme_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Location_Order_By>>;
  where?: InputMaybe<Programme_Location_Bool_Exp>;
};


export type Subscription_RootProgramme_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Programme_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Location_Order_By>>;
  where?: InputMaybe<Programme_Location_Bool_Exp>;
};


export type Subscription_RootProgramme_Location_By_PkArgs = {
  location_id: Scalars['uuid']['input'];
  programme_id: Scalars['uuid']['input'];
};


export type Subscription_RootProgramme_Location_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Programme_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Programme_Location_Bool_Exp>;
};


export type Subscription_RootProgramme_ParticipantArgs = {
  distinct_on?: InputMaybe<Array<Programme_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Participant_Order_By>>;
  where?: InputMaybe<Programme_Participant_Bool_Exp>;
};


export type Subscription_RootProgramme_Participant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Programme_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Programme_Participant_Order_By>>;
  where?: InputMaybe<Programme_Participant_Bool_Exp>;
};


export type Subscription_RootProgramme_Participant_By_PkArgs = {
  participant_id: Scalars['uuid']['input'];
  programme_id: Scalars['uuid']['input'];
};


export type Subscription_RootProgramme_Participant_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Programme_Participant_Stream_Cursor_Input>>;
  where?: InputMaybe<Programme_Participant_Bool_Exp>;
};


export type Subscription_RootProgramme_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Programme_Stream_Cursor_Input>>;
  where?: InputMaybe<Programme_Bool_Exp>;
};


export type Subscription_RootProjectArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootProject_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootProject_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Project_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Category_Order_By>>;
  where?: InputMaybe<Project_Category_Bool_Exp>;
};


export type Subscription_RootProject_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Category_Order_By>>;
  where?: InputMaybe<Project_Category_Bool_Exp>;
};


export type Subscription_RootProject_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Category_Bool_Exp>;
};


export type Subscription_RootProject_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootRegisterArgs = {
  distinct_on?: InputMaybe<Array<Register_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Order_By>>;
  where?: InputMaybe<Register_Bool_Exp>;
};


export type Subscription_RootRegister_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Order_By>>;
  where?: InputMaybe<Register_Bool_Exp>;
};


export type Subscription_RootRegister_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRegister_FacilitatorArgs = {
  distinct_on?: InputMaybe<Array<Register_Facilitator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Facilitator_Order_By>>;
  where?: InputMaybe<Register_Facilitator_Bool_Exp>;
};


export type Subscription_RootRegister_Facilitator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Facilitator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Facilitator_Order_By>>;
  where?: InputMaybe<Register_Facilitator_Bool_Exp>;
};


export type Subscription_RootRegister_Facilitator_By_PkArgs = {
  facilitator_id: Scalars['uuid']['input'];
  register_id: Scalars['uuid']['input'];
};


export type Subscription_RootRegister_Facilitator_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Register_Facilitator_Stream_Cursor_Input>>;
  where?: InputMaybe<Register_Facilitator_Bool_Exp>;
};


export type Subscription_RootRegister_ParticipantArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Order_By>>;
  where?: InputMaybe<Register_Participant_Bool_Exp>;
};


export type Subscription_RootRegister_Participant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Order_By>>;
  where?: InputMaybe<Register_Participant_Bool_Exp>;
};


export type Subscription_RootRegister_Participant_By_PkArgs = {
  participant_id: Scalars['uuid']['input'];
  register_id: Scalars['uuid']['input'];
};


export type Subscription_RootRegister_Participant_ComputedArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Computed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Computed_Order_By>>;
  where?: InputMaybe<Register_Participant_Computed_Bool_Exp>;
};


export type Subscription_RootRegister_Participant_Computed_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Computed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Computed_Order_By>>;
  where?: InputMaybe<Register_Participant_Computed_Bool_Exp>;
};


export type Subscription_RootRegister_Participant_Computed_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Register_Participant_Computed_Stream_Cursor_Input>>;
  where?: InputMaybe<Register_Participant_Computed_Bool_Exp>;
};


export type Subscription_RootRegister_Participant_LatestArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Latest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Latest_Order_By>>;
  where?: InputMaybe<Register_Participant_Latest_Bool_Exp>;
};


export type Subscription_RootRegister_Participant_Latest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Latest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Latest_Order_By>>;
  where?: InputMaybe<Register_Participant_Latest_Bool_Exp>;
};


export type Subscription_RootRegister_Participant_Latest_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Register_Participant_Latest_Stream_Cursor_Input>>;
  where?: InputMaybe<Register_Participant_Latest_Bool_Exp>;
};


export type Subscription_RootRegister_Participant_Sensitive_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Sensitive_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Sensitive_Fields_Order_By>>;
  where?: InputMaybe<Register_Participant_Sensitive_Fields_Bool_Exp>;
};


export type Subscription_RootRegister_Participant_Sensitive_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Participant_Sensitive_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Participant_Sensitive_Fields_Order_By>>;
  where?: InputMaybe<Register_Participant_Sensitive_Fields_Bool_Exp>;
};


export type Subscription_RootRegister_Participant_Sensitive_Fields_By_PkArgs = {
  participant_id: Scalars['uuid']['input'];
  register_id: Scalars['uuid']['input'];
};


export type Subscription_RootRegister_Participant_Sensitive_Fields_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Register_Participant_Sensitive_Fields_Stream_Cursor_Input>>;
  where?: InputMaybe<Register_Participant_Sensitive_Fields_Bool_Exp>;
};


export type Subscription_RootRegister_Participant_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Register_Participant_Stream_Cursor_Input>>;
  where?: InputMaybe<Register_Participant_Bool_Exp>;
};


export type Subscription_RootRegister_Project_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Register_Project_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Project_Category_Order_By>>;
  where?: InputMaybe<Register_Project_Category_Bool_Exp>;
};


export type Subscription_RootRegister_Project_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Project_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Project_Category_Order_By>>;
  where?: InputMaybe<Register_Project_Category_Bool_Exp>;
};


export type Subscription_RootRegister_Project_Category_By_PkArgs = {
  project_category_id: Scalars['uuid']['input'];
  register_id: Scalars['uuid']['input'];
};


export type Subscription_RootRegister_Project_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Register_Project_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Register_Project_Category_Bool_Exp>;
};


export type Subscription_RootRegister_Sensitive_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Register_Sensitive_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Sensitive_Fields_Order_By>>;
  where?: InputMaybe<Register_Sensitive_Fields_Bool_Exp>;
};


export type Subscription_RootRegister_Sensitive_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Sensitive_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Sensitive_Fields_Order_By>>;
  where?: InputMaybe<Register_Sensitive_Fields_Bool_Exp>;
};


export type Subscription_RootRegister_Sensitive_Fields_By_PkArgs = {
  register_id: Scalars['uuid']['input'];
};


export type Subscription_RootRegister_Sensitive_Fields_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Register_Sensitive_Fields_Stream_Cursor_Input>>;
  where?: InputMaybe<Register_Sensitive_Fields_Bool_Exp>;
};


export type Subscription_RootRegister_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Register_Stream_Cursor_Input>>;
  where?: InputMaybe<Register_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_LanguageArgs = {
  distinct_on?: InputMaybe<Array<User_Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Language_Order_By>>;
  where?: InputMaybe<User_Language_Bool_Exp>;
};


export type Subscription_RootUser_Language_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Language_Order_By>>;
  where?: InputMaybe<User_Language_Bool_Exp>;
};


export type Subscription_RootUser_Language_By_PkArgs = {
  language_code: Scalars['String']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Language_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Language_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Language_Bool_Exp>;
};


export type Subscription_RootUser_Login_CodeArgs = {
  distinct_on?: InputMaybe<Array<User_Login_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Login_Code_Order_By>>;
  where?: InputMaybe<User_Login_Code_Bool_Exp>;
};


export type Subscription_RootUser_Login_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Login_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Login_Code_Order_By>>;
  where?: InputMaybe<User_Login_Code_Bool_Exp>;
};


export type Subscription_RootUser_Login_Code_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Login_Code_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Login_Code_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Login_Code_Bool_Exp>;
};


export type Subscription_RootUser_Participant_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Participant_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Participant_Permissions_Order_By>>;
  where?: InputMaybe<User_Participant_Permissions_Bool_Exp>;
};


export type Subscription_RootUser_Participant_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Participant_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Participant_Permissions_Order_By>>;
  where?: InputMaybe<User_Participant_Permissions_Bool_Exp>;
};


export type Subscription_RootUser_Participant_Permissions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Participant_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Participant_Permissions_Bool_Exp>;
};


export type Subscription_RootUser_Register_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Register_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Register_Permissions_Order_By>>;
  where?: InputMaybe<User_Register_Permissions_Bool_Exp>;
};


export type Subscription_RootUser_Register_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Register_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Register_Permissions_Order_By>>;
  where?: InputMaybe<User_Register_Permissions_Bool_Exp>;
};


export type Subscription_RootUser_Register_Permissions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Register_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Register_Permissions_Bool_Exp>;
};


export type Subscription_RootUser_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_WarningArgs = {
  distinct_on?: InputMaybe<Array<User_Warning_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Warning_Order_By>>;
  where?: InputMaybe<User_Warning_Bool_Exp>;
};


export type Subscription_RootUser_Warning_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Warning_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Warning_Order_By>>;
  where?: InputMaybe<User_Warning_Bool_Exp>;
};


export type Subscription_RootUser_Warning_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
  warning_id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Warning_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Warning_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Warning_Bool_Exp>;
};


export type Subscription_RootWarningArgs = {
  distinct_on?: InputMaybe<Array<Warning_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Warning_Order_By>>;
  where?: InputMaybe<Warning_Bool_Exp>;
};


export type Subscription_RootWarning_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Warning_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Warning_Order_By>>;
  where?: InputMaybe<Warning_Bool_Exp>;
};


export type Subscription_RootWarning_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWarning_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Warning_Stream_Cursor_Input>>;
  where?: InputMaybe<Warning_Bool_Exp>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']['input']>;
  _gt?: InputMaybe<Scalars['time']['input']>;
  _gte?: InputMaybe<Scalars['time']['input']>;
  _in?: InputMaybe<Array<Scalars['time']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['time']['input']>;
  _lte?: InputMaybe<Scalars['time']['input']>;
  _neq?: InputMaybe<Scalars['time']['input']>;
  _nin?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "user" */
export type User = {
  __typename?: 'user';
  active: Scalars['Boolean']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  /** A computed field, executes function "user_full_name" */
  full_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  last_name: Scalars['String']['output'];
  /** An array relationship */
  organisation_managers: Array<Organisation_Manager>;
  /** An aggregate relationship */
  organisation_managers_aggregate: Organisation_Manager_Aggregate;
  /** An array relationship */
  organisation_siloed_users: Array<Organisation_Siloed_User>;
  /** An aggregate relationship */
  organisation_siloed_users_aggregate: Organisation_Siloed_User_Aggregate;
  /** An array relationship */
  organisation_users: Array<Organisation_User>;
  /** An aggregate relationship */
  organisation_users_aggregate: Organisation_User_Aggregate;
  password: Scalars['String']['output'];
  /** An array relationship */
  register_facilitators: Array<Register_Facilitator>;
  /** An aggregate relationship */
  register_facilitators_aggregate: Register_Facilitator_Aggregate;
  role: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  user_languages: Array<User_Language>;
  /** An aggregate relationship */
  user_languages_aggregate: User_Language_Aggregate;
  /** An array relationship */
  user_warnings: Array<User_Warning>;
  /** An aggregate relationship */
  user_warnings_aggregate: User_Warning_Aggregate;
};


/** columns and relationships of "user" */
export type UserOrganisation_ManagersArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Manager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Manager_Order_By>>;
  where?: InputMaybe<Organisation_Manager_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOrganisation_Managers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Manager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Manager_Order_By>>;
  where?: InputMaybe<Organisation_Manager_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOrganisation_Siloed_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Siloed_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Siloed_User_Order_By>>;
  where?: InputMaybe<Organisation_Siloed_User_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOrganisation_Siloed_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Siloed_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Siloed_User_Order_By>>;
  where?: InputMaybe<Organisation_Siloed_User_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOrganisation_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organisation_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_User_Order_By>>;
  where?: InputMaybe<Organisation_User_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOrganisation_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_User_Order_By>>;
  where?: InputMaybe<Organisation_User_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserRegister_FacilitatorsArgs = {
  distinct_on?: InputMaybe<Array<Register_Facilitator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Facilitator_Order_By>>;
  where?: InputMaybe<Register_Facilitator_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserRegister_Facilitators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Facilitator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Register_Facilitator_Order_By>>;
  where?: InputMaybe<Register_Facilitator_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_LanguagesArgs = {
  distinct_on?: InputMaybe<Array<User_Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Language_Order_By>>;
  where?: InputMaybe<User_Language_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Languages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Language_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Language_Order_By>>;
  where?: InputMaybe<User_Language_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_WarningsArgs = {
  distinct_on?: InputMaybe<Array<User_Warning_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Warning_Order_By>>;
  where?: InputMaybe<User_Warning_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Warnings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Warning_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Warning_Order_By>>;
  where?: InputMaybe<User_Warning_Bool_Exp>;
};

/** aggregated selection of "user" */
export type User_Aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

/** aggregate fields of "user" */
export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
};


/** aggregate fields of "user" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: InputMaybe<Array<User_Bool_Exp>>;
  _not?: InputMaybe<User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  organisation_managers?: InputMaybe<Organisation_Manager_Bool_Exp>;
  organisation_managers_aggregate?: InputMaybe<Organisation_Manager_Aggregate_Bool_Exp>;
  organisation_siloed_users?: InputMaybe<Organisation_Siloed_User_Bool_Exp>;
  organisation_siloed_users_aggregate?: InputMaybe<Organisation_Siloed_User_Aggregate_Bool_Exp>;
  organisation_users?: InputMaybe<Organisation_User_Bool_Exp>;
  organisation_users_aggregate?: InputMaybe<Organisation_User_Aggregate_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  register_facilitators?: InputMaybe<Register_Facilitator_Bool_Exp>;
  register_facilitators_aggregate?: InputMaybe<Register_Facilitator_Aggregate_Bool_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_languages?: InputMaybe<User_Language_Bool_Exp>;
  user_languages_aggregate?: InputMaybe<User_Language_Aggregate_Bool_Exp>;
  user_warnings?: InputMaybe<User_Warning_Bool_Exp>;
  user_warnings_aggregate?: InputMaybe<User_Warning_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "user" */
export enum User_Constraint {
  /** unique or primary key constraint on columns "email" */
  UserEmailKey = 'user_email_key',
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey'
}

/** input type for inserting data into table "user" */
export type User_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  organisation_managers?: InputMaybe<Organisation_Manager_Arr_Rel_Insert_Input>;
  organisation_siloed_users?: InputMaybe<Organisation_Siloed_User_Arr_Rel_Insert_Input>;
  organisation_users?: InputMaybe<Organisation_User_Arr_Rel_Insert_Input>;
  password?: InputMaybe<Scalars['String']['input']>;
  register_facilitators?: InputMaybe<Register_Facilitator_Arr_Rel_Insert_Input>;
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_languages?: InputMaybe<User_Language_Arr_Rel_Insert_Input>;
  user_warnings?: InputMaybe<User_Warning_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "user_language" */
export type User_Language = {
  __typename?: 'user_language';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  language: Language;
  language_code: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_language" */
export type User_Language_Aggregate = {
  __typename?: 'user_language_aggregate';
  aggregate?: Maybe<User_Language_Aggregate_Fields>;
  nodes: Array<User_Language>;
};

export type User_Language_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Language_Aggregate_Bool_Exp_Count>;
};

export type User_Language_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Language_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Language_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_language" */
export type User_Language_Aggregate_Fields = {
  __typename?: 'user_language_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Language_Max_Fields>;
  min?: Maybe<User_Language_Min_Fields>;
};


/** aggregate fields of "user_language" */
export type User_Language_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Language_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_language" */
export type User_Language_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Language_Max_Order_By>;
  min?: InputMaybe<User_Language_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_language" */
export type User_Language_Arr_Rel_Insert_Input = {
  data: Array<User_Language_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Language_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_language". All fields are combined with a logical 'AND'. */
export type User_Language_Bool_Exp = {
  _and?: InputMaybe<Array<User_Language_Bool_Exp>>;
  _not?: InputMaybe<User_Language_Bool_Exp>;
  _or?: InputMaybe<Array<User_Language_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  language?: InputMaybe<Language_Bool_Exp>;
  language_code?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_language" */
export enum User_Language_Constraint {
  /** unique or primary key constraint on columns "language_code", "user_id" */
  UserLanguagePkey = 'user_language_pkey'
}

/** input type for inserting data into table "user_language" */
export type User_Language_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  language?: InputMaybe<Language_Obj_Rel_Insert_Input>;
  language_code?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Language_Max_Fields = {
  __typename?: 'user_language_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  language_code?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_language" */
export type User_Language_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  language_code?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Language_Min_Fields = {
  __typename?: 'user_language_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  language_code?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_language" */
export type User_Language_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  language_code?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_language" */
export type User_Language_Mutation_Response = {
  __typename?: 'user_language_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Language>;
};

/** on_conflict condition type for table "user_language" */
export type User_Language_On_Conflict = {
  constraint: User_Language_Constraint;
  update_columns?: Array<User_Language_Update_Column>;
  where?: InputMaybe<User_Language_Bool_Exp>;
};

/** Ordering options when selecting data from "user_language". */
export type User_Language_Order_By = {
  created_at?: InputMaybe<Order_By>;
  language?: InputMaybe<Language_Order_By>;
  language_code?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_language */
export type User_Language_Pk_Columns_Input = {
  language_code: Scalars['String']['input'];
  user_id: Scalars['uuid']['input'];
};

/** select columns of table "user_language" */
export enum User_Language_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LanguageCode = 'language_code',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_language" */
export type User_Language_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  language_code?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_language" */
export type User_Language_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Language_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Language_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  language_code?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_language" */
export enum User_Language_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LanguageCode = 'language_code',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Language_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Language_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Language_Bool_Exp;
};

/** columns and relationships of "user_login_code" */
export type User_Login_Code = {
  __typename?: 'user_login_code';
  attempt_count: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  expires_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  login_code: Scalars['String']['output'];
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_login_code" */
export type User_Login_Code_Aggregate = {
  __typename?: 'user_login_code_aggregate';
  aggregate?: Maybe<User_Login_Code_Aggregate_Fields>;
  nodes: Array<User_Login_Code>;
};

/** aggregate fields of "user_login_code" */
export type User_Login_Code_Aggregate_Fields = {
  __typename?: 'user_login_code_aggregate_fields';
  avg?: Maybe<User_Login_Code_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Login_Code_Max_Fields>;
  min?: Maybe<User_Login_Code_Min_Fields>;
  stddev?: Maybe<User_Login_Code_Stddev_Fields>;
  stddev_pop?: Maybe<User_Login_Code_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Login_Code_Stddev_Samp_Fields>;
  sum?: Maybe<User_Login_Code_Sum_Fields>;
  var_pop?: Maybe<User_Login_Code_Var_Pop_Fields>;
  var_samp?: Maybe<User_Login_Code_Var_Samp_Fields>;
  variance?: Maybe<User_Login_Code_Variance_Fields>;
};


/** aggregate fields of "user_login_code" */
export type User_Login_Code_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Login_Code_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type User_Login_Code_Avg_Fields = {
  __typename?: 'user_login_code_avg_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_login_code". All fields are combined with a logical 'AND'. */
export type User_Login_Code_Bool_Exp = {
  _and?: InputMaybe<Array<User_Login_Code_Bool_Exp>>;
  _not?: InputMaybe<User_Login_Code_Bool_Exp>;
  _or?: InputMaybe<Array<User_Login_Code_Bool_Exp>>;
  attempt_count?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  login_code?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_login_code" */
export enum User_Login_Code_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserLoginCodePkey = 'user_login_code_pkey'
}

/** input type for incrementing numeric columns in table "user_login_code" */
export type User_Login_Code_Inc_Input = {
  attempt_count?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_login_code" */
export type User_Login_Code_Insert_Input = {
  attempt_count?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  login_code?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Login_Code_Max_Fields = {
  __typename?: 'user_login_code_max_fields';
  attempt_count?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  login_code?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type User_Login_Code_Min_Fields = {
  __typename?: 'user_login_code_min_fields';
  attempt_count?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  login_code?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "user_login_code" */
export type User_Login_Code_Mutation_Response = {
  __typename?: 'user_login_code_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Login_Code>;
};

/** on_conflict condition type for table "user_login_code" */
export type User_Login_Code_On_Conflict = {
  constraint: User_Login_Code_Constraint;
  update_columns?: Array<User_Login_Code_Update_Column>;
  where?: InputMaybe<User_Login_Code_Bool_Exp>;
};

/** Ordering options when selecting data from "user_login_code". */
export type User_Login_Code_Order_By = {
  attempt_count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  login_code?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_login_code */
export type User_Login_Code_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_login_code" */
export enum User_Login_Code_Select_Column {
  /** column name */
  AttemptCount = 'attempt_count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  LoginCode = 'login_code',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_login_code" */
export type User_Login_Code_Set_Input = {
  attempt_count?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  login_code?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type User_Login_Code_Stddev_Fields = {
  __typename?: 'user_login_code_stddev_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type User_Login_Code_Stddev_Pop_Fields = {
  __typename?: 'user_login_code_stddev_pop_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type User_Login_Code_Stddev_Samp_Fields = {
  __typename?: 'user_login_code_stddev_samp_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "user_login_code" */
export type User_Login_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Login_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Login_Code_Stream_Cursor_Value_Input = {
  attempt_count?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  login_code?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type User_Login_Code_Sum_Fields = {
  __typename?: 'user_login_code_sum_fields';
  attempt_count?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "user_login_code" */
export enum User_Login_Code_Update_Column {
  /** column name */
  AttemptCount = 'attempt_count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  LoginCode = 'login_code',
  /** column name */
  UserId = 'user_id'
}

export type User_Login_Code_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Login_Code_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Login_Code_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Login_Code_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Login_Code_Var_Pop_Fields = {
  __typename?: 'user_login_code_var_pop_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type User_Login_Code_Var_Samp_Fields = {
  __typename?: 'user_login_code_var_samp_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type User_Login_Code_Variance_Fields = {
  __typename?: 'user_login_code_variance_fields';
  attempt_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'user_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "user_full_name" */
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'user_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "user_full_name" */
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "user" */
export type User_Mutation_Response = {
  __typename?: 'user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** input type for inserting object relation for remote table "user" */
export type User_Obj_Rel_Insert_Input = {
  data: User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** on_conflict condition type for table "user" */
export type User_On_Conflict = {
  constraint: User_Constraint;
  update_columns?: Array<User_Update_Column>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** Ordering options when selecting data from "user". */
export type User_Order_By = {
  active?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  organisation_managers_aggregate?: InputMaybe<Organisation_Manager_Aggregate_Order_By>;
  organisation_siloed_users_aggregate?: InputMaybe<Organisation_Siloed_User_Aggregate_Order_By>;
  organisation_users_aggregate?: InputMaybe<Organisation_User_Aggregate_Order_By>;
  password?: InputMaybe<Order_By>;
  register_facilitators_aggregate?: InputMaybe<Register_Facilitator_Aggregate_Order_By>;
  role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_languages_aggregate?: InputMaybe<User_Language_Aggregate_Order_By>;
  user_warnings_aggregate?: InputMaybe<User_Warning_Aggregate_Order_By>;
};

/** columns and relationships of "user_participant_permissions" */
export type User_Participant_Permissions = {
  __typename?: 'user_participant_permissions';
  participant_id?: Maybe<Scalars['uuid']['output']>;
  participant_is_restricted?: Maybe<Scalars['Boolean']['output']>;
  relation_to_organisation?: Maybe<Scalars['String']['output']>;
  relation_to_participant?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "user_participant_permissions" */
export type User_Participant_Permissions_Aggregate = {
  __typename?: 'user_participant_permissions_aggregate';
  aggregate?: Maybe<User_Participant_Permissions_Aggregate_Fields>;
  nodes: Array<User_Participant_Permissions>;
};

export type User_Participant_Permissions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Participant_Permissions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Participant_Permissions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Participant_Permissions_Aggregate_Bool_Exp_Count>;
};

export type User_Participant_Permissions_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Participant_Permissions_Select_Column_User_Participant_Permissions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Participant_Permissions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Participant_Permissions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Participant_Permissions_Select_Column_User_Participant_Permissions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Participant_Permissions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Participant_Permissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Participant_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Participant_Permissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_participant_permissions" */
export type User_Participant_Permissions_Aggregate_Fields = {
  __typename?: 'user_participant_permissions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Participant_Permissions_Max_Fields>;
  min?: Maybe<User_Participant_Permissions_Min_Fields>;
};


/** aggregate fields of "user_participant_permissions" */
export type User_Participant_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Participant_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_participant_permissions" */
export type User_Participant_Permissions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Participant_Permissions_Max_Order_By>;
  min?: InputMaybe<User_Participant_Permissions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_participant_permissions" */
export type User_Participant_Permissions_Arr_Rel_Insert_Input = {
  data: Array<User_Participant_Permissions_Insert_Input>;
};

/** Boolean expression to filter rows from the table "user_participant_permissions". All fields are combined with a logical 'AND'. */
export type User_Participant_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<User_Participant_Permissions_Bool_Exp>>;
  _not?: InputMaybe<User_Participant_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<User_Participant_Permissions_Bool_Exp>>;
  participant_id?: InputMaybe<Uuid_Comparison_Exp>;
  participant_is_restricted?: InputMaybe<Boolean_Comparison_Exp>;
  relation_to_organisation?: InputMaybe<String_Comparison_Exp>;
  relation_to_participant?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "user_participant_permissions" */
export type User_Participant_Permissions_Insert_Input = {
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  participant_is_restricted?: InputMaybe<Scalars['Boolean']['input']>;
  relation_to_organisation?: InputMaybe<Scalars['String']['input']>;
  relation_to_participant?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Participant_Permissions_Max_Fields = {
  __typename?: 'user_participant_permissions_max_fields';
  participant_id?: Maybe<Scalars['uuid']['output']>;
  relation_to_organisation?: Maybe<Scalars['String']['output']>;
  relation_to_participant?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_participant_permissions" */
export type User_Participant_Permissions_Max_Order_By = {
  participant_id?: InputMaybe<Order_By>;
  relation_to_organisation?: InputMaybe<Order_By>;
  relation_to_participant?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Participant_Permissions_Min_Fields = {
  __typename?: 'user_participant_permissions_min_fields';
  participant_id?: Maybe<Scalars['uuid']['output']>;
  relation_to_organisation?: Maybe<Scalars['String']['output']>;
  relation_to_participant?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_participant_permissions" */
export type User_Participant_Permissions_Min_Order_By = {
  participant_id?: InputMaybe<Order_By>;
  relation_to_organisation?: InputMaybe<Order_By>;
  relation_to_participant?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "user_participant_permissions". */
export type User_Participant_Permissions_Order_By = {
  participant_id?: InputMaybe<Order_By>;
  participant_is_restricted?: InputMaybe<Order_By>;
  relation_to_organisation?: InputMaybe<Order_By>;
  relation_to_participant?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "user_participant_permissions" */
export enum User_Participant_Permissions_Select_Column {
  /** column name */
  ParticipantId = 'participant_id',
  /** column name */
  ParticipantIsRestricted = 'participant_is_restricted',
  /** column name */
  RelationToOrganisation = 'relation_to_organisation',
  /** column name */
  RelationToParticipant = 'relation_to_participant',
  /** column name */
  UserId = 'user_id'
}

/** select "user_participant_permissions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_participant_permissions" */
export enum User_Participant_Permissions_Select_Column_User_Participant_Permissions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ParticipantIsRestricted = 'participant_is_restricted'
}

/** select "user_participant_permissions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_participant_permissions" */
export enum User_Participant_Permissions_Select_Column_User_Participant_Permissions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ParticipantIsRestricted = 'participant_is_restricted'
}

/** Streaming cursor of the table "user_participant_permissions" */
export type User_Participant_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Participant_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Participant_Permissions_Stream_Cursor_Value_Input = {
  participant_id?: InputMaybe<Scalars['uuid']['input']>;
  participant_is_restricted?: InputMaybe<Scalars['Boolean']['input']>;
  relation_to_organisation?: InputMaybe<Scalars['String']['input']>;
  relation_to_participant?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** primary key columns input for table: user */
export type User_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "user_register_permissions" */
export type User_Register_Permissions = {
  __typename?: 'user_register_permissions';
  register_id?: Maybe<Scalars['uuid']['output']>;
  register_is_restricted?: Maybe<Scalars['Boolean']['output']>;
  relation_to_organisation?: Maybe<Scalars['String']['output']>;
  relation_to_register?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "user_register_permissions" */
export type User_Register_Permissions_Aggregate = {
  __typename?: 'user_register_permissions_aggregate';
  aggregate?: Maybe<User_Register_Permissions_Aggregate_Fields>;
  nodes: Array<User_Register_Permissions>;
};

export type User_Register_Permissions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Register_Permissions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Register_Permissions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Register_Permissions_Aggregate_Bool_Exp_Count>;
};

export type User_Register_Permissions_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Register_Permissions_Select_Column_User_Register_Permissions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Register_Permissions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Register_Permissions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Register_Permissions_Select_Column_User_Register_Permissions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Register_Permissions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Register_Permissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Register_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Register_Permissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_register_permissions" */
export type User_Register_Permissions_Aggregate_Fields = {
  __typename?: 'user_register_permissions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Register_Permissions_Max_Fields>;
  min?: Maybe<User_Register_Permissions_Min_Fields>;
};


/** aggregate fields of "user_register_permissions" */
export type User_Register_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Register_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_register_permissions" */
export type User_Register_Permissions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Register_Permissions_Max_Order_By>;
  min?: InputMaybe<User_Register_Permissions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_register_permissions" */
export type User_Register_Permissions_Arr_Rel_Insert_Input = {
  data: Array<User_Register_Permissions_Insert_Input>;
};

/** Boolean expression to filter rows from the table "user_register_permissions". All fields are combined with a logical 'AND'. */
export type User_Register_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<User_Register_Permissions_Bool_Exp>>;
  _not?: InputMaybe<User_Register_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<User_Register_Permissions_Bool_Exp>>;
  register_id?: InputMaybe<Uuid_Comparison_Exp>;
  register_is_restricted?: InputMaybe<Boolean_Comparison_Exp>;
  relation_to_organisation?: InputMaybe<String_Comparison_Exp>;
  relation_to_register?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "user_register_permissions" */
export type User_Register_Permissions_Insert_Input = {
  register_id?: InputMaybe<Scalars['uuid']['input']>;
  register_is_restricted?: InputMaybe<Scalars['Boolean']['input']>;
  relation_to_organisation?: InputMaybe<Scalars['String']['input']>;
  relation_to_register?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Register_Permissions_Max_Fields = {
  __typename?: 'user_register_permissions_max_fields';
  register_id?: Maybe<Scalars['uuid']['output']>;
  relation_to_organisation?: Maybe<Scalars['String']['output']>;
  relation_to_register?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_register_permissions" */
export type User_Register_Permissions_Max_Order_By = {
  register_id?: InputMaybe<Order_By>;
  relation_to_organisation?: InputMaybe<Order_By>;
  relation_to_register?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Register_Permissions_Min_Fields = {
  __typename?: 'user_register_permissions_min_fields';
  register_id?: Maybe<Scalars['uuid']['output']>;
  relation_to_organisation?: Maybe<Scalars['String']['output']>;
  relation_to_register?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_register_permissions" */
export type User_Register_Permissions_Min_Order_By = {
  register_id?: InputMaybe<Order_By>;
  relation_to_organisation?: InputMaybe<Order_By>;
  relation_to_register?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "user_register_permissions". */
export type User_Register_Permissions_Order_By = {
  register_id?: InputMaybe<Order_By>;
  register_is_restricted?: InputMaybe<Order_By>;
  relation_to_organisation?: InputMaybe<Order_By>;
  relation_to_register?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "user_register_permissions" */
export enum User_Register_Permissions_Select_Column {
  /** column name */
  RegisterId = 'register_id',
  /** column name */
  RegisterIsRestricted = 'register_is_restricted',
  /** column name */
  RelationToOrganisation = 'relation_to_organisation',
  /** column name */
  RelationToRegister = 'relation_to_register',
  /** column name */
  UserId = 'user_id'
}

/** select "user_register_permissions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_register_permissions" */
export enum User_Register_Permissions_Select_Column_User_Register_Permissions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  RegisterIsRestricted = 'register_is_restricted'
}

/** select "user_register_permissions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_register_permissions" */
export enum User_Register_Permissions_Select_Column_User_Register_Permissions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  RegisterIsRestricted = 'register_is_restricted'
}

/** Streaming cursor of the table "user_register_permissions" */
export type User_Register_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Register_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Register_Permissions_Stream_Cursor_Value_Input = {
  register_id?: InputMaybe<Scalars['uuid']['input']>;
  register_is_restricted?: InputMaybe<Scalars['Boolean']['input']>;
  relation_to_organisation?: InputMaybe<Scalars['String']['input']>;
  relation_to_register?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** select columns of table "user" */
export enum User_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Password = 'password',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "user" */
export type User_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "user" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "user" */
export enum User_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Password = 'password',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Bool_Exp;
};

/** columns and relationships of "user_warning" */
export type User_Warning = {
  __typename?: 'user_warning';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id: Scalars['uuid']['output'];
  /** An object relationship */
  warning: Warning;
  warning_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_warning" */
export type User_Warning_Aggregate = {
  __typename?: 'user_warning_aggregate';
  aggregate?: Maybe<User_Warning_Aggregate_Fields>;
  nodes: Array<User_Warning>;
};

export type User_Warning_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Warning_Aggregate_Bool_Exp_Count>;
};

export type User_Warning_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Warning_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Warning_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_warning" */
export type User_Warning_Aggregate_Fields = {
  __typename?: 'user_warning_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Warning_Max_Fields>;
  min?: Maybe<User_Warning_Min_Fields>;
};


/** aggregate fields of "user_warning" */
export type User_Warning_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Warning_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_warning" */
export type User_Warning_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Warning_Max_Order_By>;
  min?: InputMaybe<User_Warning_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_warning" */
export type User_Warning_Arr_Rel_Insert_Input = {
  data: Array<User_Warning_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Warning_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_warning". All fields are combined with a logical 'AND'. */
export type User_Warning_Bool_Exp = {
  _and?: InputMaybe<Array<User_Warning_Bool_Exp>>;
  _not?: InputMaybe<User_Warning_Bool_Exp>;
  _or?: InputMaybe<Array<User_Warning_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  warning?: InputMaybe<Warning_Bool_Exp>;
  warning_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_warning" */
export enum User_Warning_Constraint {
  /** unique or primary key constraint on columns "user_id", "warning_id" */
  UserWarningPkey = 'user_warning_pkey'
}

/** input type for inserting data into table "user_warning" */
export type User_Warning_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  warning?: InputMaybe<Warning_Obj_Rel_Insert_Input>;
  warning_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Warning_Max_Fields = {
  __typename?: 'user_warning_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  warning_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_warning" */
export type User_Warning_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  warning_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Warning_Min_Fields = {
  __typename?: 'user_warning_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  warning_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_warning" */
export type User_Warning_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  warning_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_warning" */
export type User_Warning_Mutation_Response = {
  __typename?: 'user_warning_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Warning>;
};

/** on_conflict condition type for table "user_warning" */
export type User_Warning_On_Conflict = {
  constraint: User_Warning_Constraint;
  update_columns?: Array<User_Warning_Update_Column>;
  where?: InputMaybe<User_Warning_Bool_Exp>;
};

/** Ordering options when selecting data from "user_warning". */
export type User_Warning_Order_By = {
  created_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  warning?: InputMaybe<Warning_Order_By>;
  warning_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_warning */
export type User_Warning_Pk_Columns_Input = {
  user_id: Scalars['uuid']['input'];
  warning_id: Scalars['uuid']['input'];
};

/** select columns of table "user_warning" */
export enum User_Warning_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WarningId = 'warning_id'
}

/** input type for updating data in table "user_warning" */
export type User_Warning_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  warning_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_warning" */
export type User_Warning_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Warning_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Warning_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  warning_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_warning" */
export enum User_Warning_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WarningId = 'warning_id'
}

export type User_Warning_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Warning_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Warning_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "warning" */
export type Warning = {
  __typename?: 'warning';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  message: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "warning" */
export type Warning_Aggregate = {
  __typename?: 'warning_aggregate';
  aggregate?: Maybe<Warning_Aggregate_Fields>;
  nodes: Array<Warning>;
};

/** aggregate fields of "warning" */
export type Warning_Aggregate_Fields = {
  __typename?: 'warning_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Warning_Max_Fields>;
  min?: Maybe<Warning_Min_Fields>;
};


/** aggregate fields of "warning" */
export type Warning_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Warning_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "warning". All fields are combined with a logical 'AND'. */
export type Warning_Bool_Exp = {
  _and?: InputMaybe<Array<Warning_Bool_Exp>>;
  _not?: InputMaybe<Warning_Bool_Exp>;
  _or?: InputMaybe<Array<Warning_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "warning" */
export enum Warning_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarningPkey = 'warning_pkey',
  /** unique or primary key constraint on columns "slug" */
  WarningSlugKey = 'warning_slug_key'
}

/** input type for inserting data into table "warning" */
export type Warning_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Warning_Max_Fields = {
  __typename?: 'warning_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Warning_Min_Fields = {
  __typename?: 'warning_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "warning" */
export type Warning_Mutation_Response = {
  __typename?: 'warning_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Warning>;
};

/** input type for inserting object relation for remote table "warning" */
export type Warning_Obj_Rel_Insert_Input = {
  data: Warning_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Warning_On_Conflict>;
};

/** on_conflict condition type for table "warning" */
export type Warning_On_Conflict = {
  constraint: Warning_Constraint;
  update_columns?: Array<Warning_Update_Column>;
  where?: InputMaybe<Warning_Bool_Exp>;
};

/** Ordering options when selecting data from "warning". */
export type Warning_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: warning */
export type Warning_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "warning" */
export enum Warning_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "warning" */
export type Warning_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "warning" */
export type Warning_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Warning_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Warning_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "warning" */
export enum Warning_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Warning_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Warning_Set_Input>;
  /** filter the rows which have to be updated */
  where: Warning_Bool_Exp;
};

export type CreateLocationMutationVariables = Exact<{
  location: Location_Insert_Input;
}>;


export type CreateLocationMutation = { __typename?: 'mutation_root', insert_location?: { __typename?: 'location_mutation_response', returning: Array<{ __typename?: 'location', id: any }> } | null };

export type CreateOrganisationManagerMutationVariables = Exact<{
  organisation_manager: Organisation_Manager_Insert_Input;
}>;


export type CreateOrganisationManagerMutation = { __typename?: 'mutation_root', insert_organisation_manager?: { __typename?: 'organisation_manager_mutation_response', returning: Array<{ __typename?: 'organisation_manager', user_id: any, organisation_id: any }> } | null };

export type CreateOrganisationProgrammeMutationVariables = Exact<{
  organisation_programme: Organisation_Programme_Insert_Input;
}>;


export type CreateOrganisationProgrammeMutation = { __typename?: 'mutation_root', insert_organisation_programme?: { __typename?: 'organisation_programme_mutation_response', returning: Array<{ __typename?: 'organisation_programme', organisation_id: any, programme_id: any }> } | null };

export type CreateOrganisationSiloedUserMutationVariables = Exact<{
  organisation_siloed_user: Organisation_Siloed_User_Insert_Input;
}>;


export type CreateOrganisationSiloedUserMutation = { __typename?: 'mutation_root', insert_organisation_siloed_user?: { __typename?: 'organisation_siloed_user_mutation_response', returning: Array<{ __typename?: 'organisation_siloed_user', user_id: any, organisation_id: any }> } | null };

export type CreateOrganisationUserMutationVariables = Exact<{
  organisation_user: Organisation_User_Insert_Input;
}>;


export type CreateOrganisationUserMutation = { __typename?: 'mutation_root', insert_organisation_user?: { __typename?: 'organisation_user_mutation_response', returning: Array<{ __typename?: 'organisation_user', user_id: any, organisation_id: any }> } | null };

export type CreateOrganisationMutationVariables = Exact<{
  organisation: Organisation_Insert_Input;
}>;


export type CreateOrganisationMutation = { __typename?: 'mutation_root', insert_organisation?: { __typename?: 'organisation_mutation_response', returning: Array<{ __typename?: 'organisation', id: any }> } | null };

export type CreateParentChildMutationVariables = Exact<{
  parent_child: Parent_Child_Insert_Input;
}>;


export type CreateParentChildMutation = { __typename?: 'mutation_root', insert_parent_child?: { __typename?: 'parent_child_mutation_response', returning: Array<{ __typename?: 'parent_child', parent_id: any, child_id: any }> } | null };

export type CreateParticipantFileMutationVariables = Exact<{
  participant_file: Participant_Files_Insert_Input;
}>;


export type CreateParticipantFileMutation = { __typename?: 'mutation_root', insert_participant_files?: { __typename?: 'participant_files_mutation_response', returning: Array<{ __typename?: 'participant_files', participant_id: any, file_size: number, file_name: string, id: any }> } | null };

export type CreateParticipantSiblingMutationVariables = Exact<{
  participant_sibling: Participant_Sibling_Insert_Input;
}>;


export type CreateParticipantSiblingMutation = { __typename?: 'mutation_root', insert_participant_sibling?: { __typename?: 'participant_sibling_mutation_response', returning: Array<{ __typename?: 'participant_sibling', participant_id: any, sibling_id: any }> } | null };

export type CreateParticipantMutationVariables = Exact<{
  participant: Participant_Insert_Input;
}>;


export type CreateParticipantMutation = { __typename?: 'mutation_root', insert_participant?: { __typename?: 'participant_mutation_response', returning: Array<{ __typename?: 'participant', id: any }> } | null };

export type CreateProgrammeMutationVariables = Exact<{
  programme: Programme_Insert_Input;
}>;


export type CreateProgrammeMutation = { __typename?: 'mutation_root', insert_programme?: { __typename?: 'programme_mutation_response', returning: Array<{ __typename?: 'programme', id: any }> } | null };

export type CreateProjectCategoryMutationVariables = Exact<{
  project_category: Project_Category_Insert_Input;
}>;


export type CreateProjectCategoryMutation = { __typename?: 'mutation_root', insert_project_category?: { __typename?: 'project_category_mutation_response', returning: Array<{ __typename?: 'project_category', id: any, project_id: any, name: string }> } | null };

export type CreateProjectMutationVariables = Exact<{
  project: Project_Insert_Input;
}>;


export type CreateProjectMutation = { __typename?: 'mutation_root', insert_project?: { __typename?: 'project_mutation_response', returning: Array<{ __typename?: 'project', id: any }> } | null };

export type CreateRegisterParticipantMutationVariables = Exact<{
  register_participant: Register_Participant_Insert_Input;
}>;


export type CreateRegisterParticipantMutation = { __typename?: 'mutation_root', insert_register_participant?: { __typename?: 'register_participant_mutation_response', returning: Array<{ __typename?: 'register_participant', register_id: any, participant_id: any, sensitive_fields?: { __typename?: 'register_participant_sensitive_fields', notes?: string | null } | null }> } | null };

export type CreateRegisterMutationVariables = Exact<{
  register: Register_Insert_Input;
}>;


export type CreateRegisterMutation = { __typename?: 'mutation_root', insert_register?: { __typename?: 'register_mutation_response', returning: Array<{ __typename?: 'register', id: any }> } | null };

export type DangerousMergeParticipantsMutationVariables = Exact<{
  participant_id_to_delete: Scalars['uuid']['input'];
  participant_sibling_objects: Array<Participant_Sibling_Insert_Input> | Participant_Sibling_Insert_Input;
  participant_language_objects: Array<Participant_Language_Insert_Input> | Participant_Language_Insert_Input;
  parent_child_objects: Array<Parent_Child_Insert_Input> | Parent_Child_Insert_Input;
  organisation_participants_objects: Array<Organisation_Participant_Insert_Input> | Organisation_Participant_Insert_Input;
  programme_participants_objects: Array<Programme_Participant_Insert_Input> | Programme_Participant_Insert_Input;
  register_participant_objects: Array<Register_Participant_Insert_Input> | Register_Participant_Insert_Input;
}>;


export type DangerousMergeParticipantsMutation = { __typename?: 'mutation_root', insert_participant_sibling?: { __typename?: 'participant_sibling_mutation_response', returning: Array<{ __typename?: 'participant_sibling', participant_id: any, sibling_id: any }> } | null, insert_participant_language?: { __typename?: 'participant_language_mutation_response', returning: Array<{ __typename?: 'participant_language', language_code: string, participant_id: any }> } | null, insert_parent_child?: { __typename?: 'parent_child_mutation_response', returning: Array<{ __typename?: 'parent_child', child_id: any, parent_id: any }> } | null, insert_organisation_participant?: { __typename?: 'organisation_participant_mutation_response', returning: Array<{ __typename?: 'organisation_participant', organisation_id: any, participant_id: any }> } | null, insert_programme_participant?: { __typename?: 'programme_participant_mutation_response', returning: Array<{ __typename?: 'programme_participant', participant_id: any, programme_id: any }> } | null, insert_register_participant?: { __typename?: 'register_participant_mutation_response', returning: Array<{ __typename?: 'register_participant', _temp_is_child?: boolean | null, _temp_is_parent?: boolean | null, participant_id: any, register_id: any, sensitive_fields?: { __typename?: 'register_participant_sensitive_fields', notes?: string | null } | null }> } | null, delete_sibling_a?: { __typename?: 'participant_sibling_mutation_response', returning: Array<{ __typename?: 'participant_sibling', participant_id: any, sibling_id: any }> } | null, delete_sibling_b?: { __typename?: 'participant_sibling_mutation_response', returning: Array<{ __typename?: 'participant_sibling', participant_id: any, sibling_id: any }> } | null, delete_parent?: { __typename?: 'parent_child_mutation_response', returning: Array<{ __typename?: 'parent_child', child_id: any, parent_id: any }> } | null, delete_child?: { __typename?: 'parent_child_mutation_response', returning: Array<{ __typename?: 'parent_child', child_id: any, parent_id: any }> } | null, delete_participant_language?: { __typename?: 'participant_language_mutation_response', returning: Array<{ __typename?: 'participant_language', language_code: string }> } | null, delete_organisation_participant?: { __typename?: 'organisation_participant_mutation_response', returning: Array<{ __typename?: 'organisation_participant', organisation_id: any }> } | null, delete_programme_participant?: { __typename?: 'programme_participant_mutation_response', returning: Array<{ __typename?: 'programme_participant', programme_id: any }> } | null, delete_register_participant?: { __typename?: 'register_participant_mutation_response', returning: Array<{ __typename?: 'register_participant', register_id: any }> } | null, delete_participant?: { __typename?: 'participant_mutation_response', returning: Array<{ __typename?: 'participant', id: any }> } | null };

export type DeactivateUserMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeactivateUserMutation = { __typename?: 'mutation_root', update_user?: { __typename?: 'user_mutation_response', returning: Array<{ __typename?: 'user', id: any }> } | null };

export type DeleteOrganisationManagerMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  organisation_id: Scalars['uuid']['input'];
}>;


export type DeleteOrganisationManagerMutation = { __typename?: 'mutation_root', delete_organisation_manager?: { __typename?: 'organisation_manager_mutation_response', returning: Array<{ __typename?: 'organisation_manager', organisation_id: any, user_id: any }> } | null };

export type DeleteOrganisationSiloedUserMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  organisation_id: Scalars['uuid']['input'];
}>;


export type DeleteOrganisationSiloedUserMutation = { __typename?: 'mutation_root', delete_organisation_siloed_user?: { __typename?: 'organisation_siloed_user_mutation_response', returning: Array<{ __typename?: 'organisation_siloed_user', organisation_id: any, user_id: any }> } | null };

export type DeleteOrganisationUserMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  organisation_id: Scalars['uuid']['input'];
}>;


export type DeleteOrganisationUserMutation = { __typename?: 'mutation_root', delete_organisation_user?: { __typename?: 'organisation_user_mutation_response', returning: Array<{ __typename?: 'organisation_user', organisation_id: any, user_id: any }> } | null };

export type DeleteOrganisationProgrammeMutationVariables = Exact<{
  organisation_id: Scalars['uuid']['input'];
  programme_id: Scalars['uuid']['input'];
}>;


export type DeleteOrganisationProgrammeMutation = { __typename?: 'mutation_root', delete_organisation_programme?: { __typename?: 'organisation_programme_mutation_response', returning: Array<{ __typename?: 'organisation_programme', programme_id: any, organisation_id: any }> } | null };

export type DeleteParentChildMutationVariables = Exact<{
  parent_id: Scalars['uuid']['input'];
  child_id: Scalars['uuid']['input'];
}>;


export type DeleteParentChildMutation = { __typename?: 'mutation_root', delete_parent_child?: { __typename?: 'parent_child_mutation_response', returning: Array<{ __typename?: 'parent_child', child_id: any, parent_id: any }> } | null };

export type DeleteParticipantFileByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteParticipantFileByIdMutation = { __typename?: 'mutation_root', delete_participant_files_by_pk?: { __typename?: 'participant_files', id: any } | null };

export type DeleteParticipantSiblingMutationVariables = Exact<{
  participant_id: Scalars['uuid']['input'];
  sibling_id: Scalars['uuid']['input'];
}>;


export type DeleteParticipantSiblingMutation = { __typename?: 'mutation_root', delete_participant_sibling?: { __typename?: 'participant_sibling_mutation_response', returning: Array<{ __typename?: 'participant_sibling', sibling_id: any, participant_id: any }> } | null };

export type DeleteProjectCategoryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteProjectCategoryMutation = { __typename?: 'mutation_root', delete_project_category_by_pk?: { __typename?: 'project_category', id: any, project_id: any, name: string } | null };

export type DeleteRegisterParticipantMutationVariables = Exact<{
  register_id: Scalars['uuid']['input'];
  participant_id: Scalars['uuid']['input'];
}>;


export type DeleteRegisterParticipantMutation = { __typename?: 'mutation_root', delete_register_participant?: { __typename?: 'register_participant_mutation_response', returning: Array<{ __typename?: 'register_participant', participant_id: any, register_id: any }> } | null };

export type DeleteRegisterMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteRegisterMutation = { __typename?: 'mutation_root', update_register?: { __typename?: 'register_mutation_response', returning: Array<{ __typename?: 'register', id: any }> } | null };

export type FetchLocationQueryVariables = Exact<{
  locationSlug: Scalars['String']['input'];
}>;


export type FetchLocationQuery = { __typename?: 'query_root', location: Array<{ __typename?: 'location', id: any, name: string, slug: string, organisation_id: any, programme_locations: Array<{ __typename?: 'programme_location', programme: { __typename?: 'programme', id: any, name: string, slug: string } }> }> };

export type FetchLocationsQueryVariables = Exact<{
  dynamicWhere?: InputMaybe<Location_Bool_Exp>;
  dynamicOrderBy?: InputMaybe<Array<Location_Order_By> | Location_Order_By>;
}>;


export type FetchLocationsQuery = { __typename?: 'query_root', location: Array<{ __typename?: 'location', id: any, name: string, slug: string, organisation_id: any, programme_locations: Array<{ __typename?: 'programme_location', programme: { __typename?: 'programme', id: any, name: string, slug: string } }>, organisation: { __typename?: 'organisation', id: any, name: string, slug: string } }> };

export type FetchOrganisationQueryVariables = Exact<{
  organisationSlug: Scalars['String']['input'];
}>;


export type FetchOrganisationQuery = { __typename?: 'query_root', organisation: Array<{ __typename?: 'organisation', id: any, name: string, slug: string, locations: Array<{ __typename?: 'location', id: any, name: string, slug: string }>, projects: Array<{ __typename?: 'project', id: any, name: string, slug: string }>, organisation_users: Array<{ __typename?: 'organisation_user', user: { __typename?: 'user', id: any, first_name: string, last_name: string } }>, organisation_managers: Array<{ __typename?: 'organisation_manager', user_id: any }>, organisation_programmes: Array<{ __typename?: 'organisation_programme', programme: { __typename?: 'programme', id: any, name: string, slug: string } }> }> };

export type FetchOrganisationsQueryVariables = Exact<{
  dynamicWhere?: InputMaybe<Organisation_Bool_Exp>;
}>;


export type FetchOrganisationsQuery = { __typename?: 'query_root', organisation: Array<{ __typename?: 'organisation', id: any, name: string, slug: string, organisation_managers: Array<{ __typename?: 'organisation_manager', user_id: any }>, organisation_programmes: Array<{ __typename?: 'organisation_programme', programme: { __typename?: 'programme', id: any, name: string, slug: string } }> }> };

export type FetchParticipantByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type FetchParticipantByIdQuery = { __typename?: 'query_root', participant_by_pk?: { __typename?: 'participant', id: any, country_code?: string | null, created_at: any, date_of_birth?: any | null, date_of_birth_accuracy?: string | null, date_of_first_attendance?: any | null, preferred_contact_method?: string | null, sex?: string | null, updated_at: any, is_refugee?: boolean | null, is_caregiver?: boolean | null, has_disability?: boolean | null, data_protection_signed: boolean, _temp_parent_names?: string | null, _temp_child_names?: string | null, referral_organisation?: string | null, sensitive_fields?: { __typename?: 'participant_sensitive_fields', email?: string | null, first_name: string, last_name: string, notes?: string | null, phone?: string | null, emergency_contact_name?: string | null, emergency_contact_detail?: string | null } | null, children: Array<{ __typename?: 'parent_child', child: { __typename?: 'participant', id: any, sensitive_fields?: { __typename?: 'participant_sensitive_fields', first_name: string, last_name: string } | null } }>, parents: Array<{ __typename?: 'parent_child', parent: { __typename?: 'participant', id: any, sensitive_fields?: { __typename?: 'participant_sensitive_fields', first_name: string, last_name: string } | null, children: Array<{ __typename?: 'parent_child', child: { __typename?: 'participant', id: any, sensitive_fields?: { __typename?: 'participant_sensitive_fields', first_name: string, last_name: string } | null } }> } }>, siblings: Array<{ __typename?: 'participant_sibling', sibling: { __typename?: 'participant', id: any, sensitive_fields?: { __typename?: 'participant_sensitive_fields', first_name: string, last_name: string } | null } }>, participant_languages: Array<{ __typename?: 'participant_language', language: { __typename?: 'language', code: string, name: string } }>, register_participants: Array<{ __typename?: 'register_participant', _temp_is_child?: boolean | null, _temp_is_parent?: boolean | null, sensitive_fields?: { __typename?: 'register_participant_sensitive_fields', notes?: string | null } | null, register: { __typename?: 'register', id: any, time: any, date: any, project: { __typename?: 'project', name: string, slug: string, id: any } } }>, organisation_participants: Array<{ __typename?: 'organisation_participant', organisation_id: any, participant_id: any }>, programme_participants: Array<{ __typename?: 'programme_participant', programme_id: any, participant_id: any }>, participant_files: Array<{ __typename?: 'participant_files', id: any, file_name: string, file_size: number, purpose: string }> } | null };

export type FetchParticipantFileByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type FetchParticipantFileByIdQuery = { __typename?: 'query_root', participant_files_by_pk?: { __typename?: 'participant_files', id: any, file_name: string, file_size: number, file_base64: string } | null };

export type FetchParticipantLatestQueryVariables = Exact<{
  dynamicWhere?: InputMaybe<Register_Participant_Latest_Bool_Exp>;
}>;


export type FetchParticipantLatestQuery = { __typename?: 'query_root', register_participant_latest: Array<{ __typename?: 'register_participant_latest', participant?: { __typename?: 'participant', date_of_birth?: any | null, date_of_birth_accuracy?: string | null, id: any, country_code?: string | null, sensitive_fields?: { __typename?: 'participant_sensitive_fields', last_name: string, first_name: string } | null } | null }> };

export type FetchParticipantsByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
  excludeId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type FetchParticipantsByEmailQuery = { __typename?: 'query_root', participant: Array<{ __typename?: 'participant', id: any, sensitive_fields?: { __typename?: 'participant_sensitive_fields', first_name: string, last_name: string } | null }> };

export type FetchParticipantsByPhoneQueryVariables = Exact<{
  phone: Scalars['String']['input'];
  excludeId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type FetchParticipantsByPhoneQuery = { __typename?: 'query_root', participant: Array<{ __typename?: 'participant', id: any, sensitive_fields?: { __typename?: 'participant_sensitive_fields', first_name: string, last_name: string } | null }> };

export type FetchProgrammeGroupsQueryVariables = Exact<{
  dynamicWhere?: InputMaybe<Programme_Group_Bool_Exp>;
}>;


export type FetchProgrammeGroupsQuery = { __typename?: 'query_root', programme_group: Array<{ __typename?: 'programme_group', id: any, name: string, slug: string, programmes: Array<{ __typename?: 'programme', id: any, name: string, slug: string }> }> };

export type FetchProgrammeQueryVariables = Exact<{
  programmeSlug: Scalars['String']['input'];
}>;


export type FetchProgrammeQuery = { __typename?: 'query_root', programme: Array<{ __typename?: 'programme', id: any, name: string, slug: string, type: string, status: string, start_date?: any | null, end_date?: any | null, organisation_programmes: Array<{ __typename?: 'organisation_programme', organisation: { __typename?: 'organisation', id: any, name: string, slug: string } }>, projects: Array<{ __typename?: 'project', id: any, name: string, slug: string }>, programme_group?: { __typename?: 'programme_group', id: any, name: string, slug: string } | null }> };

export type FetchProgrammesQueryVariables = Exact<{
  dynamicWhere?: InputMaybe<Programme_Bool_Exp>;
}>;


export type FetchProgrammesQuery = { __typename?: 'query_root', programme: Array<{ __typename?: 'programme', id: any, name: string, slug: string, type: string, start_date?: any | null, end_date?: any | null, status: string, programme_locations: Array<{ __typename?: 'programme_location', location: { __typename?: 'location', id: any, name: string, slug: string } }>, programme_group?: { __typename?: 'programme_group', id: any, name: string, slug: string } | null }> };

export type FetchProjectQueryVariables = Exact<{
  projectSlug: Scalars['String']['input'];
}>;


export type FetchProjectQuery = { __typename?: 'query_root', project: Array<{ __typename?: 'project', id: any, name: string, slug: string, programme_id: any, organisation_id: any, programme: { __typename?: 'programme', id: any, name: string, slug: string }, categories: Array<{ __typename?: 'project_category', id: any, name: string }> }> };

export type FetchProjectsQueryVariables = Exact<{
  dynamicWhere?: InputMaybe<Project_Bool_Exp>;
  dynamicOrderBy?: InputMaybe<Array<Project_Order_By> | Project_Order_By>;
}>;


export type FetchProjectsQuery = { __typename?: 'query_root', project: Array<{ __typename?: 'project', id: any, name: string, slug: string, programme_id: any, organisation_id: any, categories: Array<{ __typename?: 'project_category', id: any, name: string }>, programme: { __typename?: 'programme', id: any, name: string, slug: string }, organisation: { __typename?: 'organisation', id: any, name: string, slug: string } }> };

export type FetchRegisterAttendeesQueryVariables = Exact<{
  registerIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type FetchRegisterAttendeesQuery = { __typename?: 'query_root', register_participant: Array<{ __typename?: 'register_participant', register_id: any, participant: { __typename?: 'participant', id: any, _temp_id?: string | null, sensitive_fields?: { __typename?: 'participant_sensitive_fields', first_name: string, last_name: string } | null } }> };

export type FetchRegisterParticipantNotesQueryVariables = Exact<{
  participantId: Scalars['uuid']['input'];
}>;


export type FetchRegisterParticipantNotesQuery = { __typename?: 'query_root', register_participant_sensitive_fields: Array<{ __typename?: 'register_participant_sensitive_fields', notes?: string | null, register: { __typename?: 'register', id: any, date: any, time: any, project: { __typename?: 'project', id: any, name: string, programme: { __typename?: 'programme', id: any, slug: string } }, location: { __typename?: 'location', id: any, name: string }, register_facilitators: Array<{ __typename?: 'register_facilitator', user: { __typename?: 'user', first_name: string, last_name: string, id: any } }> } }> };

export type FetchRegisterQueryVariables = Exact<{
  registerId: Scalars['uuid']['input'];
}>;


export type FetchRegisterQuery = { __typename?: 'query_root', register_by_pk?: { __typename?: 'register', id: any, date: any, time: any, deleted_at?: any | null, override_total_participants?: number | null, number_of_orgs_in_attendance?: number | null, created_by_user_id: any, project: { __typename?: 'project', id: any, name: string, slug: string, programme: { __typename?: 'programme', id: any, slug: string } }, location: { __typename?: 'location', id: any, name: string, slug: string }, sensitive_fields?: { __typename?: 'register_sensitive_fields', notes?: string | null } | null, register_participants: Array<{ __typename?: 'register_participant', _temp_is_child?: boolean | null, _temp_is_parent?: boolean | null, sensitive_fields?: { __typename?: 'register_participant_sensitive_fields', notes?: string | null } | null, participant: { __typename?: 'participant', id: any, date_of_birth?: any | null, sensitive_fields?: { __typename?: 'participant_sensitive_fields', first_name: string, last_name: string } | null, parents: Array<{ __typename?: 'parent_child', parent: { __typename?: 'participant', id: any, sensitive_fields?: { __typename?: 'participant_sensitive_fields', first_name: string, last_name: string } | null } }>, children: Array<{ __typename?: 'parent_child', child: { __typename?: 'participant', id: any, sensitive_fields?: { __typename?: 'participant_sensitive_fields', first_name: string, last_name: string } | null } }> } }>, register_facilitators: Array<{ __typename?: 'register_facilitator', user: { __typename?: 'user', first_name: string, last_name: string, id: any } }>, register_project_categories: Array<{ __typename?: 'register_project_category', project_category: { __typename?: 'project_category', id: any, name: string } }> } | null };

export type FetchRegistersQueryVariables = Exact<{
  dynamicWhere?: InputMaybe<Register_Bool_Exp>;
  dynamicOrderBy?: InputMaybe<Array<Register_Order_By> | Register_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchRegistersQuery = { __typename?: 'query_root', register: Array<{ __typename?: 'register', date: any, id: any, time: any, override_total_participants?: number | null, number_of_orgs_in_attendance?: number | null, organisation: { __typename?: 'organisation', name: string }, location: { __typename?: 'location', id: any, name: string, slug: string }, sensitive_fields?: { __typename?: 'register_sensitive_fields', notes?: string | null } | null, project: { __typename?: 'project', id: any, name: string, slug: string, programme: { __typename?: 'programme', name: string } }, register_project_categories: Array<{ __typename?: 'register_project_category', project_category: { __typename?: 'project_category', id: any, name: string } }>, register_facilitators: Array<{ __typename?: 'register_facilitator', user: { __typename?: 'user', first_name: string, last_name: string, id: any } }>, register_participants_aggregate: { __typename?: 'register_participant_aggregate', aggregate?: { __typename?: 'register_participant_aggregate_fields', count: number } | null } }>, register_aggregate: { __typename?: 'register_aggregate', aggregate?: { __typename?: 'register_aggregate_fields', count: number } | null } };

export type FetchUserWarningsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type FetchUserWarningsQuery = { __typename?: 'query_root', user_warning: Array<{ __typename?: 'user_warning', warning: { __typename?: 'warning', created_at?: any | null, id: any, message: string, slug: string, updated_at?: any | null } }> };

export type FetchUsersQueryVariables = Exact<{
  dynamicWhere?: InputMaybe<User_Bool_Exp>;
  dynamicOrderBy?: InputMaybe<Array<User_Order_By> | User_Order_By>;
}>;


export type FetchUsersQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: any, email: string, first_name: string, last_name: string, role: string, organisation_users: Array<{ __typename?: 'organisation_user', organisation: { __typename?: 'organisation', id: any, slug: string, name: string } }> }> };

export type RegisterAggregateQueryVariables = Exact<{
  dynamicWhere?: InputMaybe<Register_Bool_Exp>;
  distinctOn?: InputMaybe<Array<Register_Select_Column> | Register_Select_Column>;
}>;


export type RegisterAggregateQuery = { __typename?: 'query_root', register_aggregate: { __typename?: 'register_aggregate', aggregate?: { __typename?: 'register_aggregate_fields', count: number } | null } };

export type RegisterParticipantAggregateQueryVariables = Exact<{
  dynamicWhere?: InputMaybe<Register_Participant_Bool_Exp>;
  distinctOn?: InputMaybe<Array<Register_Participant_Select_Column> | Register_Participant_Select_Column>;
}>;


export type RegisterParticipantAggregateQuery = { __typename?: 'query_root', register_participant_aggregate: { __typename?: 'register_participant_aggregate', aggregate?: { __typename?: 'register_participant_aggregate_fields', count: number } | null }, register_participant: Array<{ __typename?: 'register_participant', register: { __typename?: 'register', date: any, override_total_participants?: number | null, organisation: { __typename?: 'organisation', id: any, name: string }, location: { __typename?: 'location', id: any, name: string }, project: { __typename?: 'project', id: any, name: string } }, participant: { __typename?: 'participant', id: any, date_of_birth?: any | null, country_code?: string | null, sex?: string | null, sensitive_fields?: { __typename?: 'participant_sensitive_fields', first_name: string, last_name: string } | null } }> };

export type RestoreRegisterMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RestoreRegisterMutation = { __typename?: 'mutation_root', update_register?: { __typename?: 'register_mutation_response', returning: Array<{ __typename?: 'register', id: any }> } | null };

export type SearchParticipantsByNameQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  excludeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  dynamicFilters?: InputMaybe<Array<Participant_Sensitive_Fields_Bool_Exp> | Participant_Sensitive_Fields_Bool_Exp>;
  dynamicOrderBy?: InputMaybe<Array<Participant_Sensitive_Fields_Order_By> | Participant_Sensitive_Fields_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchParticipantsByNameQuery = { __typename?: 'query_root', participant_search_by_name: Array<{ __typename?: 'participant_sensitive_fields', participant: { __typename?: 'participant', id: any, created_at: any, updated_at: any, date_of_birth?: any | null, date_of_birth_accuracy?: string | null, date_of_first_attendance?: any | null, preferred_contact_method?: string | null, sex?: string | null, country_code?: string | null, sensitive_fields?: { __typename?: 'participant_sensitive_fields', first_name: string, last_name: string, notes?: string | null, phone?: string | null, email?: string | null } | null, participant_languages: Array<{ __typename?: 'participant_language', language: { __typename?: 'language', code: string, name: string } }> } }> };

export type UpdateLocationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  location: Location_Set_Input;
  programme_locations: Array<Programme_Location_Insert_Input> | Programme_Location_Insert_Input;
}>;


export type UpdateLocationMutation = { __typename?: 'mutation_root', update_location?: { __typename?: 'location_mutation_response', returning: Array<{ __typename?: 'location', id: any }> } | null, delete_programme_location?: { __typename?: 'programme_location_mutation_response', returning: Array<{ __typename?: 'programme_location', programme_id: any, location_id: any }> } | null, insert_programme_location?: { __typename?: 'programme_location_mutation_response', returning: Array<{ __typename?: 'programme_location', programme_id: any, location_id: any }> } | null };

export type UpdateOrganisationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  organisation: Organisation_Set_Input;
}>;


export type UpdateOrganisationMutation = { __typename?: 'mutation_root', update_organisation?: { __typename?: 'organisation_mutation_response', returning: Array<{ __typename?: 'organisation', id: any }> } | null };

export type UpdateParticipantMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  participant: Participant_Set_Input;
  sensitive_fields?: InputMaybe<Participant_Sensitive_Fields_Set_Input>;
  participant_languages: Array<Participant_Language_Insert_Input> | Participant_Language_Insert_Input;
}>;


export type UpdateParticipantMutation = { __typename?: 'mutation_root', update_participant?: { __typename?: 'participant_mutation_response', returning: Array<{ __typename?: 'participant', id: any }> } | null, update_participant_sensitive_fields?: { __typename?: 'participant_sensitive_fields_mutation_response', returning: Array<{ __typename?: 'participant_sensitive_fields', participant_id: any }> } | null, delete_participant_language?: { __typename?: 'participant_language_mutation_response', returning: Array<{ __typename?: 'participant_language', language_code: string }> } | null, insert_participant_language?: { __typename?: 'participant_language_mutation_response', returning: Array<{ __typename?: 'participant_language', language_code: string }> } | null };

export type UpdateProgrammeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  programme: Programme_Set_Input;
  organisation_programmes: Array<Organisation_Programme_Insert_Input> | Organisation_Programme_Insert_Input;
}>;


export type UpdateProgrammeMutation = { __typename?: 'mutation_root', update_programme?: { __typename?: 'programme_mutation_response', returning: Array<{ __typename?: 'programme', id: any }> } | null, delete_organisation_programme?: { __typename?: 'organisation_programme_mutation_response', returning: Array<{ __typename?: 'organisation_programme', organisation_id: any }> } | null, insert_organisation_programme?: { __typename?: 'organisation_programme_mutation_response', returning: Array<{ __typename?: 'organisation_programme', organisation_id: any }> } | null };

export type UpdateProjectCategoryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  project_category: Project_Category_Set_Input;
}>;


export type UpdateProjectCategoryMutation = { __typename?: 'mutation_root', update_project_category_by_pk?: { __typename?: 'project_category', id: any, project_id: any, name: string } | null };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  project: Project_Set_Input;
}>;


export type UpdateProjectMutation = { __typename?: 'mutation_root', update_project?: { __typename?: 'project_mutation_response', returning: Array<{ __typename?: 'project', id: any }> } | null };

export type UpdateRegisterSensitiveFieldsMutationVariables = Exact<{
  register_id: Scalars['uuid']['input'];
  register_sensitive_fields: Register_Sensitive_Fields_Set_Input;
}>;


export type UpdateRegisterSensitiveFieldsMutation = { __typename?: 'mutation_root', update_register_sensitive_fields?: { __typename?: 'register_sensitive_fields_mutation_response', returning: Array<{ __typename?: 'register_sensitive_fields', register_id: any, notes?: string | null, created_at: any, updated_at: any }> } | null };

export type UpdateRegisterParticipantMutationVariables = Exact<{
  register_id: Scalars['uuid']['input'];
  participant_id: Scalars['uuid']['input'];
  sensitive_fields: Register_Participant_Sensitive_Fields_Set_Input;
}>;


export type UpdateRegisterParticipantMutation = { __typename?: 'mutation_root', update_register_participant_sensitive_fields?: { __typename?: 'register_participant_sensitive_fields_mutation_response', returning: Array<{ __typename?: 'register_participant_sensitive_fields', register_id: any, participant_id: any }> } | null };

export type UpdateRegisterMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  register: Register_Set_Input;
  facilitators_to_add: Array<Register_Facilitator_Insert_Input> | Register_Facilitator_Insert_Input;
  facilitator_ids_to_remove: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  register_project_categories: Array<Register_Project_Category_Insert_Input> | Register_Project_Category_Insert_Input;
}>;


export type UpdateRegisterMutation = { __typename?: 'mutation_root', update_register?: { __typename?: 'register_mutation_response', returning: Array<{ __typename?: 'register', id: any }> } | null, delete_register_project_category?: { __typename?: 'register_project_category_mutation_response', returning: Array<{ __typename?: 'register_project_category', project_category_id: any }> } | null, insert_register_project_category?: { __typename?: 'register_project_category_mutation_response', returning: Array<{ __typename?: 'register_project_category', project_category_id: any }> } | null, insert_register_facilitator?: { __typename?: 'register_facilitator_mutation_response', returning: Array<{ __typename?: 'register_facilitator', facilitator_id: any }> } | null, delete_register_facilitator?: { __typename?: 'register_facilitator_mutation_response', returning: Array<{ __typename?: 'register_facilitator', facilitator_id: any }> } | null };

export type UserLookupQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UserLookupQuery = { __typename?: 'query_root', user_by_pk?: { __typename?: 'user', id: any, first_name: string, last_name: string, email: string, role: string, deactivated_at?: any | null, organisation_users: Array<{ __typename?: 'organisation_user', organisation: { __typename?: 'organisation', id: any, slug: string, name: string } }>, organisation_siloed_users: Array<{ __typename?: 'organisation_siloed_user', user_id: any, organisation_id: any }> } | null };

export type CreateUserLoginCodeMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  login_code: Scalars['String']['input'];
  expires_at: Scalars['timestamptz']['input'];
}>;


export type CreateUserLoginCodeMutation = { __typename?: 'mutation_root', insert_user_login_code?: { __typename?: 'user_login_code_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'user_login_code', id: any, user_id: any, login_code: string, expires_at: any }> } | null };

export type UpdateUserLoginCodeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  attempt_count: Scalars['Int']['input'];
}>;


export type UpdateUserLoginCodeMutation = { __typename?: 'mutation_root', update_user_login_code?: { __typename?: 'user_login_code_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'user_login_code', id: any }> } | null };

export type GetUserLoginCodeByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserLoginCodeByIdQuery = { __typename?: 'query_root', user_login_code_by_pk?: { __typename?: 'user_login_code', id: any, user_id: any, login_code: string, attempt_count: number, created_at: any, expires_at: any } | null };

export type CreateUserWarningMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  message: Scalars['String']['input'];
  slug: Scalars['String']['input'];
}>;


export type CreateUserWarningMutation = { __typename?: 'mutation_root', insert_user_warning?: { __typename?: 'user_warning_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'user_warning', user_id: any, warning_id: any }> } | null };

export type DeleteUserWarningMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  slug: Scalars['String']['input'];
}>;


export type DeleteUserWarningMutation = { __typename?: 'mutation_root', delete_user_warning?: { __typename?: 'user_warning_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'user_warning', user_id: any, warning_id: any }> } | null };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;


export type CreateUserMutation = { __typename?: 'mutation_root', insert_user?: { __typename?: 'user_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'user', id: any }> } | null };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;


export type UpdateUserMutation = { __typename?: 'mutation_root', update_user?: { __typename?: 'user_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'user', id: any }> } | null };

export type UpdateUserWithPasswordMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;


export type UpdateUserWithPasswordMutation = { __typename?: 'mutation_root', update_user?: { __typename?: 'user_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'user', id: any }> } | null };

export type UpdateSelfMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
}>;


export type UpdateSelfMutation = { __typename?: 'mutation_root', update_user?: { __typename?: 'user_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'user', id: any }> } | null };

export type UpdateSelfWithPasswordMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type UpdateSelfWithPasswordMutation = { __typename?: 'mutation_root', update_user?: { __typename?: 'user_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'user', id: any }> } | null };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserByIdQuery = { __typename?: 'query_root', user_by_pk?: { __typename?: 'user', first_name: string, full_name?: string | null, deactivated_at?: any | null, last_name: string, id: any, email: string, role: string, organisation_users: Array<{ __typename?: 'organisation_user', organisation_id: any }>, organisation_managers: Array<{ __typename?: 'organisation_manager', organisation_id: any }>, organisation_siloed_users: Array<{ __typename?: 'organisation_siloed_user', organisation_id: any }> } | null };

export type GetUserWithPasswordByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetUserWithPasswordByEmailQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', first_name: string, full_name?: string | null, deactivated_at?: any | null, last_name: string, id: any, email: string, role: string, password: string, organisation_users: Array<{ __typename?: 'organisation_user', organisation_id: any }>, organisation_managers: Array<{ __typename?: 'organisation_manager', organisation_id: any }>, organisation_siloed_users: Array<{ __typename?: 'organisation_siloed_user', organisation_id: any }>, user_warnings: Array<{ __typename?: 'user_warning', warning: { __typename?: 'warning', slug: string } }> }> };


export const CreateLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"location_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"location"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateLocationMutation, CreateLocationMutationVariables>;
export const CreateOrganisationManagerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrganisationManager"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation_manager"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisation_manager_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_organisation_manager"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"organisation_manager"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOrganisationManagerMutation, CreateOrganisationManagerMutationVariables>;
export const CreateOrganisationProgrammeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrganisationProgramme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation_programme"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisation_programme_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_organisation_programme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"organisation_programme"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"programme_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOrganisationProgrammeMutation, CreateOrganisationProgrammeMutationVariables>;
export const CreateOrganisationSiloedUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrganisationSiloedUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation_siloed_user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisation_siloed_user_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_organisation_siloed_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"organisation_siloed_user"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOrganisationSiloedUserMutation, CreateOrganisationSiloedUserMutationVariables>;
export const CreateOrganisationUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrganisationUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation_user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisation_user_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_organisation_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"organisation_user"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOrganisationUserMutation, CreateOrganisationUserMutationVariables>;
export const CreateOrganisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrganisation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisation_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_organisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"organisation"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOrganisationMutation, CreateOrganisationMutationVariables>;
export const CreateParentChildDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateParentChild"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parent_child"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"parent_child_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_parent_child"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"parent_child"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent_id"}},{"kind":"Field","name":{"kind":"Name","value":"child_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateParentChildMutation, CreateParentChildMutationVariables>;
export const CreateParticipantFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateParticipantFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participant_file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"participant_files_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_participant_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"participant_file"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_size"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateParticipantFileMutation, CreateParticipantFileMutationVariables>;
export const CreateParticipantSiblingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateParticipantSibling"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participant_sibling"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"participant_sibling_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_participant_sibling"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"participant_sibling"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant_id"}},{"kind":"Field","name":{"kind":"Name","value":"sibling_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateParticipantSiblingMutation, CreateParticipantSiblingMutationVariables>;
export const CreateParticipantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateParticipant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"participant_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"participant"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateParticipantMutation, CreateParticipantMutationVariables>;
export const CreateProgrammeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProgramme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programme"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"programme_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_programme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"programme"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProgrammeMutation, CreateProgrammeMutationVariables>;
export const CreateProjectCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProjectCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_category"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"project_category_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_project_category"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"project_category"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProjectCategoryMutation, CreateProjectCategoryMutationVariables>;
export const CreateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"project_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"project"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProjectMutation, CreateProjectMutationVariables>;
export const CreateRegisterParticipantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRegisterParticipant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"register_participant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"register_participant_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_register_participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"register_participant"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register_id"}},{"kind":"Field","name":{"kind":"Name","value":"participant_id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateRegisterParticipantMutation, CreateRegisterParticipantMutationVariables>;
export const CreateRegisterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRegister"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"register"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"register_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_register"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"register"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateRegisterMutation, CreateRegisterMutationVariables>;
export const DangerousMergeParticipantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DangerousMergeParticipants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participant_id_to_delete"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participant_sibling_objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"participant_sibling_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participant_language_objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"participant_language_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parent_child_objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"parent_child_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation_participants_objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisation_participant_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programme_participants_objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"programme_participant_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"register_participant_objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"register_participant_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_participant_sibling"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant_sibling_objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"participant_sibling_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant_id"}},{"kind":"Field","name":{"kind":"Name","value":"sibling_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_participant_language"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant_language_objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"participant_language_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language_code"}},{"kind":"Field","name":{"kind":"Name","value":"participant_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_parent_child"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parent_child_objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"parent_child_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child_id"}},{"kind":"Field","name":{"kind":"Name","value":"parent_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_organisation_participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisation_participants_objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"organisation_participant_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"participant_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_programme_participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programme_participants_objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"programme_participant_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant_id"}},{"kind":"Field","name":{"kind":"Name","value":"programme_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_register_participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"register_participant_objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"register_participant_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_temp_is_child"}},{"kind":"Field","name":{"kind":"Name","value":"_temp_is_parent"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participant_id"}},{"kind":"Field","name":{"kind":"Name","value":"register_id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"delete_sibling_a"},"name":{"kind":"Name","value":"delete_participant_sibling"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sibling_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant_id_to_delete"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant_id"}},{"kind":"Field","name":{"kind":"Name","value":"sibling_id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"delete_sibling_b"},"name":{"kind":"Name","value":"delete_participant_sibling"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant_id_to_delete"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant_id"}},{"kind":"Field","name":{"kind":"Name","value":"sibling_id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"delete_parent"},"name":{"kind":"Name","value":"delete_parent_child"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant_id_to_delete"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child_id"}},{"kind":"Field","name":{"kind":"Name","value":"parent_id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"delete_child"},"name":{"kind":"Name","value":"delete_parent_child"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"child_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant_id_to_delete"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child_id"}},{"kind":"Field","name":{"kind":"Name","value":"parent_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_participant_language"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant_id_to_delete"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_organisation_participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant_id_to_delete"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_programme_participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant_id_to_delete"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programme_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_register_participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant_id_to_delete"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant_id_to_delete"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DangerousMergeParticipantsMutation, DangerousMergeParticipantsMutationVariables>;
export const DeactivateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeactivateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated_at"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeactivateUserMutation, DeactivateUserMutationVariables>;
export const DeleteOrganisationManagerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOrganisationManager"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_organisation_manager"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteOrganisationManagerMutation, DeleteOrganisationManagerMutationVariables>;
export const DeleteOrganisationSiloedUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOrganisationSiloedUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_organisation_siloed_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteOrganisationSiloedUserMutation, DeleteOrganisationSiloedUserMutationVariables>;
export const DeleteOrganisationUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOrganisationUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_organisation_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteOrganisationUserMutation, DeleteOrganisationUserMutationVariables>;
export const DeleteOrganisationProgrammeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOrganisationProgramme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programme_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_organisation_programme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"programme_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programme_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programme_id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteOrganisationProgrammeMutation, DeleteOrganisationProgrammeMutationVariables>;
export const DeleteParentChildDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteParentChild"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parent_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"child_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_parent_child"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"child_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"child_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"parent_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parent_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child_id"}},{"kind":"Field","name":{"kind":"Name","value":"parent_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteParentChildMutation, DeleteParentChildMutationVariables>;
export const DeleteParticipantFileByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteParticipantFileById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_participant_files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteParticipantFileByIdMutation, DeleteParticipantFileByIdMutationVariables>;
export const DeleteParticipantSiblingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteParticipantSibling"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participant_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sibling_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_participant_sibling"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sibling_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sibling_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"participant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sibling_id"}},{"kind":"Field","name":{"kind":"Name","value":"participant_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteParticipantSiblingMutation, DeleteParticipantSiblingMutationVariables>;
export const DeleteProjectCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProjectCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_project_category_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DeleteProjectCategoryMutation, DeleteProjectCategoryMutationVariables>;
export const DeleteRegisterParticipantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteRegisterParticipant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"register_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participant_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_register_participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"register_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"register_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant_id"}},{"kind":"Field","name":{"kind":"Name","value":"register_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteRegisterParticipantMutation, DeleteRegisterParticipantMutationVariables>;
export const DeleteRegisterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteRegister"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_register"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted_at"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteRegisterMutation, DeleteRegisterMutationVariables>;
export const FetchLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationSlug"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"programme_locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchLocationQuery, FetchLocationQueryVariables>;
export const FetchLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"location_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dynamicOrderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"location_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicOrderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"programme_locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<FetchLocationsQuery, FetchLocationsQueryVariables>;
export const FetchOrganisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchOrganisation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationSlug"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation_managers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation_programmes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchOrganisationQuery, FetchOrganisationQueryVariables>;
export const FetchOrganisationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchOrganisations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"organisation_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_managers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation_programmes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchOrganisationsQuery, FetchOrganisationsQueryVariables>;
export const FetchParticipantByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchParticipantById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"emergency_contact_name"}},{"kind":"Field","name":{"kind":"Name","value":"emergency_contact_detail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_birth"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_birth_accuracy"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_first_attendance"}},{"kind":"Field","name":{"kind":"Name","value":"preferred_contact_method"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_refugee"}},{"kind":"Field","name":{"kind":"Name","value":"is_caregiver"}},{"kind":"Field","name":{"kind":"Name","value":"has_disability"}},{"kind":"Field","name":{"kind":"Name","value":"data_protection_signed"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"_temp_parent_names"}},{"kind":"Field","name":{"kind":"Name","value":"_temp_child_names"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"siblings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sibling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"participant_languages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"register_participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_temp_is_child"}},{"kind":"Field","name":{"kind":"Name","value":"_temp_is_parent"}},{"kind":"Field","name":{"kind":"Name","value":"register"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation_participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"participant_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programme_participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programme_id"}},{"kind":"Field","name":{"kind":"Name","value":"participant_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participant_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_size"}},{"kind":"Field","name":{"kind":"Name","value":"purpose"}}]}},{"kind":"Field","name":{"kind":"Name","value":"referral_organisation"}}]}}]}}]} as unknown as DocumentNode<FetchParticipantByIdQuery, FetchParticipantByIdQueryVariables>;
export const FetchParticipantFileByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchParticipantFileById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant_files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_size"}},{"kind":"Field","name":{"kind":"Name","value":"file_base64"}}]}}]}}]} as unknown as DocumentNode<FetchParticipantFileByIdQuery, FetchParticipantFileByIdQueryVariables>;
export const FetchParticipantLatestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchParticipantLatest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"register_participant_latest_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register_participant_latest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"participant_id"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date_of_birth"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_birth_accuracy"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]}}]} as unknown as DocumentNode<FetchParticipantLatestQuery, FetchParticipantLatestQueryVariables>;
export const FetchParticipantsByEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchParticipantsByEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sensitive_fields"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]} as unknown as DocumentNode<FetchParticipantsByEmailQuery, FetchParticipantsByEmailQueryVariables>;
export const FetchParticipantsByPhoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchParticipantsByPhone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sensitive_fields"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]} as unknown as DocumentNode<FetchParticipantsByPhoneQuery, FetchParticipantsByPhoneQueryVariables>;
export const FetchProgrammeGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchProgrammeGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"programme_group_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programme_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"programmes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<FetchProgrammeGroupsQuery, FetchProgrammeGroupsQueryVariables>;
export const FetchProgrammeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchProgramme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programmeSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programmeSlug"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_programmes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programme_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<FetchProgrammeQuery, FetchProgrammeQueryVariables>;
export const FetchProgrammesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchProgrammes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"programme_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"programme_locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"programme_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<FetchProgrammesQuery, FetchProgrammesQueryVariables>;
export const FetchProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectSlug"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"programme_id"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}}]}}]} as unknown as DocumentNode<FetchProjectQuery, FetchProjectQueryVariables>;
export const FetchProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchProjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"project_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dynamicOrderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"project_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicOrderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"programme_id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<FetchProjectsQuery, FetchProjectsQueryVariables>;
export const FetchRegisterAttendeesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchRegisterAttendees"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"registerIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register_participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"register"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"registerIds"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register_id"}},{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"_temp_id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchRegisterAttendeesQuery, FetchRegisterAttendeesQueryVariables>;
export const FetchRegisterParticipantNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchRegisterParticipantNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register_participant_sensitive_fields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"notes"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"_nlike"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"register"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"time"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"register"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"register_facilitators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchRegisterParticipantNotesQuery, FetchRegisterParticipantNotesQueryVariables>;
export const FetchRegisterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchRegister"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"registerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"registerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"override_total_participants"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_orgs_in_attendance"}},{"kind":"Field","name":{"kind":"Name","value":"register_participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sensitive_fields"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"last_name"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"first_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_temp_is_child"}},{"kind":"Field","name":{"kind":"Name","value":"_temp_is_parent"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_birth"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"register_facilitators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"register_project_categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user_id"}}]}}]}}]} as unknown as DocumentNode<FetchRegisterQuery, FetchRegisterQueryVariables>;
export const FetchRegistersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchRegisters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"register_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dynamicOrderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"register_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicOrderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"register_project_categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"register_facilitators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"override_total_participants"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_orgs_in_attendance"}},{"kind":"Field","name":{"kind":"Name","value":"register_participants_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"columns"},"value":{"kind":"EnumValue","value":"participant_id"}}]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"register_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<FetchRegistersQuery, FetchRegistersQueryVariables>;
export const FetchUserWarningsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchUserWarnings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_warning"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]} as unknown as DocumentNode<FetchUserWarningsQuery, FetchUserWarningsQueryVariables>;
export const FetchUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"user_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dynamicOrderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicOrderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchUsersQuery, FetchUsersQueryVariables>;
export const RegisterAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RegisterAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"register_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distinctOn"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"register_select_column"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distinctOn"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<RegisterAggregateQuery, RegisterAggregateQueryVariables>;
export const RegisterParticipantAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RegisterParticipantAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"register_participant_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distinctOn"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"register_participant_select_column"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register_participant_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distinctOn"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant_id"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"computed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant_age"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"register_participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distinctOn"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant_id"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"computed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant_age"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"override_total_participants"}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_birth"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}}]}}]}}]}}]} as unknown as DocumentNode<RegisterParticipantAggregateQuery, RegisterParticipantAggregateQueryVariables>;
export const RestoreRegisterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RestoreRegister"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_register"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted_at"},"value":{"kind":"NullValue"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<RestoreRegisterMutation, RestoreRegisterMutationVariables>;
export const SearchParticipantsByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchParticipantsByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dynamicFilters"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"participant_sensitive_fields_bool_exp"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dynamicOrderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"participant_sensitive_fields_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"participant_search_by_name"},"name":{"kind":"Name","value":"participant_search_by_name_sensitive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeIds"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicFilters"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dynamicOrderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_birth"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_birth_accuracy"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_first_attendance"}},{"kind":"Field","name":{"kind":"Name","value":"preferred_contact_method"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive_fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participant_languages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchParticipantsByNameQuery, SearchParticipantsByNameQueryVariables>;
export const UpdateLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"location_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programme_locations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"programme_location_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_programme_location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"location_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programme_id"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_programme_location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programme_locations"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"programme_centre_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programme_id"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const UpdateOrganisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganisation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisation_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_organisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisation"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>;
export const UpdateParticipantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateParticipant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"participant_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sensitive_fields"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"participant_sensitive_fields_set_input"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participant_languages"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"participant_language_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_participant_sensitive_fields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sensitive_fields"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_participant_language"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_participant_language"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant_languages"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"participant_language_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language_code"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateParticipantMutation, UpdateParticipantMutationVariables>;
export const UpdateProgrammeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programme"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"programme_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation_programmes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisation_programme_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_programme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programme"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_organisation_programme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"programme_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_organisation_programme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisation_programmes"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"organisation_programme_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgrammeMutation, UpdateProgrammeMutationVariables>;
export const UpdateProjectCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_category"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"project_category_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_project_category_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_category"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateProjectCategoryMutation, UpdateProjectCategoryMutationVariables>;
export const UpdateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"project_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdateRegisterSensitiveFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRegisterSensitiveFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"register_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"register_sensitive_fields"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"register_sensitive_fields_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_register_sensitive_fields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"register_sensitive_fields"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"register_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"register_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register_id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRegisterSensitiveFieldsMutation, UpdateRegisterSensitiveFieldsMutationVariables>;
export const UpdateRegisterParticipantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRegisterParticipant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"register_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participant_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sensitive_fields"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"register_participant_sensitive_fields_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_register_participant_sensitive_fields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sensitive_fields"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"register_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"register_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"participant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register_id"}},{"kind":"Field","name":{"kind":"Name","value":"participant_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRegisterParticipantMutation, UpdateRegisterParticipantMutationVariables>;
export const UpdateRegisterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRegister"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"register"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"register_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilitators_to_add"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"register_facilitator_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilitator_ids_to_remove"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"register_project_categories"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"register_project_category_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_register"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"register"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_register_project_category"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"register_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_register_project_category"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"register_project_categories"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"register_project_category_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_register_facilitator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilitators_to_add"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"register_facilitator_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facilitator_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_register_facilitator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"register_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"facilitator_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilitator_ids_to_remove"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facilitator_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRegisterMutation, UpdateRegisterMutationVariables>;
export const UserLookupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserLookup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"deactivated_at"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation_siloed_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}}]}}]}}]} as unknown as DocumentNode<UserLookupQuery, UserLookupQueryVariables>;
export const CreateUserLoginCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUserLoginCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"login_code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expires_at"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_login_code"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"login_code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"login_code"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"expires_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expires_at"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"login_code"}},{"kind":"Field","name":{"kind":"Name","value":"expires_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<CreateUserLoginCodeMutation, CreateUserLoginCodeMutationVariables>;
export const UpdateUserLoginCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserLoginCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attempt_count"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_login_code"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attempt_count"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attempt_count"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateUserLoginCodeMutation, UpdateUserLoginCodeMutationVariables>;
export const GetUserLoginCodeByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserLoginCodeById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_login_code_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"login_code"}},{"kind":"Field","name":{"kind":"Name","value":"attempt_count"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"expires_at"}}]}}]}}]} as unknown as DocumentNode<GetUserLoginCodeByIdQuery, GetUserLoginCodeByIdQueryVariables>;
export const CreateUserWarningDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUserWarning"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_warning"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"warning"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"warning_slug_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"EnumValue","value":"updated_at"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"warning_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<CreateUserWarningMutation, CreateUserWarningMutationVariables>;
export const DeleteUserWarningDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUserWarning"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user_warning"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"warning"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"warning_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteUserWarningMutation, DeleteUserWarningMutationVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"first_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first_name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"last_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last_name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"first_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first_name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"last_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last_name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserWithPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserWithPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"first_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first_name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"last_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last_name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateUserWithPasswordMutation, UpdateUserWithPasswordMutationVariables>;
export const UpdateSelfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSelf"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"first_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first_name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"last_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last_name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateSelfMutation, UpdateSelfMutationVariables>;
export const UpdateSelfWithPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSelfWithPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"first_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first_name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"last_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last_name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateSelfWithPasswordMutation, UpdateSelfWithPasswordMutationVariables>;
export const GetUserByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"deactivated_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation_managers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation_siloed_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const GetUserWithPasswordByEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserWithPasswordByEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"deactivated_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation_managers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation_siloed_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_warnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserWithPasswordByEmailQuery, GetUserWithPasswordByEmailQueryVariables>;